/**
 * Author -> Nopsbit 
 * Email -> hello@nopsbit.com
 * Version -> 1.3.2 
 */window.dialogSoldOutBtn = "Loppuunmyyty";
window.dialogSoldOutBtnWithIcon = window.buttonCartIcons+"Loppuunmyyty";
window.dialogBuyNowBtn = window.buttonBuytIcons+"Osta nyt";  
window.addToCartBtn = window.buttonCartIcons+"Lisää ostoskoriin";

/****************************** MANAGE QUICK VIEW POPUP BLOCK START HERE ***********************************/

/* ======= EVERGREEN TIME COUNTDOWN BLOCK START HERE ======= */
window.prevCircleNowPlaying_EVERGREEN_countdown = '' ;
var fireAnyUpdate = function fireAnyUpdate(){}
function clean_data(data){data = $.trim(data);return data;}
function run_simple_EVERGREEN_timer(countdowntime,other_data){ $(".quick-view--timer-block #real-simple-countdown-for-quickviewpopup").countdown(countdowntime, function(event) {$(this).html(event.strftime('<div class="timer--running days--cont-runn"><span class="digits">%D</span> <span class="time--indicator">D</span></div>'+ '<div class="timer--running hours--cont-runn"><span class="digits">%H</span> <span class="time--indicator">H</span></div>'+ '<div class="timer--running mins--cont-runn"><span class="digits">%M</span> <span class="time--indicator">M</span></div>'+ '<div class="timer--running secs--cont-runn"><span class="digits">%S</span> <span class="time--indicator">S</span></div>'));});}
function run_recnewstyle_EVERGREEN_timer(countdowntime,other_data){ $("#countdown-newstyle--realtime-for-quickviewpopup").countdown(countdowntime, function(event) { $(this).html( event.strftime('<div class="new_style timer--running days--cont-runn"><span class="digits">%D</span> <span class="time--indicator">Day</span></div>'+ '<div class="new_style timer--running hours--cont-runn"><span class="digits">%H</span> <span class="time--indicator">Hour</span></div>'+ '<div class="new_style timer--running mins--cont-runn"><span class="digits">%M</span> <span class="time--indicator">Min</span></div>'+ '<div class="new_style timer--running secs--cont-runn"><span class="digits">%S</span> <span class="time--indicator">Sec</span></div>'));});}
function run_slidedown_EVERGREEN_timer(countDownTimeForSlideDown,other_data){$('#real-slidedown-countdown-for-quickviewpopup').countDown({targetDate: {'day'  : countDownTimeForSlideDown.day,'month': countDownTimeForSlideDown.month,'year' : countDownTimeForSlideDown.year,'hour' : countDownTimeForSlideDown.hour,'min'  : countDownTimeForSlideDown.min,'sec'  : countDownTimeForSlideDown.sec}});}

/************** RUN CIRCLE COUNT DOWN CODE START HERE *********************/  
const c_ROF_EVERGREEN = {context: {},values: {},times: {}};
function deg_EVERGREEN(d) {return (Math.PI/180)*d-(Math.PI/180)*90;}
function render_ROF_EVERGREEN() {
  c_ROF_EVERGREEN.context.seconds.clearRect(0, 0, 50, 50); c_ROF_EVERGREEN.context.seconds.beginPath(); c_ROF_EVERGREEN.context.seconds.strokeStyle = "#3A55FF";
  c_ROF_EVERGREEN.context.seconds.arc(25, 25, 22, deg_EVERGREEN(0), deg_EVERGREEN(6 * (60 - c_ROF_EVERGREEN.times.seconds))); c_ROF_EVERGREEN.context.seconds.lineWidth = 5; c_ROF_EVERGREEN.context.seconds.lineCap = "round"; c_ROF_EVERGREEN.context.seconds.stroke(); c_ROF_EVERGREEN.context.minutes.clearRect(0, 0, 50, 50); c_ROF_EVERGREEN.context.minutes.beginPath(); c_ROF_EVERGREEN.context.minutes.strokeStyle = "#E834B1";
  c_ROF_EVERGREEN.context.minutes.arc(25, 25, 22, deg_EVERGREEN(0), deg_EVERGREEN(6 * (60 - c_ROF_EVERGREEN.times.minutes))); c_ROF_EVERGREEN.context.minutes.lineWidth = 5; c_ROF_EVERGREEN.context.minutes.lineCap = "round"; c_ROF_EVERGREEN.context.minutes.stroke(); c_ROF_EVERGREEN.context.hours.clearRect(0, 0, 50, 50); c_ROF_EVERGREEN.context.hours.beginPath(); c_ROF_EVERGREEN.context.hours.strokeStyle = "#FFA246";
  c_ROF_EVERGREEN.context.hours.arc(25, 25, 22, deg_EVERGREEN(0), deg_EVERGREEN(15 * (24 - c_ROF_EVERGREEN.times.hours))); c_ROF_EVERGREEN.context.hours.lineWidth = 5; c_ROF_EVERGREEN.context.hours.lineCap = "round"; c_ROF_EVERGREEN.context.hours.stroke(); c_ROF_EVERGREEN.context.days.clearRect(0, 0, 50, 50); c_ROF_EVERGREEN.context.days.beginPath(); c_ROF_EVERGREEN.context.days.strokeStyle = "#47FFAF";
  c_ROF_EVERGREEN.context.days.arc(25, 25, 22, deg_EVERGREEN(0), deg_EVERGREEN(365 - c_ROF_EVERGREEN.times.days)); c_ROF_EVERGREEN.context.days.lineWidth = 5; c_ROF_EVERGREEN.context.days.lineCap = "round"; c_ROF_EVERGREEN.context.days.stroke(); 
}
function init_ROF__EVERGREEN(countdowntime,other_data) { 
  c_ROF_EVERGREEN.context.seconds = document.getElementById('seconds-canvas-real-circle-countdown-for-quickviewpopup').getContext('2d'); c_ROF_EVERGREEN.context.minutes = document.getElementById('minutes-canvas-real-circle-countdown-for-quickviewpopup').getContext('2d'); c_ROF_EVERGREEN.context.hours = document.getElementById('hours-canvas-real-circle-countdown-for-quickviewpopup').getContext('2d'); c_ROF_EVERGREEN.context.days = document.getElementById('days-canvas-real-circle-countdown-for-quickviewpopup').getContext('2d');
  c_ROF_EVERGREEN.values.seconds = document.getElementById('seconds-value-real-circle-countdown-for-quickviewpopup'); c_ROF_EVERGREEN.values.minutes = document.getElementById('minutes-value-real-circle-countdown-for-quickviewpopup'); c_ROF_EVERGREEN.values.hours = document.getElementById('hours-value-real-circle-countdown-for-quickviewpopup'); c_ROF_EVERGREEN.values.days = document.getElementById('days-value-real-circle-countdown-for-quickviewpopup');
  window.prevCircleNowPlaying_EVERGREEN_countdown = setInterval(function() { const now = new Date().getTime(); const launchDate = new Date(countdowntime).getTime(); const distance = launchDate - now; if(distance >= 0){ c_ROF_EVERGREEN.times.days = Math.floor(distance / (1000 * 60 * 60 * 24)); c_ROF_EVERGREEN.times.hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)); c_ROF_EVERGREEN.times.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)); c_ROF_EVERGREEN.times.seconds = Math.floor((distance % (1000 * 60)) / 1000);} else{c_ROF_EVERGREEN.times.days = 0; c_ROF_EVERGREEN.times.hours = 0; c_ROF_EVERGREEN.times.minutes = 0; c_ROF_EVERGREEN.times.seconds = 0;} c_ROF_EVERGREEN.values.days.innerText    = c_ROF_EVERGREEN.times.days; c_ROF_EVERGREEN.values.hours.innerText   = c_ROF_EVERGREEN.times.hours; c_ROF_EVERGREEN.values.minutes.innerText = c_ROF_EVERGREEN.times.minutes; c_ROF_EVERGREEN.values.seconds.innerText = c_ROF_EVERGREEN.times.seconds;render_ROF_EVERGREEN();}, 1000); 
}
function init_circle__EVERGREEN_timer(countdowntime,other_data){ init_ROF__EVERGREEN(countdowntime,other_data);}
/************** RUN CIRCLE COUNT DOWN CODE END HERE *********************/
/* ======= EVERGREEN TIME COUNTDOWN BLOCK END HERE ======= */

/* ========== REAL TIME COUNTDOWN  REAL TIME COUNTDOWN BLOCK START HERE ========== */

window.prevCircleNowPlaying_real_countdown = '';
function run_simple_timer(countdowntime,other_data){$(".quick-view--timer-block #real-simple-countdown-for-quickviewpopup").countdown(countdowntime, function(event) { $(this).html(event.strftime('<div class="timer--running days--cont-runn"><span class="digits">%D</span> <span class="time--indicator">D:</span></div>'+ '<div class="timer--running hours--cont-runn"><span class="digits">%H</span> <span class="time--indicator">H:</span></div>'+ '<div class="timer--running mins--cont-runn"><span class="digits">%M</span> <span class="time--indicator">M:</span></div>'+ '<div class="timer--running secs--cont-runn"><span class="digits">%S</span> <span class="time--indicator">S</span></div>'));}); }
function run_recnewstyle_slider(countdowntime,other_data){$("#countdown-newstyle--realtime-for-quickviewpopup").countdown(countdowntime, function(event) {$(this).html(event.strftime('<div class="new_style timer--running days--cont-runn"><span class="digits">%D</span> <span class="time--indicator">Day</span></div>'+ '<div class="new_style timer--running hours--cont-runn"><span class="digits">%H</span> <span class="time--indicator">Hour</span></div>'+ '<div class="new_style timer--running mins--cont-runn"><span class="digits">%M</span> <span class="time--indicator">Min</span></div>'+ '<div class="new_style timer--running secs--cont-runn"><span class="digits">%S</span> <span class="time--indicator">Sec</span></div>'));});} 
function run_slidedown_slider(countDownTimeForSlideDown,other_data){$('#real-slidedown-countdown-for-quickviewpopup').countDown({ targetDate: {'day'  : countDownTimeForSlideDown.day,'month': countDownTimeForSlideDown.month,'year' : countDownTimeForSlideDown.year,'hour' : countDownTimeForSlideDown.hour,'min'  : countDownTimeForSlideDown.min,'sec'  : countDownTimeForSlideDown.sec}});}

/************** RUN CIRCLE COUNT DOWN CODE START HERE *********************/
const c_real_countdowntimer = {context: {},values: {},times: {}};
function deg(d) {return (Math.PI/180)*d-(Math.PI/180)*90;}
function render_real_countdowntimer() {
  c_real_countdowntimer.context.seconds.clearRect(0, 0, 50, 50); c_real_countdowntimer.context.seconds.beginPath(); c_real_countdowntimer.context.seconds.strokeStyle = "#3A55FF";
  c_real_countdowntimer.context.seconds.arc(25, 25, 22, deg(0), deg(6 * (60 - c_real_countdowntimer.times.seconds))); c_real_countdowntimer.context.seconds.lineWidth = 5; c_real_countdowntimer.context.seconds.lineCap = "round"; c_real_countdowntimer.context.seconds.stroke();c_real_countdowntimer.context.minutes.clearRect(0, 0, 50, 50); c_real_countdowntimer.context.minutes.beginPath(); c_real_countdowntimer.context.minutes.strokeStyle = "#E834B1";
  c_real_countdowntimer.context.minutes.arc(25, 25, 22, deg(0), deg(6 * (60 - c_real_countdowntimer.times.minutes))); c_real_countdowntimer.context.minutes.lineWidth = 5; c_real_countdowntimer.context.minutes.lineCap = "round"; c_real_countdowntimer.context.minutes.stroke(); c_real_countdowntimer.context.hours.clearRect(0, 0, 50, 50); c_real_countdowntimer.context.hours.beginPath(); c_real_countdowntimer.context.hours.strokeStyle = "#FFA246";
  c_real_countdowntimer.context.hours.arc(25, 25, 22, deg(0), deg(15 * (24 - c_real_countdowntimer.times.hours))); c_real_countdowntimer.context.hours.lineWidth = 5; c_real_countdowntimer.context.hours.lineCap = "round"; c_real_countdowntimer.context.hours.stroke(); c_real_countdowntimer.context.days.clearRect(0, 0, 50, 50); c_real_countdowntimer.context.days.beginPath(); c_real_countdowntimer.context.days.strokeStyle = "#47FFAF";
  c_real_countdowntimer.context.days.arc(25, 25, 22, deg(0), deg(365 - c_real_countdowntimer.times.days)); c_real_countdowntimer.context.days.lineWidth = 5; c_real_countdowntimer.context.days.lineCap = "round"; c_real_countdowntimer.context.days.stroke();
}
function init_real_countdowntimer(countdowntime,other_data) {
  c_real_countdowntimer.context.seconds = document.getElementById('seconds-canvas-real-circle-countdown-for-quickviewpopup').getContext('2d'); c_real_countdowntimer.context.minutes = document.getElementById('minutes-canvas-real-circle-countdown-for-quickviewpopup').getContext('2d'); c_real_countdowntimer.context.hours = document.getElementById('hours-canvas-real-circle-countdown-for-quickviewpopup').getContext('2d'); c_real_countdowntimer.context.days = document.getElementById('days-canvas-real-circle-countdown-for-quickviewpopup').getContext('2d'); c_real_countdowntimer.values.seconds = document.getElementById('seconds-value-real-circle-countdown-for-quickviewpopup'); c_real_countdowntimer.values.minutes = document.getElementById('minutes-value-real-circle-countdown-for-quickviewpopup'); c_real_countdowntimer.values.hours = document.getElementById('hours-value-real-circle-countdown-for-quickviewpopup'); c_real_countdowntimer.values.days = document.getElementById('days-value-real-circle-countdown-for-quickviewpopup');
  window.prevCircleNowPlaying_real_countdown = setInterval(function() {
    const now = new Date().getTime(); const launchDate = new Date(countdowntime).getTime(); 
    const distance = launchDate - now; c_real_countdowntimer.times.days = Math.floor(distance / (1000 * 60 * 60 * 24));
    c_real_countdowntimer.times.hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    c_real_countdowntimer.times.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    c_real_countdowntimer.times.seconds = Math.floor((distance % (1000 * 60)) / 1000);

    if(c_real_countdowntimer.times.days < 0){ c_real_countdowntimer.times.days = 0; }
    if(c_real_countdowntimer.times.hours < 0){ c_real_countdowntimer.times.hours = 0; }
    if(c_real_countdowntimer.times.minutes < 0){ c_real_countdowntimer.times.minutes = 0; }
    if(c_real_countdowntimer.times.seconds < 0){ c_real_countdowntimer.times.seconds = 0; }

    c_real_countdowntimer.values.days.innerText    = c_real_countdowntimer.times.days;
    c_real_countdowntimer.values.hours.innerText   = c_real_countdowntimer.times.hours;
    c_real_countdowntimer.values.minutes.innerText = c_real_countdowntimer.times.minutes;
    c_real_countdowntimer.values.seconds.innerText = c_real_countdowntimer.times.seconds;
    render_real_countdowntimer(); // Draw!
  }, 1000);
}
function run_circle_countdown(countdowntime,other_data){init_real_countdowntimer(countdowntime,other_data);}
/************** RUN CIRCLE COUNT DOWN CODE END HERE *********************/

/* ==============================  REAL TIME COUNTDOWN  REAL TIME COUNTDOWN BLOCK END HERE ============================== */


function run__countdown(thisData){
  var circle_Timer_html = '<div class="circle-countdown countdown" style=" justify-content: center;" ><div class="countdown-box days"> <canvas id="days-canvas-real-circle-countdown-for-quickviewpopup" width="50" height="50"></canvas> <svg width="50" height="50"> <circle id="outer" cx="25" cy="25" r="22" fill="transparent" stroke-width="5" stroke="#47FFAF" opacity="0.1"/> </svg><div class="label"> <span id="days-value-real-circle-countdown-for-quickviewpopup"></span> <span>Days</span></div></div><div class="countdown-box hours"> <canvas id="hours-canvas-real-circle-countdown-for-quickviewpopup" width="50" height="50"></canvas> <svg width="50" height="50"> <circle id="outer" cx="25" cy="25" r="22" fill="transparent" stroke-width="5" stroke="#FFA246" opacity="0.1"/> </svg><div class="label"> <span id="hours-value-real-circle-countdown-for-quickviewpopup"></span> <span>Hr</span></div></div><div class="countdown-box minutes"> <canvas id="minutes-canvas-real-circle-countdown-for-quickviewpopup" width="50" height="50"></canvas> <svg width="50" height="50"> <circle id="outer" cx="25" cy="25" r="22" fill="transparent" stroke-width="5" stroke="#E834B1" opacity="0.1"/> </svg><div class="label"> <span id="minutes-value-real-circle-countdown-for-quickviewpopup"></span> <span>Min</span></div></div><div class="countdown-box seconds"> <canvas id="seconds-canvas-real-circle-countdown-for-quickviewpopup" width="50" height="50"></canvas> <svg width="50" height="50"> <circle id="outer" cx="25" cy="25" r="22" fill="transparent" stroke-width="5" stroke="#3A55FF" opacity="0.1"/> </svg><div class="label"> <span id="seconds-value-real-circle-countdown-for-quickviewpopup"></span> <span>Sec</span></div></div></div>';
  var currentProRoot = thisData.parents('.product--snippet'); 
  var action_countdown_status = thisData.parents('.product--snippet').find('.countdown--control--data').attr('active-countdown-status');
  var active_time_status_id = parseInt( thisData.parents('.product--snippet').find('.countdown--control--data').attr('active-time-status-id') );
  var product__id = currentProRoot.find('.countdown--control--data').attr('active-product-id');
  var EVERGREEN_FinishCalculatedDate = currentProRoot.find('.countdown--control--data').attr('active-runOnFinishCalculatedDate');
  $('.quick-view--timer-block #countdown-newstyle--realtime-for-quickviewpopup').html('');
  $('#etp-quick-view-dialog .quick-view--timer-block #real-slidedown-countdown-for-quickviewpopup--worked').html('');
  $('.quick-view--timer-block #real-simple-countdown-for-quickviewpopup').html('');
  if( action_countdown_status == 'REALTIME' ){
    var curr_datetime = thisData.parents('.product--snippet').find('.countdown--control--data').attr('active-realtimer-datetime');
  }
  else if( action_countdown_status == 'EVERGREEN' ){
    var curr_datetime = thisData.parents('.product--snippet').find('.countdown--control--data').attr('active-evergreentimer-datetime');
  }
  else{var curr_datetime = '';}
  curr_datetime = $.trim(curr_datetime);
  if(curr_datetime != '' && action_countdown_status == 'REALTIME') {
    var splitDate_QUICKVIEW = split_the_date(curr_datetime);
    var date_for_circle_countdown_QUICKVIEW = month[splitDate_QUICKVIEW.month-1]+' '+splitDate_QUICKVIEW.date+', '+splitDate_QUICKVIEW.year+' '+splitDate_QUICKVIEW.hrs+':'+splitDate_QUICKVIEW.mins+':'+splitDate_QUICKVIEW.secs;
    var day_QUICKVIEW     = splitDate_QUICKVIEW.date; var month_QUICKVIEW   = splitDate_QUICKVIEW.month;
    var year_QUICKVIEW    = splitDate_QUICKVIEW.year; var hour_QUICKVIEW    = splitDate_QUICKVIEW.hrs;
    var minuts_QUICKVIEW  = splitDate_QUICKVIEW.mins; var sec_QUICKVIEW     = splitDate_QUICKVIEW.secs;
    var countDownTimeForSlideDown = { day:day_QUICKVIEW,month:month_QUICKVIEW,year:year_QUICKVIEW,hour:hour_QUICKVIEW,min:minuts_QUICKVIEW,sec:sec_QUICKVIEW }; var countdowntime = year_QUICKVIEW+'/'+month_QUICKVIEW+'/'+day_QUICKVIEW+' '+hour_QUICKVIEW+':'+minuts_QUICKVIEW+':'+sec_QUICKVIEW;} 
  if( action_countdown_status == 'REALTIME' && curr_datetime != '' ){
    if( active_time_status_id == 1 ){
      var other_data = '';
      var fresh_sliderdown_html = $('#etp-quick-view-dialog .quick-view--timer-block #real-slidedown-countdown-for-quickviewpopup--backup--org').html();
      setTimeout(function(){
        $('#etp-quick-view-dialog .quick-view--timer-block #real-slidedown-countdown-for-quickviewpopup--worked').html(fresh_sliderdown_html);
        $('#etp-quick-view-dialog .quick-view--timer-block #real-slidedown-countdown-for-quickviewpopup--worked ul').attr('id','real-slidedown-countdown-for-quickviewpopup');
        run_slidedown_slider(countDownTimeForSlideDown,other_data);
      },1000);
    }
    else if( active_time_status_id == 2 ){
      var other_data = '' ; run_simple_timer(countdowntime,other_data);
    }else if( active_time_status_id == 3 ){
      clearInterval(window.prevCircleNowPlaying_real_countdown); 
      var other_data = '' ; $('.quick-view--timer-block #circle-countdown--block').html('');
      setTimeout(function(){
        $('.quick-view--timer-block #circle-countdown--block').html(circle_Timer_html);
        run_circle_countdown(date_for_circle_countdown_QUICKVIEW,other_data);
      },1000);
    }else if( active_time_status_id == 4 ){
      var other_data = '' ; run_recnewstyle_slider(countdowntime,other_data);
    }else {}
  } 
  if( action_countdown_status == 'EVERGREEN' && curr_datetime != '' ){
    var countdown_mintues = curr_datetime; var minutes_EVERGREEN = countdown_mintues;
    var getLastdate_EVERGREEN = ''; getLastdate_EVERGREEN = localStorage.getItem(EVERGREEN_FinishCalculatedDate);
    getLastdate_EVERGREEN = getFutureLastdate( getLastdate_EVERGREEN,product__id,minutes_EVERGREEN);
    var splitDate_EVERGREEN = split_the_date(getLastdate_EVERGREEN); var day_QUICKVIEW     = splitDate_EVERGREEN.date;
    var month_QUICKVIEW   = splitDate_EVERGREEN.month; var year_QUICKVIEW    = splitDate_EVERGREEN.year;
    var hour_QUICKVIEW    = splitDate_EVERGREEN.hrs; var minuts_QUICKVIEW  = splitDate_EVERGREEN.mins;
    var sec_QUICKVIEW     = splitDate_EVERGREEN.secs;
    var countDownTimeForSlideDown = { day:day_QUICKVIEW,month:month_QUICKVIEW,year:year_QUICKVIEW,hour:hour_QUICKVIEW,min:minuts_QUICKVIEW,sec:sec_QUICKVIEW };
    var date_for_circle_countdown_restart_on_finishEVERGREEN = month[splitDate_EVERGREEN.month-1]+' '+splitDate_EVERGREEN.date+', '+splitDate_EVERGREEN.year+' '+splitDate_EVERGREEN.hrs+':'+splitDate_EVERGREEN.mins+':'+splitDate_EVERGREEN.secs;
    countdowntime = getLastdate_EVERGREEN; other_data = '';
    if( active_time_status_id == 1 ){
      var fresh_sliderdown_html = $('#etp-quick-view-dialog .quick-view--timer-block #real-slidedown-countdown-for-quickviewpopup--backup--org').html();
      setTimeout(function(){
        $('#etp-quick-view-dialog .quick-view--timer-block #real-slidedown-countdown-for-quickviewpopup--worked').html(fresh_sliderdown_html);
        $('#etp-quick-view-dialog .quick-view--timer-block #real-slidedown-countdown-for-quickviewpopup--worked ul').attr('id','real-slidedown-countdown-for-quickviewpopup');
        run_slidedown_EVERGREEN_timer(countDownTimeForSlideDown,other_data); },1000); 
    } else if( active_time_status_id == 2 ){
      run_simple_EVERGREEN_timer(countdowntime,other_data); 
    } else if( active_time_status_id == 3 ){
      $('.quick-view--timer-block #circle-countdown--block').html(''); 
      clearInterval(window.prevCircleNowPlaying_EVERGREEN_countdown); 
      setTimeout(function(){$('.quick-view--timer-block #circle-countdown--block').html(circle_Timer_html);
                            init_circle__EVERGREEN_timer(date_for_circle_countdown_restart_on_finishEVERGREEN,other_data);},1000);
    }else if( active_time_status_id == 4 ){ 
      run_recnewstyle_EVERGREEN_timer(countdowntime,other_data);
    }else {}
  };  

  if(curr_datetime == ''){
    $('.quick-view--timer-block, .quick-view-dialog .etp-single-product-count ').hide(); 
  } 
  else { 
    $('.quick-view--timer-block, .quick-view-dialog .etp-single-product-count ').show()
  }
}

function reinitilize_tooltip(){setTimeout(function(){ $('[data-toggle="tooltip"]').tooltip();},1000);} 
function copy_the_discount_code(){ var copyText = document.getElementById("myDiscountCode13"); copyText.select(); document.execCommand("copy"); swal("Discount Code", "Copied the discount code : "+copyText.value, "success");} 
function close_all_modals() {$(".etp-modal-popup .modal-dialog .modal-body .close").click();}
function run_swipeslider_for_relatedproduct_in_modal(slider_path){var swiperAct = new Swiper(slider_path, {navigation: {nextEl: '.swiper-button-next.popUp-rv-next', prevEl: '.swiper-button-prev.popUp-rv-prev'}, paginationClickable: false, slidesPerView: 3,centeredSlides: false, autoplay: 2500, spaceBetween: 20, slidesPerView: 3, autoplayDisableOnInteraction: false, freeMode: false, loop: false, speed:500, observer: true, observeParents: true, breakpoints: {767: {slidesPerView: 2, spaceBetween: 20, freeMode: true, loop: false, speed:500, scrollbar: {el: '.swiper-scrollbar', clickable: true,}}, 500: {slidesPerView: 2., spaceBetween: 20, freeMode: true, loop: false, speed:500, scrollbar: { el: '.swiper-scrollbar', clickable: true,}}}});}
function update_colors(url_path){
  
  var colorList = "Black: #000000, White: #ffffff"; 
  var colorListArr = {};colorList = colorList.split(','); 
  for(var z=0;z<colorList.length;z++){var oneByone = $.trim(colorList[z]); oneByone = oneByone.split(':'); var keyName = $.trim( oneByone[0].toLowerCase() ); var keyValue = $.trim( oneByone[1] ); if(keyName != '' && keyName != null){  colorListArr[keyName] = keyValue; }}; $(url_path).each(function(){var keyName = $.trim( $(this).children('button').attr('data-value') ); keyName = keyName.toLowerCase(); var color_code = colorListArr[keyName]; $(this).children('button').css('background-color',color_code);})
         
}
function get_particular_collection_products(productCollectionList,element_path,color_swatch_path,wrapup_path,slider_path){
  $('#etp-ajax-success-message .etp-recentView-dialog').hide();  
  if(productCollectionList == '' || typeof productCollectionList === 'undefined'){
    return false;
  }  
  $(element_path).html('');    
  productCollectionList = productCollectionList.split(',');   
  var product_collection = $.trim(productCollectionList[0]);
  product_collection = product_collection.replace(/\s+/g, "-");    

  $.ajax({    
    url: "/collections/"+product_collection, 
    type: "GET",
    dataType : 'html',       
    success: function(dataHtml){                  
      var data_product = '';           
      var data_html =  $(dataHtml).find('.etp-collection-content').find('.etp-grid-view').html() ;
      $(element_path).html(data_html);   
      reinitilize_tooltip();
      update_colors(color_swatch_path);  
      $(wrapup_path).wrap( "<div class='swiper-slide'></div>" ); 
      currencyConvert();
      setTimeout(function(){
        $('#etp-ajax-success-message .etp-recentView-dialog').show();
        run_swipeslider_for_relatedproduct_in_modal(slider_path);  
        $('#etp-ajax-success-message .related--product-container .product--snippet .product-title-price .single_products_options .selector-wrapper ul li:nth-child(1)').click();
        var hierarcy_root2 = $('#etp-ajax-success-message .related--product-container .product--snippet .product-title-price .single_products_options');
        setTimeout(function(){ activate_available_variants(hierarcy_root2); },200);  
      },1000); // RUN SWIPE SLIDER 
    }  
  });   

}

function activate_product_page_variant(){
  var swatch_value=new Array();
  var selectorLink = $('.option-background.product-page-swatches .option-switch-dropdown > .selector-wrapper > .single-option-selector');
  var selectorOptionLink = $('.option-background.product-page-swatches .option-switch-dropdown > .selector-wrapper > .single-option-selector option');

  if( selectorOptionLink.length > 1 )
  {           
    var varient_combi_name = ''; var zx = 0;  var total_option_list = selectorLink.length;
    $(".option-background.product-page-swatches .option-switch-dropdown > .selector-wrapper").each(function(){ 
      var current_varient_value = $(this).find('.single-option-selector').val();  swatch_value[zx] = current_varient_value ;
      if(zx < (total_option_list -1) ){   varient_combi_name = varient_combi_name + current_varient_value + ' / ';  }
      else   {  varient_combi_name = varient_combi_name + current_varient_value ;     }  zx++;    
    });

    if( varient_combi_name.indexOf('null') == -1 ){     
      var varient__id_active = $(".product-page-swatches .varient-id--options option[data-title='"+varient_combi_name+"']").val();
      $(".product-page-swatches .varient-id--options").val('').change();
      setTimeout(function(){ $(".product-page-swatches .varient-id--options").val(varient__id_active).change(); },200);

      // ----------------- ASSIGN VALUES block start here  ------------------  
      var i = 0;
      $(".sticky-add-to-cart .option-switch-dropdown .single-option-selector").each(function(){
        $(this).val(swatch_value[i]);  i++;         
      })
      // ----------------- ASSIGN VALUES block END here  ------------------
    }

  }
}
function update_color_swatches(){

  

  var colorList = "Black: #000000, White: #ffffff";
  var colorListArr = {};
  colorList = colorList.split(',');

  for(var z=0;z<colorList.length;z++){

    var oneByone = colorList[z];      
    oneByone = oneByone.split(':');
    var keyName = $.trim( oneByone[0].toLowerCase() ); var keyValue = $.trim( oneByone[1] ); 
    if(keyName != '' && keyName != null){  colorListArr[keyName] = keyValue;  }
  }  

  $('#etp-quick-view-dialog .second-varient-option-block .option-background .varient-box-style.color--swatch ul li').each(function(){
    var keyName = $.trim( $(this).children('button').attr('data-value') ); keyName = keyName.toLowerCase();
    var color_code = colorListArr[keyName];
    $(this).children('button').css('background-color',color_code);
  })

      
}
function check_product_availability_in_real_time(variant_id , handle , add_to_cart_btn_hierarchy , buy_now_btn_hierarchy,other_data){

  $.ajax({
    url: '/products/'+handle+'.js',
    dataType: 'json',
    async: false,
    success: function(prod_data) {
      var total_variant = prod_data.variants.length;

      for( var z = 0 ; z < total_variant ; z++ ){ 
        var variant_detail = prod_data.variants[z];
        var get_variant_id = variant_detail.id;
        if(get_variant_id == variant_id){ 

          if(variant_detail.available == false){         

            $(buy_now_btn_hierarchy).addClass('disabled').text(window.dialogSoldOutBtn);
            $(add_to_cart_btn_hierarchy).addClass('disabled').text(window.dialogSoldOutBtn);

            if(other_data.action == 'product-page'){
              $(other_data.price_hierarchy).html(other_data.sold__out_html);   
              $(other_data.sticky_addto_cart_hierarchy).addClass('disabled').text(window.dialogSoldOutBtn);
              $(".sticky-add-to-cart .prices-top-bar .price-real").html(window.dialogSoldOutBtn);
            }
            else if(other_data.action == 'homepage-single-product-page'){
              $(other_data.price_hierarchy).html(other_data.sold__out_html);   
            }
            else if(other_data.action == 'upsell-product-block'){
              $(other_data.price_hierarchy).html(other_data.sold__out_html);   
            }
            else
            {

            }

          }    
          else   
          { 

            $(buy_now_btn_hierarchy).removeClass('disabled').html(window.dialogBuyNowBtn);
            $(add_to_cart_btn_hierarchy).removeClass('disabled').html(window.addToCartBtn);

            if(other_data.action == 'product-page'){
              $(other_data.sticky_addto_cart_hierarchy).removeClass('disabled').html(window.addToCartBtn);
              var price__html = $(".product-detail--full--11 .previewPriceOuter .etp-default-price").html();  
              $(".sticky-add-to-cart .prices-top-bar .price-real").html(price__html);
            } 
            else if(other_data.action == 'homepage-single-product-page'){

            }
            else
            {

            }

          }
        }
      } // end for loop

    } // end of success block
  });
}                

function show_currency_flag(){

  var current_currency = $(".header--currency--block-11 .dropdown button .etp-currency-text").text();
  var currency_flag_classes = $.trim( $("#currencies_sle li a[data-value='"+current_currency+"']").parent('li').attr('class') );
  current_currency = $.trim(current_currency);
  $(".currency_icons--block .etp-currency-symbol").attr('class','etp-currency-symbol '+currency_flag_classes);

}
function re_initilize_currency(){   

  var current_currency = $(".header--currency--block-11 .dropdown button .etp-currency-text").text();
  var currency_flag_classes = $.trim( $("#currencies_sle li a[data-value='"+current_currency+"']").parent('li').attr('class') );
  current_currency = $.trim(current_currency);
  $(".currency-block-top-001 .dropdown .etp-currency-symbol").attr('class','etp-currency-symbol '+currency_flag_classes); 
  $(".header--currency--block-11 .dropdown .currencies--switcher--engine").val(window.shopCurrency).change();
  $(".header--currency--block-11 .dropdown .currencies--switcher--engine").val(current_currency).change();
}   
/***************************************************************************************
 * Show Loading Animation Function
 ***************************************************************************************/
function showLoading() {
  $(".etp-loading").show()
}
/***************************************************************************************
 * Hide Loading Animation Function
 ***************************************************************************************/
function hideLoading() {
  $(".etp-loading").hide()
}
/*******************************************************************************
 * Scroll Animation Function - Using Animate.css with jQuery Waypoints
 *******************************************************************************/
function etpAnimation(items, trigger) {
  items.each( function() {
    var osElement = $(this),
        osAnimationClass = osElement.attr('data-etp-animation'),
        osAnimationDelay = osElement.attr('data-etp-animation-delay');
    osElement.css({
      '-webkit-animation-delay':  osAnimationDelay,
      '-moz-animation-delay':     osAnimationDelay,
      'animation-delay':          osAnimationDelay
    });
    var osTrigger = ( trigger ) ? trigger : osElement;
    osTrigger.waypoint(function() {
      osElement.addClass('animated').addClass(osAnimationClass);
    },{
      triggerOnce: true,
      offset: '90%'
    });
  });
}
/***************************************************************************************
 * Show Success Message Function
 ***************************************************************************************/
function showSuccessMessage(successVar) {
  var image = successVar.image,
      message = successVar.message,
      buttonText = successVar.buttonText,
      buttonLink = successVar.buttonLink,
      productName = successVar.productName,
      popup = $('#etp-ajax-success-message');
  popup.find('.etp-success-message-img').html('<img src="'+image+'" class="img-responsive">');
  popup.find('.etp-success-message-title').text(productName);
  popup.find('.etp-success-message-details').html(message);
  popup.find('.etp-success-message-link').text(buttonText);
  popup.find('.etp-success-message-link').attr('href', buttonLink);
  popup.modal('show');
} 

function showSuccessMessageForWhislist(successVar) {  

  var image = successVar.image,
      message = successVar.message,
      buttonText = successVar.buttonText, 
      buttonLink = successVar.buttonLink, 
      productName = successVar.productName,
      variantId = successVar.variantId ,
      product_collection = successVar.collectionListName ,
      popup = $('#etp-ajax-success-message--Wishlist');
  popup.find('.etp-success-message-img').html('<img src="'+image+'" class="img-responsive">');
  popup.find('.etp-success-message-title').text(productName);
  popup.find('.etp-success-message-details').html(message);
  popup.find('.etp-success-message-link').text(buttonText);
  popup.find('.etp-success-message-link').attr('href', buttonLink);

  var productCollectionList = $.trim(successVar.collectionListName) ;

  var element_path = '#etp-ajax-success-message--Wishlist .whislist-related--product-container .whislist-slide_popup_list-related-product .swiper-wrapper';
  var color_swatch_path = '#etp-ajax-success-message--Wishlist .whislist-related--product-container .product--snippet .product-title-price .single_products_options .selector-wrapper div[swatch-type="color"] ul li';
  var wrapup_path = "#etp-ajax-success-message--Wishlist .whislist-related--product-container .whislist-slide_popup_list-related-product .swiper-wrapper .product--snippet";
  var slider_path = '.swiper-container.whislist-slide_popup_list-related-product';
  if(productCollectionList != '' && productCollectionList != null && typeof productCollectionList !== 'undefined'){
    get_particular_collection_products(productCollectionList,element_path,color_swatch_path,wrapup_path,slider_path);  
    $('#etp-ajax-success-message--Wishlist .etp-recentView-dialog .whislist-related--product-container').show();
  }

  popup.find('.add--to--cart-on-whislist').attr('data-variant-id', variantId);  
  popup.modal('show');
}
/***************************************************************************************
 * Show Common Message Function
 ***************************************************************************************/
function showCommonMessage(message) {

  var popup = $('#etp-common-message');
  popup.find('.etp-common-message-details').html(message);
  popup.modal('show');

}
/***************************************************************************************
 * Currency Convert Function
 ***************************************************************************************/
function currencyConvert() {
  Currency.convertAll(window.shopCurrency, $('#currencies').val(), 'span.money', window.currencyFormat);
}
/***************************************************************************************
 * Ajax Add To Cart Function
 ***************************************************************************************/
function ajaxAddToCart2(id, quantity,currentThis) {
  var dynamicData = "quantity="+quantity+"&id="+id;
  return $.ajax({
    url: "/cart/add.js",
    type: "get",
    data: dynamicData,
    dataType: "json",  
    beforeSend: function() {
      showLoading();
    },
    error: function(data) {
      currentThis.removeClass('loader_running');
      hideLoading();
      var message = '<i class="fa fa-info-circle font-size-16"></i> '+ $.parseJSON(data.responseText).description;
      showCommonMessage(message);
    }
  });
}
function ajaxAddToCart(id, quantity) {
  var dynamicData = "quantity="+quantity+"&id="+id;
  return $.ajax({
    url: "/cart/add.js",
    type: "get",
    data: dynamicData,
    dataType: "json",
    beforeSend: function() {
      showLoading();
    },
    error: function(data) {
      hideLoading();
      var message = '<i class="fa fa-info-circle font-size-16"></i> '+ $.parseJSON(data.responseText).description;
      showCommonMessage(message);
    }
  });
}
/***************************************************************************************
 * Instant Search
 ***************************************************************************************/
function ajaxInstantSearch(search) {
  var getData = "type=product&view=json&q=*"+search+"*";
  return $.ajax({
    url: '/search',
    type: "get",
    dataType: "json",
    data: getData,
    beforeSend: function() {
      $('.search-loading').show();
      $('.instant-search-data').show();
    },
    error: function() {
      $('.search-loading').hide();
      $('.instant-search-data').hide();
    }
  });
} 
/***************************************************************************************
 * Cart Empty or Not Function
 ***************************************************************************************/
function cartEmptyOrNot() {
  if( $(".etp-cart-item-list").children().length > 0) {
    $(".etp-cartNotEmpty").show();
    $(".cart-products").show();
    $(".etp-cartEmpty").hide();
  } else {
    $(".etp-cartNotEmpty").hide();
    $(".cart-products").hide();
    $(".etp-cartEmpty").show();
  }   
}
/***************************************************************************************
 * Update Dropdown Cart Function
 ***************************************************************************************/   
function updateCartWrapperProducts(){

  if( $(".cart-content .cart-item-list .etp-cart-page-list").length > 0 ){     

    $.ajax({
      url: "/cart",
      type: "GET",
      dataType: "html",
      success: function(dataHtml){
        var required_data = $(dataHtml).find('.etp-cart-page-list').html();  
        $(".cart-content .cart-item-list .etp-cart-page-list").html(required_data);
      }
    });

  }
}
function updateDropdownCart(data) {
  var total_price = Shopify.formatMoney(data.total_price),
      cartItemList = '';
  $(".etp-cart-total-price").html('<span class="money">'+total_price+'</span>');    
  $(".etp-cart-item-count").html(data.item_count);
  for (var i = 0; i < data.items.length; i++) {
    cartItemList += '<li class="cart-menu-line-item padding-left-15 padding-right-15"><a href="'+ data.items[i].url +'" class="pull-left"><img src="'+ Shopify.resizeImage(data.items[i].image, "small") +'" alt=""></a><div class="pull-left"><a href="'+ data.items[i].url +'" class="cart-menu-line-title pull-left margin-left-10 drop-title">'+ data.items[i].product_title +'</a><div class="pull-left cart-menu-line-cal text-right"><a href="#" class="cart-menu-item-remove drop-title" data-varient-id="'+ data.items[i].variant_id +'"><i class="fa fa-times"></i></a><p class="margin-top-15"><strong class="cart-menu-line-quantity">'+ data.items[i].quantity +'</strong> x <strong class="cart-menu-line-price"><span class="money">'+ Shopify.formatMoney(data.items[i].price, window.money_format) +'</span></strong></p></div></div></li><li class="divider"></li>';
  }
  $(".etp-cart-item-list").html('').append(cartItemList);

  if(data.item_count == 0){
    $(".navbar-default .etp-cart-menu-body .cart_counts__").hide();
  }
  else{
    $(".navbar-default .etp-cart-menu-body .cart_counts__").show();
  }
  updateCartWrapperProducts();
  cartEmptyOrNot();
  currencyConvert();
}
/***************************************************************************************
 * Ajax Dropdown Cart Function
 ***************************************************************************************/
function ajaxDropdownCart() {
  Shopify.getCart(function(data) {
    updateDropdownCart(data)
  })
}/***************************************************************************************
 * Compare List Count Function
 ***************************************************************************************/

function compareListCount() {
  if(typeof Shopify.etpCookie !== 'undefined'){
    var countList = Shopify.etpCookie.countItem('etp_cookieName_compare');
    $('.etp-compare-count').text(countList);
  }
}

/***************************************************************************************
 * Compare List Done Function
 ***************************************************************************************/
function compareListDone() {
  if(typeof Shopify.etpCookie !== 'undefined'){
    var compareListData = Shopify.etpCookie.cookieList('etp_cookieName_compare');
    if(typeof  compareListData != 'undefined'){
      compareListData = compareListData.split(' ');
      for ( var p = 0; p < compareListData.length; p++ ) {
        var dataHandleClass = $('.etp-add-to-compare[data-handle="'+ compareListData[p] +'"]');
        dataHandleClass.addClass('etp-compare-done');
        dataHandleClass.removeClass('etp-add-to-compare');

        dataHandleClass.children('i').removeClass('fa-heart-o');
        dataHandleClass.children('i').addClass('fa-heart');
      }
    }
  }
} 
/***************************************************************************************
 * Compare List Record Function
 ***************************************************************************************/
function compareListRecord(handle) {
  Shopify.etpCookie.recordItem(handle, {cookieName: "etp_cookieName_compare"});
  compareListDone();
}
/***************************************************************************************
 * Compare List Empty Function
 ***************************************************************************************/

function compareListEmpty() {
  if(typeof Shopify.etpCookie !== 'undefined'){
    var countList = Shopify.etpCookie.countItem('etp_cookieName_compare'),
        listEmpty = $(".etp-compare-list-empty");
    if(listEmpty.length && countList == 0) {
      listEmpty.fadeIn();
      $('.etp-compare-table').hide();
    }
  }
}/***************************************************************************************
 * Ajax Get Data Function
 ***************************************************************************************/
function ajaxGetData(url, dataType) {
  var dataTypeDefault = typeof dataType !== 'undefined' ?  dataType : 'html';
  return $.ajax({
    url: url,
    type: "get",
    dataType: dataTypeDefault,
    beforeSend: function() {
      showLoading();
    },
    error: function() {
      hideLoading();
      var message = '<i class="fa fa-info-circle font-size-16"></i> '+window.dialogMassage;
      showCommonMessage(message);
    }
  });
}
/***************************************************************************************
 * Cart Page Data Update Function
 ***************************************************************************************/
function cartPageUpdate(data) {
  $('.etp-cart-page-list').html($(data).find('.etp-cart-page-list').html());
  $('.etp-cart-menu-body').html($(data).find('.etp-cart-menu-body').html());
  $('.etp-cart-sub-total').html($(data).find('.etp-cart-sub-total').html());
  $('.etp-cart-topbar-total').html($(data).find('.etp-cart-topbar-total').html());
  cartEmptyOrNot();
  currencyConvert();
}
/***************************************************************************************
 * Filter Default Filter Data Function
 ***************************************************************************************/
function filterDefaultData() {
  var url = document.location.href,
      urlSplit = url.split( '?'),
      subCategory = urlSplit[0].substr(urlSplit[0].lastIndexOf('/') + 1);
  if(subCategory) {
    $(".etp-filter-category option[value='/collections/"+ subCategory +"']").attr("selected", "selected");
  } else {
    subCategory = url.substr(url.lastIndexOf('/') + 1);
    $(".etp-filter-category option[value='/collections/"+ subCategory +"']").attr("selected", "selected");
  }
  if(urlSplit[1]){
    var urlSplitEqual = urlSplit[1].split( '='),
        urlSplitPlus = urlSplitEqual[1].split('+');
    if(urlSplitEqual[0] == 'constraint') {
      $('.filter-product-list').slideToggle("slow");
    }
    for (var i = 0; i < urlSplitPlus.length; i++) {
      $(".etp-filter-checkbox").each(function() {
        if(urlSplitPlus[i] == $(this).val()){
          $(this).prop('checked', true);
          $(this).parent().addClass('active');
        }
      });
    }
    if(urlSplitEqual[0] == 'sort_by'){
      if(urlSplitEqual[1]) {
        $(".etp-sort-by option[value='"+ urlSplitEqual[1] +"']").attr("selected", "selected");
      } 
    } else if(urlSplitEqual[0] == 'show'){
      if(urlSplitEqual[1] == 'list') {
        $('.etp-list-grid').removeClass('active');
        $('.etp-list-grid[data-value="list"]').addClass('active');
        $('.etp-grid-view').addClass('etp-list-view').removeClass('etp-grid-view');
        $('.etp-list-product-des').show();
      } else{
        $('.etp-list-grid').removeClass('active');
        $('.etp-list-grid[data-value="grid"]').addClass('active');
        $('.etp-list-view').addClass('etp-grid-view').removeClass('etp-list-view');
        $('.etp-list-product-des').hide();
      }
    }
  }
}  
/***************************************************************************************
 * Filter Ajax Page Content Update Function
 ***************************************************************************************/
function filterUpdate(data) {
  $('.collection-handle').text($(data).find('.etp-filter-category.active').text());
  $('.etp-collection-content').html($(data).find('.etp-collection-content').html());
  $('.etp-filter-product').html($(data).find('.etp-filter-product').html());
  filterDefaultData();
  currencyConvert();
  // etpAnimation($('.etp-animation'));
}
/***************************************************************************************
 * Url change using PushSate Function
 ***************************************************************************************/
function urlPushState(url) {
  if(url != window.location){
    if (history.pushState) {
      window.history.pushState({path:url},url,url);
    } else{
      window.location.href = url;
    }
  }
}
/***************************************************************************************
 * Filter By Category Url Function
 ***************************************************************************************/
function filterCategoryUrl(thisData) {
  var url = document.location.href,
      urlSplit = url.split('?'),
      newUrl = thisData.attr('href');
  if(urlSplit[1]){
    newUrl = newUrl +'?'+ urlSplit[1];
  }
  return newUrl;
}
/***************************************************************************************
 * Sort By Url Function
 ***************************************************************************************/
function filterSortByUrl(thisData) {
  var url = document.location.href,
      urlSplit = url.split( '?'),
      sortByVal = thisData.val();
  if(urlSplit[1]){
    url = urlSplit[0];
  }
  url = url+'?sort_by='+sortByVal.replace(/\+/g, '%20');
  return url;
}
/***************************************************************************************
 * Grid or List Url Function
 ***************************************************************************************/
function filterGridListUrl(thisData) {
  var url = document.location.href,
      urlSplit = url.split( '?'),
      sortByVal = thisData.attr('data-value');
  if(urlSplit[1]){
    url = urlSplit[0];
  }
  url = url+'?show='+sortByVal.replace(/\+/g, '%20');
  return url;
}
/***************************************************************************************
 * Filter Using CheckBox Data Function
 ***************************************************************************************/
function filterCheckBox(thisData) {
  var url = document.location.href,
      urlSplit = url.split( '?'),
      subCategory = urlSplit[0].substr(urlSplit[0].lastIndexOf('/') + 1);
  url = '/collections/'+ subCategory +'?constraint='+ thisData.val();
  if(urlSplit[1]){
    var urlSplitEqual = urlSplit[1].split('=');
    if(urlSplitEqual[0] == "constraint"){
      var tags = urlSplitEqual[1].split('+');
      tags.push(thisData.val());
      var bing = tags.join('+');
      if(thisData.is(':checked')) {
        url = '/collections/'+ subCategory +'?constraint='+ bing;
      } else {
        Array.prototype.remove = function() {
          var what, a = arguments, L = a.length, ax;
          while (L && this.length) {
            what = a[--L];
            while ((ax = this.indexOf(what)) !== -1) {
              this.splice(ax, 1);
            }
          }
          return this;
        };
        for (i = 0; i < tags.length; i++) {
          if(tags[i] == thisData.val()){
            tags.remove(thisData.val());
          }
        }
        if(tags.length == 0){
          url = '/collections/'+ subCategory;
        } else{
          bing = tags.join('+');
          url = '/collections/'+ subCategory +'?constraint='+ bing;
        }
      }
    }
  }
  return url;
}

function getandomArbitrary(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function checkQuickViewProductViewing(data){  // FORMAT :: product_view-20/100-10_sec

  var variant_id = data.id;
  var tags_list = data.tags ; var product_view_text = '';

  for(var i=0;i<tags_list.length;i++){


    if( tags_list[i].indexOf('product_view') > -1){
      product_view_text = tags_list[i] ;
    }
  }


  if(product_view_text != '' )
  { 
    try{ 
      product_view_text = product_view_text.split('-');
      var interval_time = product_view_text[2];    
      interval_time = interval_time.split('_'); 
      interval_time = interval_time[0];
      var interval_time_unit = interval_time[1]; 

      product_view_text = product_view_text[1];    

      var product_view_text_breake = product_view_text.split("/"); 

      var min_view = parseInt(product_view_text_breake[0]);
      var max_view = parseInt(product_view_text_breake[1]); 

      var set_interval_time = interval_time * 1000 ;  
      $("#etp-quick-view-dialog .etp-quickview-total-viewing").text(getandomArbitrary( min_view , max_view));
      $("#etp-quick-view-dialog .etp-quickview-total-viewing--block").show();
      $("#etp-quick-view-dialog .etp-quickview-total-viewing--block .etp-total-viewing-block").show();
      $("#etp-quick-view-dialog .second-varient-option-block .count-product .etp-total-viewing-block-main").removeClass('hideme');
      window.Quickview_product_view_text_interval =  setInterval(function() {   
        $("#etp-quick-view-dialog .etp-quickview-total-viewing").text(getandomArbitrary( min_view , max_view));
      },set_interval_time);
    }
    catch(err) {    

    } 
  }     
  else
  { 
    $("#etp-quick-view-dialog .etp-quickview-total-viewing--block").hide();   
    $("#etp-quick-view-dialog .etp-quickview-total-viewing--block .etp-total-viewing-block").hide();  
    $("#etp-quick-view-dialog .second-varient-option-block .count-product .etp-total-viewing-block-main").addClass('hideme');
  } 
} 

function active_firststyle_if_only_reviews_exists(){    
  var storeClass = 'count-product  count-product-style-2 flex-box wrap-box';
  var mainRoot = $('#etp-quick-view-dialog .second-varient-option-block .count-product');
  if( mainRoot.find(".etp-total-sold-block-main").hasClass('hideme') && mainRoot.find(".etp-total-viewing-block-main").hasClass('hideme') ){
    mainRoot.attr('class','count-product');
  }
  else{
    mainRoot.attr('class',storeClass);   
  }
}           
function soldOutProducts(data){    

  var variant_id = data.id;
  var tags_list = data.tags ; var prod_available = ''; var product_sold ='';
  for(var i=0;i<tags_list.length;i++){    
    if( tags_list[i].indexOf('product_available') > -1){
      prod_available = tags_list[i] ;
    }
    if( tags_list[i].indexOf('product_sold') > -1){
      product_sold = tags_list[i] ;
    }
  }

  if(prod_available != ''){

    var total_product_available = prod_available.split('-');
    total_product_available = total_product_available[1];
  }

  if(product_sold != '' && prod_available != '')
  {
    product_sold = product_sold.split('-');
    var prod_interval_timer = product_sold[2].split('_');
    prod_interval_timer = prod_interval_timer[0]; 
    var set_soldout_interval_time = prod_interval_timer * 1000 ;
    product_sold = product_sold[1].split('/');
    var start_from_soldout = parseInt( product_sold[0] ); 
    var end_from_soldout = parseInt( product_sold[1] );
    var start_from_soldout_reserve = product_sold[0];
    var end_from_soldout_reserve = product_sold[1];
    var total_product_available_reserve = total_product_available;
    /************** CHECK COOKIE EXISTS OR NOT BLOCK START HERE *********************/  
    var total_productavailable =  $.cookie('total_product_available_'+variant_id);
    /************** CHECK COOKIE EXISTS OR NOT BLOCK END HERE *********************/  
    if( total_productavailable != '' && typeof total_productavailable != 'undefined' &&  total_productavailable != null ){

      var total_diff =  parseInt(total_product_available) - parseInt(total_productavailable) ;  
      start_from_soldout =  parseInt(start_from_soldout) + parseInt(total_diff) ;  
      total_product_available = total_productavailable ; 
      $("#etp-quick-view-dialog .second-varient-option-block .etp-quickview-total-sold").text(start_from_soldout);
      $("#etp-quick-view-dialog .etp-quickview-availability-all span.number-span").text(total_product_available);
      $("#etp-quick-view-dialog .etp-quickview-availability-block .availability_bar_progress").css('width' , total_product_available +'%');
      $("#etp-quick-view-dialog .etp-quickview-availability-block .availability-bar").show();
    }        

    window.Quick_view_interval = setInterval(function()    
                                             {              
      start_from_soldout = parseInt(start_from_soldout) + 1;
      total_product_available = parseInt(total_product_available) - 1;     
      if( start_from_soldout <= end_from_soldout && total_product_available > 2 )  
      {         
        $("#etp-quick-view-dialog .second-varient-option-block .etp-quickview-total-sold").text(start_from_soldout);
        $("#etp-quick-view-dialog .etp-quickview-availability-all span.number-span").text(total_product_available);
        $("#etp-quick-view-dialog .etp-quickview-availability-block .availability_bar_progress").css('width' , total_product_available +'%');
        $("#etp-quick-view-dialog .etp-quickview-availability-block .availability-bar").show();
        /************** COOKIE BLOCK START HERE *********************/
        var total_productavailable =  $.cookie('total_product_available_'+variant_id);  

        if( total_productavailable == '' || typeof total_productavailable == 'undefined') 
        {  
          start_from_soldout = parseInt(start_from_soldout_reserve) ;
          var date = new Date(); 
          var currentHrs = date.getHours(); 
          var currentMins = date.getMinutes();
          var required_mintues = ( 1 * 60 ) + currentMins ;                     
          var set__Time = date.getTime() + (required_mintues * 60 * 1000) ;
          date.setTime(set__Time);    
          localStorage.setItem("soldout_expiredate_"+variant_id,set__Time );   
          $.cookie('total_product_available_'+variant_id, total_product_available , { expires: date, path: '/' });         

        }          
        else  
        {         
          var date = new Date(); 
          set__Time = localStorage.getItem("soldout_expiredate_"+variant_id); date.setTime(set__Time);                                   
          $.cookie('total_product_available_'+variant_id, total_product_available , { expires: date, path: '/' });
        }  

        /************** COOKIE BLOCK END HERE *********************/          
      }     

    },set_soldout_interval_time);  

    $("#etp-quick-view-dialog .second-varient-option-block .count-product .total-sold--block").show();
    $("#etp-quick-view-dialog .second-varient-option-block .etp-quickview-availability-block").show();     
    $("#etp-quick-view-dialog .second-varient-option-block .count-product .etp-total-sold-block-main").removeClass('hideme');
  }
  else 
  {
    $("#etp-quick-view-dialog .second-varient-option-block .count-product .total-sold--block").hide();
    $("#etp-quick-view-dialog .second-varient-option-block .etp-quickview-availability-block").hide();
    $("#etp-quick-view-dialog .second-varient-option-block .count-product .etp-total-sold-block-main").addClass('hideme');      
  }
} 

$('body').on('click', '#etp-quick-view-dialog .modal-body .close', function(){     

  clearInterval(window.Quick_view_interval);  var emptyMe = '';   
  clearInterval(window.Quickview_product_view_text_interval);

  $("#etp-quick-view-dialog .second-varient-option-block .etp-quickview-total-sold").text(emptyMe);
  $("#etp-quick-view-dialog .etp-quickview-availability-all span.number-span").text(emptyMe);

  $('.quick-view--timer-block #countdown-newstyle--realtime-for-quickviewpopup').html(emptyMe); // Reset div for new time init 
  $('#etp-quick-view-dialog .quick-view--timer-block #real-slidedown-countdown-for-quickviewpopup--worked').html(emptyMe);
  $('.quick-view--timer-block #real-simple-countdown-for-quickviewpopup').html(emptyMe); // Reset div for new time init 
  $('.quick-view--timer-block #circle-countdown--block').html(emptyMe);

})

function display_popup_fotorama_thumbs(popUPFotorama,thisData){
  setTimeout(function(){ 
    popUPFotorama.show(0); $('#etp-quick-view-dialog .second-varient-option-block').removeClass('second-varient-option-block--loading');
  },1000);
  setTimeout(function(){
    $("#etp-quick-view-dialog #etp-quickView-featureImage").css('opacity',1);
    $('#etp-quick-view-dialog .etp-product .images--container-ftrama-11').removeClass('loading'); 
    POPUP_activate_easy_zoom(thisData); hit_easy_zoom_oneach_image_changed();
  },2000); 
}

function POPUP_hit_the_easyzoom(){

  /************************ EASYZOOM CODE START HERE **************************/
  var $easyzoom = $('#etp-quick-view-dialog .easyzoom').easyZoom(); 
  var api1 = $easyzoom.filter('.easyzoom--with-thumbnails').data('easyZoom');

  $('#etp-quick-view-dialog .thumbnails').on('click', 'a', function(e) {
    var $this = $(this);    
    e.preventDefault();   
    api1.swap($this.data('standard'), $this.attr('href'));
  }); 
  /************************ EASYZOOM CODE END HERE **************************/

}        

function POPUP_initilize_the_easy_Zoom(my_img_collection){       

  var image_src = $('#etp-quick-view-dialog .fotorama .fotorama__stage__shaft .fotorama__active .fotorama__img').attr('src');

  var zoom_image_src = $.trim(my_img_collection[image_src]); 

  var img_css = $('#etp-quick-view-dialog .fotorama .fotorama__stage__shaft .fotorama__active .fotorama__img').attr('style');
  var new_img_html = '<div class="easyzoom easyzoom--overlay">'+    
      '<a  href="'+zoom_image_src+'" class="etp-product-image img-responsive">'+ 
      '<img src="'+image_src+'" alt="" style="'+img_css+'" />'+
      '</a>'+    
      '</div> ';
  var total_easyzoom_div = $('#etp-quick-view-dialog .fotorama .fotorama__stage__shaft .fotorama__active .easyzoom').length;
  if( total_easyzoom_div  == 0 && zoom_image_src !== 'undefined' ){             
    if( zoom_image_src != '' ){
      $('#etp-quick-view-dialog .fotorama .fotorama__stage__shaft .fotorama__active').html(new_img_html);
      POPUP_hit_the_easyzoom();     
    }
  }     
}   

function POPUP_activate_easy_zoom(thisData){

  if(thisData != ''){ 
    window.my_img_collection = {};       

    thisData.parents('.product--snippet').find('.product--option--variant--container').find('.product-image-list').find('ul').find('li').each(function(){
      var img_key = clean_data( $(this).attr('data-img-key') ); var img_value = clean_data( $(this).attr('data-img-value') );


      window.my_img_collection[img_key] = img_value;        
    })   
  }

  if( window.product_image_zoom == "1" ){  //<!-- For desktop and mobile -->
    POPUP_initilize_the_easy_Zoom(window.my_img_collection);      
  }    
  if( window.product_image_zoom == "2" ){ //<!-- Only for desktop -->
    if( $(window).width() >= 768 ){   
      POPUP_initilize_the_easy_Zoom(window.my_img_collection);    
    }
  }
  if( window.product_image_zoom == "3" ){ //<!-- Only for mobile -->  
    if( $(window).width() < 768 ){
      POPUP_initilize_the_easy_Zoom(window.my_img_collection);   
    }   
  }
  if( window.product_image_zoom == "4" ){ //<!-- Disable -->     

  }     
}  

function hit_easy_zoom_oneach_image_changed(){
  $('#etp-quick-view-dialog .fotorama').on('fotorama:ready ' +   
                                           'fotorama:showend ' +
                                           'fotorama:load ' +        
                                           'fotorama:error ',       
                                           function (e, fotorama, extra) {      

    var ftEventType = $.trim( e.type.toString() ); 

    if( ftEventType == 'fotorama:showend' || ftEventType == 'fotorama:load')                                    
    {
      var thisData = ''; 
      POPUP_activate_easy_zoom(thisData); 
    }
  });
}
function activeFotoramaSlider(thisData){

  var isInitialloadFotoramaCompleted = '';
  $('#etp-quick-view-dialog .images--container-ftrama-11 .fotorama').on('fotorama:ready ' +
                                                                        'fotorama:show ' +
                                                                        'fotorama:showend ' +
                                                                        'fotorama:load ',
                                                                        function (e, fotorama, extra) 
                                                                        {
    var last_img = $("#etp-quick-view-dialog .images--container-ftrama-11 .fotorama__nav-wrap .fotorama__nav__frame").length;
    last_img = last_img - 1;  var ftEventType = $.trim( e.type.toString() ); 

    if( (ftEventType == 'fotorama:ready' ) || (ftEventType == 'fotorama:load' && isInitialloadFotoramaCompleted == '') )                                 
    {
      var startFrom = 5;var imz = startFrom ; var setTimeOutInterval = 0; var startPoint = 0; var endReachout = 0;

      var intr = setInterval(function() { 
        fotorama.show(imz); startPoint++;
        imz = imz + startFrom; if(imz > last_img){ imz = last_img; endReachout++; } 
        if (endReachout == 1){  clearInterval(intr);display_popup_fotorama_thumbs(fotorama,thisData); }
      }, 1000); 
      isInitialloadFotoramaCompleted = 'YES';
    }           
  }  ).fotorama();   
}
function justActiveFotoramaSlider(popUPFotorama,thisData){

  var isInitialloadFotoramaCompleted = '';
  $('#etp-quick-view-dialog .images--container-ftrama-11 .fotorama').on('fotorama:ready fotorama:show fotorama:showend fotorama:load ',
                                                                        function (e, fotorama, extra)  { } ).fotorama();
  setTimeout(function(){
    $("#etp-quick-view-dialog #etp-quickView-featureImage").css('opacity',1);
    $('#etp-quick-view-dialog .etp-product .images--container-ftrama-11').removeClass('loading');
    $('#etp-quick-view-dialog .second-varient-option-block').removeClass('second-varient-option-block--loading');
    POPUP_activate_easy_zoom(thisData); hit_easy_zoom_oneach_image_changed();
  },1000);
} 

function get_belongs_to_options(dataVal){
  var currentOption =  dataVal; var optContainer = '';
  $('#etp-quick-view-dialog .option-background .select .modal--varient-id--options option').each(function(){
    var opt_title = $.trim($(this).attr('data-title'));
    if( opt_title.indexOf(currentOption) > -1 ){ optContainer += opt_title+','; }
  })
  return optContainer;
}

function activate_available_variants(hierarcy_root){
  hierarcy_root.find('.selector-wrapper').each(function(){

    if( $(this).find('ul').find('li.activated-cell').children('button.select_options').hasClass('variant_availability-false') ) { 

      $(this).find('ul').find('li').each(function(){
        if( !$(this).children('button.select_options').hasClass('variant_availability-false') ) {  
          $(this).children('button').click(); return false;  
        } 
      });     

    } 

  })  
}



/******************************** [ POPUP MODAL DIALOG BOX PRODUCT ] Manage select dropdown block start HERE *************************/

function popupModal_manageDropdownOptionAvailability(s,wrapperNum,currentThis,variantName){

  var f =s;
  var nWIndex = wrapperNum + 1; var newOptionSet = ''; var st = 1; var vOptionList = [];

  currentThis.find('.modal-product--option-blueprint').find('.modal-product--option--cont:nth-child('+f+')').find('ul').find('li').each(function(){

    var nextWOptionValue = $.trim($(this).attr('data-value')); var newVariantName = variantName+nextWOptionValue;

    currentThis.find('.product--option--variant--container').find('.modal--varient-id--options').find('option').each(function(){

      var data_title = $.trim( $(this).attr('data-title') );     

      if( data_title.indexOf(newVariantName) > -1 ){     

        if(st == 1){ var selected = 'selected'; } else { var selected = ''; }  st++;
        if(vOptionList.indexOf(nextWOptionValue) == -1 ) // check variant array contain current option
        {  
          newOptionSet += '<option value="'+nextWOptionValue+'" '+selected+' >'+nextWOptionValue+'</option>';  
          vOptionList.push(nextWOptionValue);
        }
      } 

    }) //end of select option each loop  
  }) // end of variant id select each loop    

  currentThis.find('.product--option--variant--container').find('.selector-wrapper:nth-child('+f+')').find('select').html(newOptionSet);
  var selectedVariant = currentThis.find('.product--option--variant--container').find('.modal--varient-id--options').val();

}
function popupModal_manageDropDownOptionsList(onPageLoadFlag,currentThis,currentWrapperThis,totalOptionPack){
  var currIndex = currentWrapperThis.index(); var variantName = '';
  var wrapperNum = currIndex+1;

  if(wrapperNum < totalOptionPack)
  {
    for(var s=1;s<=wrapperNum;s++){  

      var optionValue = currentThis.find('.product--option--variant--container').find('.selector-wrapper:nth-child('+s+')').find('select').val();
      variantName += optionValue+' / ';

    }    

    if(onPageLoadFlag == true){
      popupModal_manageDropdownOptionAvailability(s,wrapperNum,currentThis,variantName);
    }
    else
    {

      for(var f=(wrapperNum+1);f<=totalOptionPack;f++)
      { 
        s = f; variantName = '';
        for(var s=1;s<f;s++){  

          var optionValue = currentThis.find('.product--option--variant--container').find('.selector-wrapper:nth-child('+s+')').find('select').val();
          variantName += optionValue+' / ';

        }
        popupModal_manageDropdownOptionAvailability(s,wrapperNum,currentThis,variantName);     
      }
    }

  }

}
$('body').on('change', '#etp-quick-view-dialog .option-background .product--option--variant--container .selector-wrapper select', function(){

  if( $('#etp-quick-view-dialog .modal-product--option-blueprint').attr('data-initilize-process-done') == 'true' ){
    var currentThis = $(this).parents('.option-background');
    var totalOptionPack = $(this).parents('.product--option--variant--container').find('.selector-wrapper').length;  
    var currentWrapperThis = $(this).parent('.selector-wrapper');  var onPageLoadFlag = false ;

    popupModal_manageDropDownOptionsList(onPageLoadFlag,currentThis,currentWrapperThis,totalOptionPack);
  }

})

function checkPopupModalOptionAvailability(){
  var onPageLoadFlag = true ;
  $('#etp-quick-view-dialog .option-background').each(function(){
    var currentThis = $(this);
    currentThis.find('.product--option--variant--container').find('.selector-wrapper').each(function(){  
      var currentWrapperThis = $(this); 
      var totalOptionPack = currentThis.find('.product--option--variant--container').find('.selector-wrapper').length;

      popupModal_manageDropDownOptionsList(onPageLoadFlag,currentThis,currentWrapperThis,totalOptionPack);
    })
  })
} 
/******************************** [ POPUP MODAL DIALOG BOX PRODUCT ] Manage select dropdown block end HERE ********************************/


function createOptionBluePrint(){
  var bindHtml = '';
  $('#etp-quick-view-dialog .option-background .product--option--variant--container .select .selector-wrapper').each(function(){
    var optionHtml = ''; 
    var labelName = $.trim( $(this).children('label').text() );
    var labelHtml = '<label class="modal-product--option--label" for="">'+labelName+'</label>';
    $(this).children('.single-option-selector').find('option').each(function(){
      var optionName = $.trim( $(this).text() );
      optionHtml += '<li data-value="'+optionName+'" value="'+optionName+'">'+optionName+'</li>';
    })
    bindHtml +='<div class="modal-product--option--cont">'+labelHtml+'<ul class="modal-product--option--block">'+optionHtml+'</ul></div>';
  })
  $('#etp-quick-view-dialog .option-background .modal-product--option-blueprint').html(bindHtml);

}

function manage_buttons_popup(){
  var currentThis = $("#etp-quick-view-dialog .modal--varient-id--options") ; 
  var variantList = currentThis.find('option').length; 

  if(variantList == 1){
    var prod_availability = $.trim( currentThis.find('option:selected').attr('variant-availability') );  
    var variant_id = $.trim( currentThis.find('option:selected').val() );
    var product_handle = $.trim( currentThis.find('option:selected').attr('product-handle') );   

    if( prod_availability == false || prod_availability == "false" ) {         

      $("#etp-quick-view-dialog .second-varient-option-block .action--btn-block .etp-buy-now").addClass('disabled').text(window.dialogSoldOutBtn);
      $("#etp-quick-view-dialog .second-varient-option-block .action--btn-block #etp-quickView-buttons .etp-add-to-cart").addClass('disabled').text(window.dialogSoldOutBtn);
    }
    else      
    {           
      $("#etp-quick-view-dialog .second-varient-option-block .action--btn-block .etp-buy-now").removeClass('disabled').html(window.dialogBuyNowBtn);
      $("#etp-quick-view-dialog .second-varient-option-block .action--btn-block #etp-quickView-buttons .etp-add-to-cart").removeClass('disabled').html(window.addToCartBtn); 
    }
    currentThis.parents('.second-varient-option-block').find('.action--btn-block').find('a').attr('data-varient-id',variant_id);
  } 
} 
/***************************************************************************************
 * Quick View Data Function
 ***************************************************************************************/
function quickView(data, thisData) 
{
  $('#etp-quick-view-dialog .second-varient-option-block').addClass('second-varient-option-block--loading');
  var title = '<a href="'+data.url+'">'+data.title+'</a>',
      product_handle = data.handle,
      productCollectionList = thisData.attr('collection-title'), 
      price = data.price,
      compare_at_price = data.compare_at_price,   
      featured_image = data.featured_image,
      vendor = data.vendor,
      type = data.type,
      available = data.available, 
      images = data.images,      
      variants = data.variants,
      options = data.options,
      quickViewSlider = '',   
      quickViewOptions = '',
      productSlider = $('#etp-quickView-slider'), 
      availableItem = (available == true) ? 'Yes' : 'No',
      ratings = thisData.parents('.etp-product').find('.etp-rating-con').html(),
      description = thisData.parents('.etp-product').find('.etp-list-product-des').text(), 
      countdown = thisData.parents('.etp-product').find('.etp-countdown');  

  //  calculatePrice='';   
  var quickButtons ,calculatePrice ='' ;   
  var loading_img = '<img src="https://cdn.shopify.com/s/files/1/0044/8738/1090/files/loading_transparent_icon_e2ca83ba-4e8a-4bbc-bd3b-944478cf4db2.gif?v=1575450060">';
  $(".quick-view-dialog .etp-quickview-availability-all span.number-span").html(loading_img);
  if( available == true || available == "true" ){
    quickButtons = '<a href="#" class=" modal-btn--belong btn btn-primary etp-add-to-cart " data-item-quantity="1" data-varient-id="'+ variants[0].id +'">'+window.dialogAddBtn+'</a>'+ thisData.parents('.etp-product').find('.etp-wish-compare-con').html();

    // CHANGE STATUS OF BUY NOW BUTTON
    $("#etp-quick-view-dialog .action--btn-block .etp-buy-now").html(window.dialogBuyNowBtn);
    $("#etp-quick-view-dialog .action--btn-block .etp-buy-now").removeClass('disabled');      
  }
  else {
    quickButtons = '<a href="#" class=" modal-btn--belong btn btn-primary etp-add-to-cart disabled" data-item-quantity="1" data-varient-id="'+ variants[0].id +'">'+window.dialogSoldOutBtn+'</a>'+ thisData.parents('.etp-product').find('.etp-wish-compare-con').html(); 
    // CHANGE STATUS OF BUY NOW BUTTON
    $("#etp-quick-view-dialog .action--btn-block .etp-buy-now").text(window.dialogSoldOutBtn); 

    if( !$("#etp-quick-view-dialog .action--btn-block .etp-buy-now").hasClass('disabled') ) {
      $("#etp-quick-view-dialog .action--btn-block .etp-buy-now").addClass('disabled');
    }
  }
  calculatePrice = (compare_at_price > price) ? '<del class="margin-right-10 compate_at_price_popup"><span class="money" data-currency-'+window.shopCurrency_in_lowercase+'="'+Shopify.formatMoney(compare_at_price)+'" data-currency="'+window.shopCurrency+'">'+Shopify.formatMoney(compare_at_price)+'</span></del> <span class="etp-quickView-default-price original_price_popup"><span class="money" data-currency-'+window.shopCurrency_in_lowercase+'="'+Shopify.formatMoney(price)+'" data-currency="'+window.shopCurrency+'" >'+Shopify.formatMoney(price)+'</span></span>' : '<span class="etp-quickView-default-price original_price_popup"><span class="money" data-currency-'+window.shopCurrency_in_lowercase+'="'+Shopify.formatMoney(price)+'" data-currency="'+window.shopCurrency+'" >'+Shopify.formatMoney(price)+'</span></span>'; 

  if(featured_image != null){
    featured_image = Shopify.resizeImage(featured_image, "grande");
    $('#etp-quickView-image').attr('src', featured_image);
  }
  $('#etp-quickView-title').html(title);
  $('#etp-quickView-details').text(description.substr(0,130)+"...");
  $('#etp-quickView-vendor').text(vendor);
  $('#etp-quickView-type').text(type);
  $('#etp-quickView-available').text(availableItem); 
  $('#etp-quickView-price').html(calculatePrice);
  $("#etp-quickView-buttons").html(quickButtons);
  $(".etp-quickView-rating-con").html(ratings);
  $('.etp-quick-page').attr('href', data.url);
  $('#etp-quick-view-dialog  .second-varient-option-block #etp-quickView-title').attr('product-collection',productCollectionList);

  /***************** COLLECT ALL IMAGES BLOCK START HERE***************************/
  $('#etp-quick-view-dialog .images--container-ftrama-11 .single-product-image-list').remove();
  var total_images = data.images.length; var imagesBundle = '<div class="fotorama etp-single-product-image main-fotorama-container--" data-nav="thumbs">';

  var overlay_image = '<img src="'+data.images[0]+'" class="product-overlay-image">';

  for (var jx=0; jx < total_images; jx++) {
    var images_path = data.images[jx];

    imagesBundle += '<a src="'+images_path+'" class="etp-product-image img-responsive"><img src="'+images_path+'" data-zoom-image="'+images_path+'"></a>';
  }
  imagesBundle += '</div>';   
  $("#etp-quick-view-dialog #quickView-image-overlayer").html(overlay_image);     
  $("#etp-quick-view-dialog #etp-quickView-featureImage").html(imagesBundle).css('opacity',0);


  //var popUPFotorama = $('#etp-quick-view-dialog #etp-quickView-featureImage .fotorama').fotorama();
  $('#etp-quickView-price').html(calculatePrice);
      
  activeFotoramaSlider(thisData);
      
  // fotorama.show(0); 

  /***************** COLLECT ALL IMAGES BLOCK END HERE***************************/   
  for (var j=0; j < variants.length; j++){

    if(variants[j].featured_image == null || variants[j].featured_image == ''){
      var featuredImages = featured_image;
    }
    else
    { var featuredImages = variants[j].featured_image.src; }     

    var variant_availability = variants[j].available;   
    var variantCompareAtPrice= variants[j].compare_at_price;       
    var variantPrice= variants[j].price ;   
    if( variantCompareAtPrice == '' || variantCompareAtPrice == null ){
      variantCompareAtPrice = 0;
    }
    // *************************** OPTION FOR MAIN SELECT OF PRODUCT *******************************
    quickViewOptions += '<option variant-compare-at-price="'+variantCompareAtPrice+'" variant-price="'+variantPrice+'" variant-availability="'+variant_availability+'" product-handle ="'+product_handle+'" varient-id="'+variants[j].id+'" featured-img="'+featuredImages+'" data-name="'+ variants[j].title +'" data-title="'+ variants[j].title +'" value="'+ variants[j].id +'">'+ variants[j].title +' - '+ variants[j].price +'</option>';
    //quickViewOptions += '<option varient-id="'+variants[j].id+'" featured-img="'+variants[j].featured_image.src+'" data-name="'+ variants[j].title +'" value="'+ variants[j].id +'">'+ variants[j].title +'</option>';
  }
  $('.etp-quickView-switch').html('<div class="etp-quickView-options product--option--variant--container" style="display: none;"><div class="select clearfix"><select id="etp-quickView-select" class="modal--varient-id--options varient-id--options" name="id"></select></div></div><div class="swatch-opt-wrapper"></div>');
  $('#etp-quick-view-dialog #etp-quickView-select').html(quickViewOptions); 

  new Shopify.OptionSelectors("etp-quickView-select", { product: data, onVariantSelected: quickViewCallBack});

  for (var k = 0; k < options.length; k++) {
    $('.etp-quickView-options label[for="etp-quickView-select-option-'+ k +'"]').text(options[k].name);
  }

  var total_option_list = $(".etp-quickView-options .selector-wrapper").length; var zx = 1 ;

  $(".etp-quickView-options .selector-wrapper").each(function(){ 

    var wrapperClassName = 'not-very-first-wrapper';var wrapperUnderLiClassName = ''; 
    if(zx == 1) {  wrapperClassName = 'very--first--wrapper'; wrapperUnderLiClassName = 'very--first--options'; }

    var switch_ID = $(this).find('.single-option-selector').attr('id'); 
    var option_title = $(this).find('label').text();  var is_current_coloroption = 'NO'; 

    var label_name_lowercase =  option_title.toLowerCase(); var add__class_to_ul = '';
    if(label_name_lowercase == 'color' || label_name_lowercase == 'colors'){ 
      add__class_to_ul = 'quick_view--varient--color';
      is_current_coloroption = 'YES';
    }
    $('.etp-quickView-switch .swatch-opt-wrapper').append('<div class="selector-wrapper onlycolorvarient varient-box-style '+switch_ID+' margin-bottom-20 '+wrapperClassName+'" style="display: none;"><strong>'+option_title+':</strong><ul class="list-inline margin-top-5 '+add__class_to_ul+'"></ul></div>');

    var total__options =  $(this).siblings('#etp-quickView-select').children('option').length;

    if(total_option_list == 1)   
    {     
      var first_option_label_name = options[0].name;
      first_option_label_name =  first_option_label_name.toLowerCase()
      $(this).siblings('#etp-quickView-select').children('option').each(function(i, v){

        var text = '', val = '', select_first = '', dataVal = $(this).attr('data-name');  
        var featured_image = $(this).attr('featured-img');  var belongs_to_options = get_belongs_to_options(dataVal);
        if(featured_image =='' || typeof featured_image == 'undefined') { featured_image = '';}
        if(i == 0){
          select_first = 'active';
        }

        text = $(this).text(); 
        if(text == 'Default Title'){          
          $('#etp-quick-view-dialog .varient-box-style').addClass('hide'); 
        } 

        if(total__options > 1)   
        {
          if(first_option_label_name == 'color' || first_option_label_name == 'colors')
          {  
            if( window.show_product_variant_image == 1 ){   
              $('#etp-quick-view-dialog .'+switch_ID+' ul').append('<li class="'+wrapperUnderLiClassName+' global-popup homepage-popup-11 " data-value="'+ dataVal +'" data-toggle="tooltip" data-placement="top" title="'+ dataVal +'" ><button data-image-url="'+featured_image+'" type="button" id="'+switch_ID+'" data-value="'+ dataVal +'" style="background-size: 100%;background-image: url('+featured_image+');" class="select_options image--code custom-variant-image" data-image-url="'+featured_image+'" ><i class="fa fa-check-square"></i><span></span></button><span style="display:none;visibility:hidden;opacity:0;" class="belong--to" data-attached-variants="">'+belongs_to_options+'</span></li>');  
            }  
            else
            {    
              $('#etp-quick-view-dialog .'+switch_ID+' ul').append('<li class="'+wrapperUnderLiClassName+' global-popup homepage-popup-11 " data-value="'+ dataVal +'" data-toggle="tooltip" data-placement="top" title="'+ dataVal +'" ><button data-image-url="'+featured_image+'" type="button" id="'+switch_ID+'" data-value="'+ dataVal +'" style="background-size: 100%;background-color:'+dataVal+';" class="select_options color--code color--code-condtition custom-variant-image" data-image-url="'+featured_image+'" ><i class="fa fa-check-square"></i><span></span></button><span style="display:none;visibility:hidden;opacity:0;" class="belong--to" data-attached-variants="">'+belongs_to_options+'</span></li>');
              if( !$('#etp-quick-view-dialog .'+switch_ID).hasClass('color--swatch') ){ 
                $('#etp-quick-view-dialog .'+switch_ID).addClass('color--swatch');
              }
            }   
          }       
          else  
          {   
            $('#etp-quick-view-dialog .'+switch_ID+' ul').append('<li class="'+wrapperUnderLiClassName+' global-popup homepage-popup-11 " data-value="'+ dataVal +'"><button data-image-url="'+featured_image+'" type="button" id="'+switch_ID+'" data-value="'+ dataVal +'" style="background-size: 100%;" class="select_options  custom-variant-image" data-image-url="'+featured_image+'" ><i class="fa fa-check-square"></i><span>'+dataVal+'</span></button><span style="display:none;visibility:hidden;opacity:0;" class="belong--to" data-attached-variants="">'+belongs_to_options+'</span></li>');  
          }

        }
      });

      // UPDATE OPTION LABEL //  
      var label_name = data.options[0].name ;
      $(".option-background .etp-quickView-switch .varient-box-style strong").text(label_name+':'); 

      var label_name_lowercase =  label_name.toLowerCase(); add__class_to_ul = 'quick_view--varient--color';
      if(label_name_lowercase == 'color' || label_name_lowercase == 'colors'){  
        $("#etp-quick-view-dialog .option-background .varient-box-style ul").addClass(add__class_to_ul);
      } 

    }       
    else     
    {  

      var is_current_color_option = 'NO';
      $(this).find('select.single-option-selector').children('option').each(function(i, v){
        var option_text = $(this).text();var option_value = $(this).val();   
        var text = '', val = '', select_first = '', dataVal = '', featured_image = '';

        if(i == 0){  select_first = 'active';   }   
        if(label_name_lowercase == 'color' || label_name_lowercase == 'colors'){

          dataVal = $(this).val(); var belongs_to_options = get_belongs_to_options(dataVal);
          $("#etp-quick-view-dialog .option-background .etp-quickView-switch #etp-quickView-select option").each(function(){
            var option_val = $(this).attr('data-name'); 

            if(option_val.indexOf(dataVal) > -1 && featured_image == ''){
              featured_image = $.trim( $(this).attr('featured-img') ); 
              return false;                      
            }
          })  
          var is_current_color_option = 'YES';
        }   
        else
        {   
          featured_image = '';   dataVal = $(this).text(); var belongs_to_options = get_belongs_to_options(dataVal);
          if(text == 'Default Title'){ $('#etp-quick-view-dialog .varient-box-style').addClass('hide');  }
        }    
        var dataValsafe = '';
        if(featured_image == ''){dataValsafe=dataVal;}  
        if(total__options > 1)
        {      
          if( window.show_product_variant_image == 1 ){           
            $('#etp-quick-view-dialog .'+switch_ID+' ul').append('<li class="'+wrapperUnderLiClassName+' homepage-popup-11 image--code" data-value="'+ dataVal +'"><button data-image-url="'+featured_image+'" type="button" id="'+switch_ID+'" data-value="'+ dataVal +'" style="background-size: 100%;background-image: url('+featured_image+');" class="select_options  custom-variant-image" data-image-url="'+featured_image+'" ><i class="fa fa-check-square"></i><span>'+dataValsafe+'</span></button><span style="display:none;visibility:hidden;opacity:0;" class="belong--to" data-attached-variants="">'+belongs_to_options+'</span></li>');
          }    
          else
          {     
            if( is_current_color_option == 'YES' ){ 
              var option_value_color_code = option_value;
            } 
            else{
              var option_value_color_code = '';
            } 

            if(label_name_lowercase == 'color' || label_name_lowercase == 'colors'){  
              $('#etp-quick-view-dialog .'+switch_ID+' ul').append('<li class="'+wrapperUnderLiClassName+' homepage-popup-11 color--code '+label_name_lowercase+'" data-value="'+ dataVal +'" data-toggle="tooltip" data-placement="top" title="'+ dataVal +'" ><button data-image-url="'+featured_image+'" type="button" id="'+switch_ID+'" data-value="'+ dataVal +'" style="background-size: 100%;background-color:'+option_value_color_code+';" class="select_options  custom-variant-image" data-image-url="'+featured_image+'" ><i class="fa fa-check-square"></i><span>'+dataValsafe+'</span></button><span style="display:none;visibility:hidden;opacity:0;" class="belong--to" data-attached-variants="">'+belongs_to_options+'</span></li>');
            }
            else
            {  
              $('#etp-quick-view-dialog .'+switch_ID+' ul').append('<li class="'+wrapperUnderLiClassName+' homepage-popup-11 '+label_name_lowercase+'" data-value="'+ dataVal +'" ><button data-image-url="'+featured_image+'" type="button" id="'+switch_ID+'" data-value="'+ dataVal +'" style="background-size: 100%;background-color:'+option_value_color_code+';" class="select_options  custom-variant-image" data-image-url="'+featured_image+'" ><i class="fa fa-check-square"></i><span>'+dataValsafe+'</span></button><span style="display:none;visibility:hidden;opacity:0;" class="belong--to" data-attached-variants="">'+belongs_to_options+'</span></li>');
            }  
            if( !$('#etp-quick-view-dialog .'+switch_ID).hasClass('color--swatch') && is_current_color_option == 'YES' ){     
              $('#etp-quick-view-dialog .'+switch_ID).addClass('color--swatch');          
            }  
          }     
        }    
      });      
      $('#etp-quick-view-dialog .option-background .etp-quickView-switch').show();     
    }

    if(data.options[0].values[0] == 'Default Title'){
      $('#etp-quick-view-dialog .option-background .etp-quickView-switch').hide();       
    }
    else {    
      $('#etp-quick-view-dialog .option-background .etp-quickView-switch').show();
    } 
    zx++;
  });

  for ( var i = 0; i < 4; i++ ) {
    quickViewSlider += '<li><a href="#" class="etp-quickView-sliderZoom" data-zoom-image="'+ Shopify.resizeImage(images[i], "grande") +'"><img src="'+ Shopify.resizeImage(images[i], "compact") +'" alt="" /></a></li>';
  }
  productSlider.html(quickViewSlider); 

  /*********************** UPDATE FIRST VARIANT OPTION NAME OR TEXT BLOCK START HERE **************************/
  var total_selector_wrapper = $("#etp-quick-view-dialog .option-background .select .selector-wrapper").length;
  if(total_selector_wrapper == 1)
  {
    var total_selector_wrapper_options = $("#etp-quick-view-dialog .option-background .select .selector-wrapper select option").length;
    if(total_selector_wrapper_options > 1)
    {
      // display the  default titile and value of default variant of product or product that have only one default variant

      var first_select_option_text = '<label for="etp-quickView-select-option-0">'+options[0].name+'</label>';
      $("#etp-quick-view-dialog .option-background .select .selector-wrapper").prepend(first_select_option_text);
    }
    else
    {
      $("#etp-quick-view-dialog .option-background .select .selector-wrapper").hide();  
    }
  }
  /*********************** UPDATE FIRST VARIANT OPTION NAME OR TEXT BLOCK END HERE **************************/

  var country_name = $("#geo--location--country-name--container input").val(); 
  
  // ACTIVATE FIRST OPTION OF EACH OPTIONLIST BLOCK START HERE
  if( $('#etp-quick-view-dialog .option-background .varient-box-style ul li button').length > 0 )
  {
    $("#etp-quick-view-dialog .option-background .varient-box-style").each(function(){
      $(this).find('ul').find('li:first-child').children('button').click(); 
    })
  }      
  // ACTIVATE FIRST OPTION OF EACH OPTIONLIST BLOCK END HERE 
  var hierarcy_root = $('#etp-quick-view-dialog .option-background .etp-quickView-swatch .swatch-opt-wrapper');
  soldOutProducts(data); // MANAGE SOLDOUT AND AVAILABLE PRODUCTS .
  checkQuickViewProductViewing(data) // MANAGE PRODUCTS VIEWING MODULE . 
  update_color_swatches() // UPDATE COLOR SWATCHES COLOR.
  reinitilize_tooltip();
  active_firststyle_if_only_reviews_exists(); 
  run__countdown(thisData);
  setTimeout(function(){ activate_available_variants(hierarcy_root); },200);
  manage_buttons_popup();
  
}

/************************* CHANGE IMAGE ON POPUP-HOMEPAGE VARIENT BUTTON CLICK BLOCK START HERE *******************************/

$('body').on('click', '#etp-quick-view-dialog .second-varient-option-block .option-background .etp-quickView-switch ul li button', function(){

  

  var current_img_url = $(this).attr('data-image-url'); 
  var is_value_exists = 'NO';
  if(current_img_url != '' && current_img_url != 'undefined' && current_img_url != null)
  {  
    current_img_url = current_img_url.split('https:');
    current_img_url = current_img_url[1]; var index =0; 
    var fotoramaApi = $('#etp-quick-view-dialog .single-variants-product .fotorama').data('fotorama');
    $('#etp-quick-view-dialog .fotorama__nav-wrap .fotorama__nav .fotorama__nav__shaft .fotorama__nav__frame').each(function(){
      var color_swatch_thumb = $(this).find('img').attr('src');
      if(color_swatch_thumb != '' && typeof color_swatch_thumb !== 'undefined'){ 
        if(color_swatch_thumb == current_img_url){
          is_value_exists = 'YES';
          fotoramaApi.show(index);
        } 
      }
      index++;
    });  
  }

  

})   

$(".single--product-show-up .varient-id--options").change(function(){  
  var img_src ; var currentRoot = $(this).parents('.single--product-show-up'); var currentThis = $(this);
  var image_path = $.trim(currentRoot.find('.varient-id--options').find('option:selected').attr('data-img-src'));
  var org_image_path = image_path;
  // image_path = image_path.split('?v=');  image_path = image_path[0];
  image_path = image_path.split('_');  image_path = image_path[0];
  var is_sticky_there = $(".sticky-add-to-cart .left-area .product-img-top img").length;
  if(is_sticky_there > 0){ $(".sticky-add-to-cart .left-area .product-img-top img").attr('src',org_image_path); }
  var index = 0;        

  var totalimg = currentThis.parents('.etp-product').find('.fotorama').find('.fotorama__nav-wrap').find('.fotorama__nav__frame').find('.fotorama__img').length;

  
  currentThis.parents('.etp-product').find('.fotorama').find('.fotorama__nav-wrap').find('.fotorama__nav__frame').find('.fotorama__img').each(function(){

    img_src =$.trim( $(this).attr('src') );
    img_src = img_src.split('_');  img_src = img_src[0];
    if(image_path == img_src)                   
    {    
      var fotoramaApi = currentThis.parents('.etp-product').find('.fotorama').data('fotorama'); 
      fotoramaApi.show(index); return false;   
    } 
    index++;
  })     
              
})  


$('body').on('change', '#etp-quick-view-dialog .modal--varient-id--options', function() {
  var img_src ;
  var image_path = $.trim( $('#etp-quick-view-dialog .modal--varient-id--options option:selected').attr('featured-img') );
  image_path = image_path.split('https:'); image_path = image_path[1];
  var index = 0; 
  $("#etp-quick-view-dialog .fotorama__nav-wrap .fotorama__nav__frame .fotorama__img").each(function(){

    img_src =$.trim( $(this).attr('src') );
    if(image_path == img_src) {    
      var fotoramaApi = $('#etp-quick-view-dialog .fotorama').data('fotorama');
      fotoramaApi.show(index); } 
    index++;
  })  
});
 
/************************* CHANGE IMAGE ON POPUP-HOMEPAGE VARIENT BUTTON CLICK BLOCK START HERE *******************************/

/*******************************************************************************
 * Listen For The JQuery Ready Event On The Document
 *******************************************************************************/
$(function() {
  /*******************************************************************************
     * All Animation Load
     *******************************************************************************/
  //etpAnimation($('.etp-animation'));
  /***************************************************************************************
     * Compare List
     ***************************************************************************************/compareListCount();
  compareListEmpty();
  compareListDone();$(document).on("click", ".etp-add-to-compare", function(p) {      
    p.preventDefault(); var variantId = '';
    var dataHandle = $(this).attr('data-handle'); var product__image =''; 
    $('#etp-ajax-success-message--Wishlist .etp-recentView-dialog .whislist-related--product-container').hide();

    if( $(this).hasClass('recently-viewed-clickable-btn') ){   

      product__image = $(this).parents('.etp-product').find('.recently-view-product-feature-image').find('img.etp-product-image').attr("data-featured-img-src");   
    }
    else if( $(this).hasClass('search-etp-add-to-compare') ){  

      var variantId = $(this).attr('data-varient-id');     
      product__image = $(this).attr('data-featured-img-src');   
    }
    else if( $(this).hasClass('single-product-full-detail') ){   

      var variantId = $(this).parents('.product-detail--full--11').find('.option-background').find('.varient-id--options').find('option:selected').val();
      product__image = $(this).parents('.product-detail--full--11').find('.option-background').find('.varient-id--options').find('option:selected').attr('featured-img');
    }
    else if( $(this).hasClass('homepage-singleproduct--addtocompare-btn') ){  

      var variantId = $(this).parents('.etp-product').find('.homepage-singleproduct--varient-id--options').find('option:selected').val();
      product__image = $(this).parents('.home--page-single-product--container').find('.homepage-singleproduct--varient-id--options').find('option:selected').attr('featured-img');
    }
    else if( $(this).hasClass('product--also--bought') ){        

      var variantId = $(this).parents('.etp-product').find('.relatedproduct--option--variant--container').find('option:selected').val();
      if( $(this).parents('.etp-product').find('.product--featured--image').length > 0 ){ 
        product__image = $(this).parents('.etp-product').find('.product--featured--image').attr('data-product-featured-img'); 
      }
      else{
        product__image = $(this).parents('.etp-product').find('.option-background').find('.modal--varient-id--options').find('option:selected').attr('featured-img');
      }

    }


    else  if( $(this).hasClass('product--snippet--addtocompare') )   
    {  
      if( $(this).parents('.second-varient-option-block').length > 0 )    
      {
        var variantId = $(this).parents('.etp-product').find('.option-background').find('.modal--varient-id--options').find('option:selected').val();
        product__image = $(this).parents('.etp-product').find('.option-background').find('.modal--varient-id--options').find('option:selected').attr('featured-img');
      }   
      else  
      {
        var variantId = $(this).parents('.etp-product').find('.single_products_options').find('.product--option--variant--container').find('.varient-id--options').find('option:selected').val();
        product__image = $(this).parents('.etp-product').find('.single_products_options').find('.product--option--variant--container').find('.varient-id--options').find('option:selected').attr('featured-img');

      } 
    }
    else
    {    
      product__image = $(this).parents('.etp-product').find('.product--featured--image').attr("data-product-featured-img"); 
    }      

    compareListRecord(dataHandle); 
    var successVar = {  
      image: product__image,
      message: '<i class="fa fa-check"></i> '+window.dialogCompare,
      buttonText: ''+window.dialogCompareBtn,
      buttonLink: '/pages/'+window.comparePage, 
      productName: $(this).parents('.etp-product').find('.etp-product-title').text(),
      collectionListName: $(this).attr('collection-title'),
      variantId: variantId 
    };
    showSuccessMessageForWhislist(successVar);compareListCount();});

  $(document).on("click", ".etp-compare-done", function(p){
    p.preventDefault();
    if(window.comparePage == ''){
      var message = '<i class="fa fa-info-circle font-size-16"></i> This product already in your Wishlist List. To view Wishlist product please select Wishlist page from <a href="/admin/themes">theme option</a>';
    }else {
      var message = '<i class="fa fa-info-circle font-size-16"></i> This product already in your Wishlist List. Please check Wishlist page <a href="/pages/'+window.comparePage+'">Here</a>';
    }
    showCommonMessage(message);
  });
  $(document).on("click", ".etp-compare-remove", function(p) {
    p.preventDefault();
    Shopify.etpCookie.removeItem($(this).attr('data-handle'), {cookieName: "etp_cookieName_compare"});
    $(this).parents('.etp-product').fadeOut();compareListEmpty();
    compareListCount();});
  $(document).on('click', '.etp-compare-null', function(p) {
    p.stopPropagation();
    var message = '<i class="fa fa-info-circle font-size-16"></i> Please select Wishlist Page from <a href="/admin/themes">theme option</a>';
    showCommonMessage(message);
  });
  /***************************************************************************************
     * Add To Cart Option
     ***************************************************************************************/
  cartEmptyOrNot();

  $(document).on("click", ".etp-add-to-cart", function(p) { 
    //var currencyCode = $(".header--currency--block-11 .dropdown button .etp-currency-text").text();
    var currencyCode = window.shop_currency;

    var redirectTo = ''; var currentParentThis = $(this);  
    if(window.act_popup == false || window.act_popup == 'false'){ redirectTo = '/cart'; }    
    $(this).addClass('loader_running'); $('body').addClass('hide_addtocart__big_loader');  window.currentThis = $(this);
    p.preventDefault(); var selected_featured_image_src =''; var choose_quantity = 1;
    var total_images = $(this).parents('.etp-product').find('.option-background').find("#etp-quickView-select").find('option').length;
    var variant_id =''; var productPrice = '' ; var productName = ''; var productType = '';

    if( $(this).hasClass('modal-btn--belong') )
    {
      if(selected_featured_image_src == '' || typeof selected_featured_image_src == 'undefined'){
        selected_featured_image_src = $(this).parents('.overflow-h.position-r').children('a').find('img.lazyautosizes.lazyloaded').attr("src");
      }

      selected_featured_image_src = $(this).parents('.etp-product').find('.option-background').find("#etp-quickView-select").find('option:selected').attr("featured-img");
      if(selected_featured_image_src == '' || typeof selected_featured_image_src == 'undefined'){
        selected_featured_image_src = $("#etp-quickView-featureImage .fotorama__wrap .fotorama__nav-wrap .fotorama__nav__shaft .fotorama__nav__frame").first().find('img').attr("src");
      }    
      variant_id = $(this).parents(".second-varient-option-block").find('.option-background').find('.modal--varient-id--options').find('option:selected').val();
      productPrice = $(this).parents(".second-varient-option-block").find('.option-background').find('.modal--varient-id--options').find('option:selected').attr('variant-price'); 
      productName = $(this).parents('.second-varient-option-block').find('#etp-quickView-title').find('a').text();  
      //     productType = $(this).parents('.etp-product').find('.product--option--variant--container').find('.varient-id--options').find('option:selected').attr('product-type');

    }  
    else if($(this).hasClass('search-etp-add-to-cart')) 
    { 
      selected_featured_image_src = $(this).attr("data-featured-img-src");
      variant_id = $(this).attr("data-varient-id"); 
    } 
    else if($(this).hasClass('product-page--addd-to--cart')) 
    {
      selected_featured_image_src = $(this).parents(".product-detail--full--11").find('.option-background').find('select#product-select').find('option:selected').attr("data-img-src");
      variant_id = $(this).parents(".product-detail--full--11").find('.option-background').find('select#product-select').find('option:selected').val();
      productPrice = $(this).parents(".product-detail--full--11").find('.option-background').find('select#product-select').find('option:selected').attr('product-price');
      productName = $(this).parents(".product-detail--full--11").find('.option-background').find('select#product-select').find('option:selected').attr('product-name');
      productType = $(this).parents(".product-detail--full--11").find('.option-background').find('select#product-select').find('option:selected').attr('product-type');

    }
    else if($(this).hasClass('buttonAddToCartTop'))  
    {
      selected_featured_image_src = $('.varient-id--options').find('option:selected').attr("data-img-src");
      variant_id = $('.varient-id--options').find('option:selected').val();
    }
    else if($(this).hasClass('single--product--homepage--addtocart'))                    
    {       
      selected_featured_image_src = $(this).parents('.home--page-single-product--container').find('.homepage-singleproduct--varient-id--options').find('option:selected').attr("data-img-src");
      variant_id = $(this).parents('.home--page-single-product--container').find('.homepage-singleproduct--varient-id--options').find('option:selected').val();
    }
    else if( $(this).parent('div.etp-product-cart-con').hasClass('product--snippets--homepage-mob-view') )  
    {
      selected_featured_image_src = $(this).parents('div.etp-product').find('.product--images--container').find('.product--featured--image').attr("data-product-featured-img");
      variant_id = $(this).attr('data-varient-id');        
    }      
    else if($(this).parent('div.etp-product-cart-con').hasClass('related--product--mob-view'))  
    {
      selected_featured_image_src = $(this).parent('div.etp-product-cart-con').siblings('.relatedproduct--option--variant--container').find('option:selected').attr("data-img-src");
      variant_id = $(this).parent('div.etp-product-cart-con').siblings('.relatedproduct--option--variant--container').find('option:selected').val();
    }
    else if($(this).hasClass('single--variant'))  
    {
      // console.log('single variant -- hit');
      selected_featured_image_src = $(this).parents('.etp-product').find('.product--images--container').find('.product--featured--image').attr("data-product-featured-img");
      var variantImgSrc =productType = $(this).parents('.etp-product').find('.product--option--variant--container').find('.varient-id--options').find('option:selected').attr('featured-img');
      if($.trim(variantImgSrc) != ''){ selected_featured_image_src = variantImgSrc; }
      variant_id = $(this).attr('data-varient-id');
      productPrice = $(this).parents('.etp-product').find('.product--option--variant--container').find('.varient-id--options').find('option:selected').attr('product-price');
      productName = $(this).parents('.etp-product').find('.product--option--variant--container').find('.varient-id--options').find('option:selected').attr('product-name');
      productType = $(this).parents('.etp-product').find('.product--option--variant--container').find('.varient-id--options').find('option:selected').attr('product-type');
    }
    else if($(this).hasClass('self-id-container'))           
    {   
      selected_featured_image_src = $(this).parents('.etp-product').find('.product--images--container').find('.product--featured--image').attr("data-product-featured-img");
      variant_id = $(this).attr('data-varient-id');

      if( $(this).hasClass('upsell-addToCart') ) {  
        redirectTo = '/cart';
        productPrice = $(this).parents(".etp-product").find('.upsell-product--option--variant--container').find('.varient-id--options').find('option:selected').attr('product-price'); 
        productName = $(this).parents(".etp-product").find('.upsell-product--option--variant--container').find('.varient-id--options').find('option:selected').attr('product-name'); 
        productType = $(this).parents(".etp-product").find('.upsell-product--option--variant--container').find('.varient-id--options').find('option:selected').attr('product-type');

      }  

    }
    else
    {  
      // selected_featured_image_src = $(this).parents('.overflow-h.position-r').children('a').find('img.inactive-product').attr("src");
    } 

    productPrice = productPrice / 100;
    var productCollectionList = currentParentThis.parents('.etp-product').find('.second-varient-option-block').find('#etp-quickView-title').attr('product-collection');
    if(typeof productCollectionList == 'undefined' || productCollectionList == '' || productCollectionList == null){
      var productCollectionList = $.trim( currentParentThis.attr('collection-title') );
    }  

    var element_path = '#etp-ajax-success-message .related--product-container .slide_popup_list-related-product .swiper-wrapper';
    var color_swatch_path = '#etp-ajax-success-message .related--product-container .product--snippet .product-title-price .single_products_options .selector-wrapper div[swatch-type="color"] ul li';
    var wrapup_path = "#etp-ajax-success-message .related--product-container .slide_popup_list-related-product .swiper-wrapper .product--snippet";
    var slider_path = '.swiper-container.slide_popup_list-related-product';
    if(redirectTo == '') {
      get_particular_collection_products(productCollectionList,element_path,color_swatch_path,wrapup_path,slider_path);  
    }
    var successVar = {
      // image: $(this).parents('.etp-product').find('.etp-product-image').attr("src"),
      image:selected_featured_image_src ,
      message: '<i class="fa fa-check"></i> '+window.dialogCart,
      buttonText: ''+window.dialogCartBtn,  
      buttonLink: '/cart',     
      productName: $(this).parents('.etp-product').find('.etp-product-title').text()
    },
        quantity =  parseInt($(this).attr('data-item-quantity')),
        id = variant_id ;  var currentThis = $(this); 

    try{
      if(productName != '' && productPrice != ''){
        fbq('track', 'AddToCart', {
          content_ids: variant_id,
          content_name: productName,
          content_type: 'product',
          currency:currencyCode,
          value: productPrice,
          num_items: quantity 
        });
      }
    }
    catch(err) {
      console.log('Error fbq'+err.message);
    }
    ajaxAddToCart2(id, quantity,currentThis).done(function() {

      if(redirectTo != '') {     
        window.location.href = '/cart';
      }    
      else     
      {
        $('#etp-quick-view-dialog .modal-body .close').click();          
        hideLoading();        
        ajaxDropdownCart();

        var is_upsell_exist= $("#upsell--modal-block .login-back .row .product-widget .etp-product").length ;
        if( ( is_upsell_exist > 0  ) && ( currentParentThis.hasClass('product-page--addd-to--cart') ) ) {  
          $("#upsell--modal-block").show().addClass('in'); $('body').addClass('modal-open');
        }   
        else {     
          showSuccessMessage(successVar);
        }  

        window.currentThis.removeClass('loader_running');
        $('body').removeClass('hide_addtocart__big_loader');
      }

    });  

  });


  $(document).on("click", ".etp-buy-now", function(p) {
    p.preventDefault();
    var quantity = parseInt($(this).attr('data-item-quantity')),
        id = $(this).attr('data-varient-id');
    ajaxAddToCart(id, quantity).done(function() {
      window.location.href = "/checkout";
    });
  });
  $(document).on("click", ".cart-menu-item-remove", function(p) {
    p.preventDefault();
    var id = $(this).attr('data-varient-id');
    Shopify.removeItem(id, function(data) {              
      updateDropdownCart(data);
    });
  });
  /***************************************************************************************
     * Instant Search 
     ***************************************************************************************/

  function searchPages(query)
  { 

    $('.search-loading').show();
    $('.instant-search-data').show();

    var myurl = '/search?type=page&q='+query;  
    $.ajax({
      type: 'GET',
      url: myurl,
      dataType: "html",
      success: function(resultData) {
        var required_data =  $(resultData).find('.search--result--as--json--custom').html(); var cartItemList = ''; 
        if(required_data != '' && typeof required_data !== 'undefined')  
        {
          var parsed_json  = JSON.parse(required_data); 
          for (var i = 0; i < parsed_json.pagesList.length; i++) {  
            var page_title = parsed_json.pagesList[i].itemTitle;  var page_url = parsed_json.pagesList[i].itemUrl;
            cartItemList += '<li><a href="'+page_url+'"><div class="pull-left"><p class="product-title">'+ page_title +'</p></div></a></li>';
          }
        }
        $('.search-loading').hide();   
        $('.instant-search-data').show(); 
        $('.instant-search-data ul').html(cartItemList);
      },
      error: function(xhr, status, error) {
        var err = eval("(" + xhr.responseText + ")");
        alert(err.Message);
      }
    });

  }

  function searchArticles(searchData){

    $('.search-loading').show();
    $('.instant-search-data').show();

    var myurl = '/search?type=article&view=json&q='+searchData;     
    $.ajax({
      type: 'GET',
      url: myurl,
      dataType: "json",
      success: function(resultData) { 
        var cartItemList = '';
        if(resultData.length > 0)  
        {  
          for (var i = 0; i < resultData.length; i++) {  
            var blog_title = resultData[i].title;  var blog_url = resultData[i].handle;  var blog_img_src = resultData[i].image.src; var blog_img_alt = resultData[i].image.alt;
            cartItemList += '<li><a href="/blogs/news/'+ blog_url +'"><div class="pull-left"><img src="'+ Shopify.resizeImage(blog_img_src, "70x70") +'" alt="'+blog_img_alt+'"></div><div class="pull-left"><p class="product-title">'+ blog_title +'</p></div></a></li>';
          }
        }
        $('.search-loading').hide();   
        $('.instant-search-data').show(); 
        $('.instant-search-data ul').html(cartItemList); 
      },
      error: function(xhr, status, error) {
        var err = eval("(" + xhr.responseText + ")");
        alert(err.Message);
      }
    });

  }

  $(document).on("input", ".header--instant-search", function(p) {

    var choose_action = $(".search--form--hit--action .header-search-input").val();
    p.preventDefault();
    var searchData = $(this).val();
    $('.search-loading').hide();
    $('.instant-search-data ul').html('');

    if(choose_action == 'page')
    {
      searchPages(searchData);     
    }
    else if(choose_action == 'article')
    {
      searchArticles(searchData);
    }    
    else
    {
      var shopCurrencyLowerCase = window.shopCurrency.toLowerCase();

      ajaxInstantSearch(searchData).done(function(data) {

        var cartItemList = ''; var product__price = 0; var product_compare__price = '';
        for (var i = 0; i < data.length; i++) {
          product_compare__price = Shopify.formatMoney(data[i].compare_at_price, window.money_format);
          product__price = Shopify.formatMoney(data[i].price, window.money_format);
          if(data[i].compare_at_price > data[i].price)  
          {
            cartItemList += '<li><a href="/products/'+ data[i].handle +'"><div class="pull-left"><img src="'+ Shopify.resizeImage(data[i].featured_image, "70x70") +'" alt=""></div><div class="pull-left"><p class="product-title">'+ data[i].title +'</p><p><del><span class="money compare__at__price" data-currency-'+shopCurrencyLowerCase+'="'+product_compare__price+'" >'+product_compare__price+'</span></del></p><p><span class="money" data-currency-'+shopCurrencyLowerCase+'="'+ product__price +'" >'+ product__price +'</span></p></div></a></li>';
          }
          else
          {
            cartItemList += '<li><a href="/products/'+ data[i].handle +'"><div class="pull-left"><img src="'+ Shopify.resizeImage(data[i].featured_image, "70x70") +'" alt=""></div><div class="pull-left"><p class="product-title">'+ data[i].title +'</p><p><span class="money" data-currency-'+shopCurrencyLowerCase+'="'+product__price+'" >'+product__price+'</span></p></div></a></li>';
          }
        }
        $('.search-loading').hide();   
        $('.instant-search-data').show(); 
        $('.instant-search-data ul').html(cartItemList);
        setTimeout(function(){ re_initilize_currency() },500) ;
      });

    }
  });

  $(document).ready(function(){
    /*****************change option to according last selected block start here *****************************/
    var choose_action = $(".search--form--hit--action .header-search-input").val();
    $("#search--option--list-menu li a[data-value='"+choose_action+"']").click(); 
    /*****************change option to according last selected block end here *****************************/
  })

  $('body').bind('click', function(){
    $('.instant-search-data').hide();
    $('.search-loading').hide(); 
  });
  /***************************************************************************************
     * Filter
     ***************************************************************************************/
  filterDefaultData();
  $(document).on("click", ".etp-filter-category", function(p) {
    p.preventDefault();
    var thisData = $(this),
        url = filterCategoryUrl(thisData);
    ajaxGetData(url).done(function(data) {
      hideLoading();
      urlPushState(url);
      filterUpdate(data);

    });
  });
  $(document).on("change", ".etp-sort-by", function() {
    var thisData = $(this),
        url = filterSortByUrl(thisData);
    ajaxGetData(url).done(function(data) {
      hideLoading();
      urlPushState(url);
      filterUpdate(data);

    });
  });
  $(document).on("click", ".etp-list-grid:not(.active)", function() {
    var thisData = $(this),
        url = filterGridListUrl(thisData);
    ajaxGetData(url).done(function(data) {
      hideLoading();
      urlPushState(url);
      filterUpdate(data);

    });
  }); 
  $(document).on("click", ".etp-filter-checkbox", function() {
    var thisData = $(this),
        url = filterCheckBox(thisData);
    ajaxGetData(url).done(function(data) {
      reinitilize_tooltip();
      hideLoading();    
      urlPushState(url);
      filterUpdate(data);  
    }); 				 
  }); 
  /*******************************************************************************
     * Welcome Newsletter
     *******************************************************************************/
  //if($.cookie("welcome_newsletter") == null) {
  //    $('#etp-welcome-newsletter').modal('show');   
  // }   
  $(document).on("click", "#etp-welcome-newsletter .close , #etp-welcome-newsletter ", function(p) {
    p.preventDefault();
    $.cookie("welcome_newsletter", "no");  
  });
  //if($.cookie("coupon_dailog") == null) {
  //   $('#etp-coupon-dailog').modal('show');
  // }
  $(document).on("click", "#etp-coupon-dailog .close,#etp-coupon-dailog ", function(p) {
    p.preventDefault();
    $.cookie("coupon_dailog", "no");
  });
  if($.cookie("welcome_notification") == null) {
    $('.notification-message').show();
  }
  $(document).on("click", ".notification-message-close", function(p) {
    p.preventDefault();
    $.cookie("welcome_notification", "no");
    $('.notification-message').fadeOut();
  });
  /*******************************************************************************
     * Custom Dom Load Class
     *******************************************************************************/
  $(".etp-dom-ready").show();
  /*******************************************************************************
     * Mobile Sidebar Click Event
     *******************************************************************************/
  $(document).on('click', '.bars', function(p) {
    p.stopPropagation();
    $(".sidebar").show("slow");
    $(".fa-plus-circle").hide();
    $(".fa-minus-circle").show();
    $(this).addClass('barclose').removeClass('bars');
  });
  $(document).on('click', '.barclose', function(p) {
    p.stopPropagation();
    $(".fa-minus-circle").hide();
    $(".fa-plus-circle").show();
    $(this).addClass('bars').removeClass('barclose');
    $(".sidebar").hide("slow");
    $('html, body').animate({scrollTop : 0},800);
    return false;
  });
  /*******************************************************************************
     * Search functionality
     *******************************************************************************/
  var url = document.location.href,
      urlSplit = url.split('&');
  if (urlSplit[1]){
    var type = urlSplit[1].substr(urlSplit[1].lastIndexOf('=') + 1);
    if (type == 'product'){
      $('#search_concept').text('All Categories');
      $('.header-search-input').attr('value', 'product');
    } else if (type == 'page') {
      $('#search_concept').text('Pages');
      $('.header-search-input').attr('value', 'page');
    } else if (type == 'article') {
      $('#search_concept').text('Articles');
      $('.header-search-input').attr('value', 'article');
    }
  }
  $(document).on('click', '.header-search a', function() {
    var value = $(this).attr('data-value'),
        text = $(this).text();
    $('#search_concept').text(text);
    $(this).parents('form').find('#search_concept').text(text); 
    $('.header-search-input').attr('value', value);  
  });
});
/*******************************************************************************
 * Listen When The Document Full Load
 *******************************************************************************/
$(document).ready(function() {
  /*******************************************************************************
     * Get Geo location information
     *******************************************************************************/
  $.getJSON('//ipapi.co/json/', function(location) {
    // $('.geo-country').html(location.country_name);
    var country_name = location.country_name ;
    $("#geo--location--country-name--container #current---country--name").val(country_name);

    if( $(".current-shipping--country .free-ship p").length > 0 ){
      $(".current-shipping--country .free-ship p").html($(".current-shipping--country .free-ship p").html().replace("Country","<span class='country_letter_decision'>"+location.country_name+"</span>"));
    }

    // CHANGE GEO LOCATION ON HOMEPAGE IN SECTION OF SINGLE PRODUCT
    if( $(".homepage-single--product-geo .free-ship p").length > 0 ){
      $(".homepage-single--product-geo .free-ship p").html($(".homepage-single--product-geo .free-ship p").html().replace("Country","<span class='country_letter_decision'>"+location.country_name+"</span>"));
    }

    $(".geo--text--block .geo-text").html($(".geo--text--block .geo-text").html().replace("Country","<span class='country_letter_decision'>"+location.country_name+"</span>"));
    

  });
  /*******************************************************************************
     * Tool Tips
     *******************************************************************************/
  if($('[data-toggle="tooltip"]').length) {   
    $('[data-toggle="tooltip"]').tooltip();
  }
  /***************************************************************************************
     * Modal Dialog (Quick View, Success Message, Welcome Newsletter, Error Massage)
     ***************************************************************************************/
  $(document).on('click', '.etp-quick-view', function(p) {
    p.preventDefault();
    $("#etp-ajax-success-message--Wishlist .modal-body .close").click();  
    $("#etp-ajax-success-message .modal-body .close").click();
    $('#etp-quick-view-dialog .modal-product--option-blueprint').attr('data-initilize-process-done','');  

    $('#etp-quick-view-dialog .etp-quickView-single-quantity').val(1);
    $('#etp-quick-view-dialog .etp-product .images--container-ftrama-11').addClass('loading');

    var thisData = $(this),
        url = '/products/'+ thisData.attr('data-handle') +'.js';   
    ajaxGetData(url, 'json').done(function(data) {
      quickView(data, thisData);
      if(window.optionSwitchDropdown == '2'){
        $('.etp-quickView-options').show();
      }else {
        $('.varient-box-style').show();  
      }
      hideLoading();
      $('#etp-quick-view-dialog').modal('show');
    });
  }); 
  $(document).on("click", ".etp-quickView-quantity-group .input-group-addon", function() {
    var t = $(this).attr("data-direction"),
        n = $(this).parent().children('input[type="text"]'),
        i = n.val();
    if ("up" == t){
      i++;
      n.val(i);
    } else if ("down" == t) {
      if (1 == i) return;
      i--;
      n.val(i);
    }
    $('#etp-quickView-buttons .etp-add-to-cart').attr('data-item-quantity', n.val());
    $('.action--btn-block .etp-buy-now').attr('data-item-quantity', n.val());
    //subTotal($('.etp-quickView-single-quantity').val(), $('.etp-quickView-default-price .money').text(), $('.etp-quickView-subtotal .money')); 
  });
  // Manage Quantity code start  here
  $(document).on("click", ".product-quantity-group .input-group-addon", function() {
    var dataDirection = $(this).attr("data-direction"),
        quantity = $(this).parent().children('.etp-single-quantity').val();
    if ("up" == dataDirection){ if(quantity >= 1){ quantity++; }else{ quantity = 1; } } 
    else if ("down" == dataDirection){ if(quantity > 1){ quantity--; }else{ quantity = 1; } }
    $(this).parent().children('.etp-single-quantity').val(quantity);
    $('.single-product-buttons .etp-buy-now').attr('data-item-quantity', quantity);
    $('.single-product-buttons .etp-add-to-cart').attr('data-item-quantity', quantity);
  });

  // Run on page load
  var quantity = $('.quantities .etp-quantity-group input.etp-single-quantity').val();
  $('.single-product-buttons .etp-buy-now').attr('data-item-quantity', quantity);
  $('.single-product-buttons .etp-add-to-cart').attr('data-item-quantity', quantity);
  // Manage Quantity code end  here

  $(document).on('click', '.etp-quickView-switch .select_options', function() {
    $(this).parents('ul').find('.select_options').removeClass('active');
    $(this).addClass('active');
    $('.selector-wrapper #'+$(this).attr('id')).val($(this).attr('data-value')).trigger('change');
  });
  $('#etp-quickView-sliderLoad').css('background', 'url('+ window.animationLoading +') 50% 50% no-repeat');
  $(document).on('click', '.etp-quickView-sliderZoom', function(p) {
    p.preventDefault();
    $('#etp-quickView-sliderLoad').show();
    var imageUrl = $(this).attr('data-zoom-image');
    ajaxGetData(imageUrl).done(function() {
      hideLoading();
      $('#etp-quickView-image').attr('src', imageUrl);
      $('#etp-quickView-sliderLoad').hide();
    });
  });
  /***************************************************************************************
     * Home page single product
     ***************************************************************************************/
  $(document).on('click', '.etp-single-sliderZoom', function(p) {
    p.preventDefault();
    $('#etp-quickView-sliderLoad').show();
    var imageUrl = $(this).attr('data-zoom-image');
    ajaxGetData(imageUrl).done(function() {
      hideLoading();
      $('.etp-single-product-image img').attr('src', imageUrl);
      $('#etp-quickView-sliderLoad').hide();
    }); 
  });
  /***************************************************************************************
     * Cart Page
     ***************************************************************************************/

  $(document).on("click", ".etp-cart-page-update", function(p) {
    p.preventDefault();
    var url = $(this).attr('href')+$('.etp-cart-quantity-'+$(this).attr('data-item-id')).val();
    ajaxGetData(url).done(function(data) {
      hideLoading();
      cartPageUpdate(data);
    });
  });
  $(document).on("click", ".etp-cart-page-delete", function(p) {
    p.preventDefault();
    var url = $(this).attr('href');
    ajaxGetData(url).done(function(data) {
      hideLoading();
      cartPageUpdate(data);
    });
  });

  $(document).on("change", ".etp-cart-quantity-update", function(p) {
    p.preventDefault();
    var url = $(this).attr('data-href')+$('.etp-cart-quantity-'+$(this).attr('data-item-id')).val();
    ajaxGetData(url).done(function(data) {
      hideLoading();
      cartPageUpdate(data);
    });
  });

  $(document).on("click", ".cart_quantity_selector_box .cart_minus ,.cart_quantity_selector_box .cart_plus", function(p) {
    var url = $(this).siblings('.etp-cart-quantity-update').attr('data-href')+$('.etp-cart-quantity-'+$(this).siblings('.etp-cart-quantity-update').attr('data-item-id')).val();
    ajaxGetData(url).done(function(data) {
      hideLoading();
      cartPageUpdate(data);
    });
  });

  /***************************************************************************************
     * Back To Top Button
     ***************************************************************************************/
  $(window).scroll(function(){
    if ($(this).scrollTop() > 500) {
      $('#back-to-up').fadeIn();
    } else {
      $('#back-to-up').fadeOut();
    }
  });

  $(document).on('click', '#back-to-up', function(p) {
    $('html, body').animate({scrollTop : 0},800);
    return false;
  });


  /*******************************************************************************
     * IE10 viewport hack for Surface/desktop Windows 8 bug
     *******************************************************************************/
  if (navigator.userAgent.match(/IEMobile\/10\.0/)) {
    var msViewportStyle = document.createElement('style');
    msViewportStyle.appendChild(
      document.createTextNode(
        '@-ms-viewport{width:auto!important}'
      )
    );
    document.querySelector('head').appendChild(msViewportStyle)
  }
  /*******************************************************************************
     * Custom Window Load class
     *******************************************************************************/
  $(".etp-win-ready").show();

  /*******************************************************************************
     * Home slider
     *******************************************************************************/
  var slider_height = $(".main-slide .carousel-inner .item").height();
  $(".main-slide .carousel-inner iframe").height(slider_height);

});

$(document).ready(function(){

  activate_product_page_variant();
  $('body').on('change', '.option-background.product-page-swatches .option-switch-dropdown > .selector-wrapper > .single-option-selector', function() {

    var swatch_value=new Array();

    if( $('.option-background.product-page-swatches .option-switch-dropdown > .selector-wrapper > .single-option-selector').length > 1 )
    {            
      var varient_combi_name = ''; var zx = 0; 
      var total_option_list = $(".option-background.product-page-swatches .option-switch-dropdown > .selector-wrapper > .single-option-selector").length;
      $(".option-background.product-page-swatches .option-switch-dropdown > .selector-wrapper").each(function(){ 

        var current_varient_value = $(this).find('.single-option-selector').val();
        swatch_value[zx] = current_varient_value ;

        if(zx < (total_option_list -1) ){   
          varient_combi_name = varient_combi_name + current_varient_value + ' / ';
        }
        else    
        {
          varient_combi_name = varient_combi_name + current_varient_value ;   
        }
        zx++;    
      });

      if( varient_combi_name.indexOf('null') == -1 ){     

        var varient__id_active = $(".product-page-swatches .varient-id--options option[data-title='"+varient_combi_name+"']").val();
        $(".product-page-swatches .varient-id--options").val(varient__id_active).change();

        // ----------------- ASSIGN VALUES block start here  ------------------  
        var i = 0;
        $(".sticky-add-to-cart .option-switch-dropdown .single-option-selector").each(function(){

          $(this).val(swatch_value[i]);  i++;         
        })
        // ----------------- ASSIGN VALUES block END here  ------------------
      }

    }
    else  
    { 
      var current_varient_value = $.trim( $(this).val() ); 
      var varient__id_active = $(this).parents(".option-background").find(".varient-id--options option[data-title='"+current_varient_value+"']").val();
      $(this).parents(".option-background").find(".varient-id--options").val(varient__id_active).change();
      $(".sticky-add-to-cart .option-switch-dropdown .single-option-selector").val(current_varient_value);
    }   
  })

  /*** CHANGE OPTION OF PRODUCT WHEN WE CHANGE THE PRODUCT OPTION FROM STICKY BLOCK START HERE  ***/

  $('body').on('change', '.sticky-add-to-cart .option-switch-dropdown .single-option-selector', function() {

    var swatch_value=new Array(); var st_zx = 0;   

    $(".sticky-add-to-cart .option-switch-dropdown .single-option-selector").each(function(){ 
      var current_varient_value = $(this).val();
      swatch_value[st_zx] = current_varient_value ;        
      st_zx++; 
    });     

    // ----------------- ASSIGN VALUES block start here  ------------------

    var total_option = $('.option-background.product-page-swatches .varient-box-style .selector-wrapper .swatches-box').length;
    if( total_option > 0 ) 
    { 
      var swatch_index =0;
      $(".option-background.product-page-swatches .varient-box-style .selector-wrapper").each(function(){
        $(this).find(".swatches-box").find('li[data-value="'+swatch_value[swatch_index]+'"] button').click();
        swatch_index++; 
      })  
    }
    else
    {
      var t = 0;
      $(".option-background.product-page-swatches .single-option-selector").each(function(){
        if(  $(this).val() != swatch_value[t] ){      
          $(this).val(swatch_value[t]).change();  
        }                                          
        t++;  
      }) 
    } // end of else block

    // ----------------- ASSIGN VALUES block END here  ------------------
  })

  $(".sticky-add-to-cart .etp-add-to-cart--sticky-btn").click(function(){   
    $(".product-detail--full--11 .product-page--addd-to--cart").click();
  })

  /*** CHANGE OPTION OF PRODUCT WHEN WE CHANGE THE PRODUCT OPTION FROM STICKY BLOCK END HERE  ***/
  /************************** PRODUCT BLOCK START HERE [ CHANGE PRICE,DETAILS,INFO ON VARIANT CHANGE ] ******************************/
  $(".product-page-swatches .option-switch-dropdown .varient-id--options").change(function(){    

    var prod_availability = $.trim( $(this).find('option:selected').attr('variant-availability') );  
    var variant_id = $.trim( $(this).find('option:selected').val() );
    var product_handle = $.trim( $(this).find('option:selected').attr('product-handle') );
    var variant_compare_at_price = $.trim( $(this).find('option:selected').attr('product-compare-at-price') );
    var variant_price = $.trim( parseFloat( $(this).find('option:selected').attr('product-price') ) );
    $('.product-detail--full--11 .single-product-buttons #buyNow_btn').attr('data-varient-id',variant_id);
    if(variant_compare_at_price == '' || variant_compare_at_price == null){    
      variant_compare_at_price = 0 ;
    }    
    else    
    {
      variant_compare_at_price = parseFloat( variant_compare_at_price );  
    } 

    var sold__out_html = '<h3 class="margin-top-0 margin-bottom-10 etp-price-preview pull-left sold__out_product">Sold Out</h3>';  
    if(variant_price < variant_compare_at_price)
    {   
      var save_type = $.trim($("#you__save__type_switch").val());             
      var save__price = variant_compare_at_price - variant_price ; 
      var save__price_percentage = ( ( variant_price * 100 ) / variant_compare_at_price ); 
      save__price_percentage = (100 - save__price_percentage).toFixed(2) ;
      save__price_percentage =  Math.round(save__price_percentage);      

      if(save_type == 'percentage'){         

        var inject_html = '<h3 class="margin-top-0 margin-bottom-10 etp-price-preview pull-left">'+
            '<del><span class="money" data-currency-'+window.shopCurrency_in_lowercase+'="'+Shopify.formatMoney(variant_compare_at_price,window.shop_money_format)+'" data-currency="'+window.shopCurrency+'" >'+ Shopify.formatMoney(variant_compare_at_price,window.shop_money_format) +'</span></del>'+
            ' <span class="margin-left-10 etp-default-price etp-default-price-a3">'+
            '<span class="money" data-currency-'+window.shopCurrency_in_lowercase+'="'+Shopify.formatMoney(variant_price, window.shop_money_format)+'" data-currency="'+window.shopCurrency+'">'+ Shopify.formatMoney(variant_price, window.shop_money_format) +'</span></span></h3>'+

            '<div class="save__price_block" style="background-color:#fd992f; color:#ffffff">Save<span class="save__price">'+
            '<span id="totalSaved" class="you--save-money-per" data-save-per="'+save__price_percentage+'" >'+ save__price_percentage +'<span class="per--sign" >%</span></span>'+
            '</span></div>';   
      }

      else if(save_type == 'numeric' ){

        var inject_html = '<h3 class="margin-top-0 margin-bottom-10 etp-price-preview pull-left">'+
            '<del><span class="money" data-currency-'+window.shopCurrency_in_lowercase+'="'+Shopify.formatMoney(variant_compare_at_price,window.shop_money_format)+'" data-currency="'+window.shopCurrency+'" >'+ Shopify.formatMoney(variant_compare_at_price,window.shop_money_format) +'</span></del>'+
            ' <span class="margin-left-10 etp-default-price etp-default-price-a3">'+
            '<span class="money" data-currency-'+window.shopCurrency_in_lowercase+'="'+Shopify.formatMoney(variant_price, window.shop_money_format)+'" data-currency="'+window.shopCurrency+'">'+ Shopify.formatMoney(variant_price, window.shop_money_format) +'</span></span></h3>'+

            '<div class="save__price_block" style="background-color:#fd992f; color:#ffffff">Save<span class="save__price">'+
            '<span id="totalSaved" class="money" data-currency-'+window.shopCurrency_in_lowercase+'="'+Shopify.formatMoney(save__price,window.shop_money_format)+'" data-currency="'+window.shopCurrency+'">'+ Shopify.formatMoney(save__price, window.shop_money_format) +'</span>'+
            '</span></div>';   

      }

      else{

        var inject_html = '<h3 class="margin-top-0 margin-bottom-10 etp-price-preview pull-left">'+
            '<del><span class="money" data-currency-'+window.shopCurrency_in_lowercase+'="'+Shopify.formatMoney(variant_compare_at_price,window.shop_money_format)+'" data-currency="'+window.shopCurrency+'" >'+ Shopify.formatMoney(variant_compare_at_price,window.shop_money_format) +'</span></del>'+
            ' <span class="margin-left-10 etp-default-price etp-default-price-a3">'+
            '<span class="money" data-currency-'+window.shopCurrency_in_lowercase+'="'+Shopify.formatMoney(variant_price, window.shop_money_format)+'" data-currency="'+window.shopCurrency+'">'+ Shopify.formatMoney(variant_price, window.shop_money_format) +'</span></span></h3>' ;

      }

      $('.product-detail--full--11 .price-preview .previewPriceOuter').html(inject_html);
    } else {

      var inject_html = '<h3 class="margin-top-0 margin-bottom-10 etp-price-preview pull-left"><span class="etp-default-price etp-default-price-a1" original-value=""><span class="money" data-currency-'+window.shopCurrency_in_lowercase+'="'+Shopify.formatMoney(variant_price,window.shop_money_format)+'" data-currency="'+window.shopCurrency+'">'+ Shopify.formatMoney(variant_price,window.shop_money_format) +'</span></span></h3><div class="save__price_block" style="background-color:#fd992f; color:#ffffff"></div>';
      $('.product-detail--full--11 .price-preview .previewPriceOuter').html(inject_html);
    }



    if( prod_availability == false || prod_availability == "false" ) {   
      $(".sticky-add-to-cart .prices-top-bar .price-real").html(window.dialogSoldOutBtn);
      // $('.product-detail--full--11 .price-preview .previewPriceOuter').html(sold__out_html);
      $(".sticky-add-to-cart #buttonAddToCartTop").addClass('disabled').html(window.dialogSoldOutBtn);
      $(".sticky-add-to-cart .product_if_available").hide();
      $(".sticky-add-to-cart .product_if_unavailable").show();
      $(".product-detail--full--11 .single-product-buttons .etp-buy-now").addClass('disabled').html(window.dialogSoldOutBtn);
      $(".product-detail--full--11 .single-product-buttons .product-page--addd-to--cart").addClass('disabled').html(window.dialogSoldOutBtn);

    } 
    else                      
    {   
      $('.product-detail--full--11 .single-product-buttons .etp-buy-now').removeAttr("disabled").removeClass('disabled').html(window.dialogBuyNowBtn);
      $('.product-detail--full--11 .single-product-buttons .product-page--addd-to--cart').removeAttr("disabled").removeClass('disabled').html(window.addToCartBtn);
      $('.sticky-add-to-cart #buttonAddToCartTop').removeClass('disabled').html(window.addToCartBtn);
      var price__html = $(".product-detail--full--11 .previewPriceOuter .etp-default-price").html();  
      $(".sticky-add-to-cart .prices-top-bar .price-real").html(price__html); 
      $(".sticky-add-to-cart .product_if_available").show();
      $(".sticky-add-to-cart .product_if_unavailable").hide();   
    } 
    re_initilize_currency();  

  })  

  var currentThis = $(".product-page-swatches .option-switch-dropdown .varient-id--options");   
  var totalVariantsList = $(".product-page-swatches .option-switch-dropdown .varient-id--options option").length;

  var prod_availability = $.trim( currentThis.find('option:selected').attr('variant-availability') );  
  var variant_id = $.trim( currentThis.find('option:selected').val() );
  var product_handle = $.trim( currentThis.find('option:selected').attr('product-handle') );
  var variant_compare_at_price = $.trim( currentThis.find('option:selected').attr('product-compare-at-price') );
  var variant_price = $.trim( parseFloat( currentThis.find('option:selected').attr('product-price') ) );

  if(totalVariantsList == 1){

    if(variant_compare_at_price == '' || variant_compare_at_price == null){    
      variant_compare_at_price = 0 ;
    }    
    else    
    {
      variant_compare_at_price = parseFloat( variant_compare_at_price );  
    } 

    var sold__out_html = '<h3 class="margin-top-0 margin-bottom-10 etp-price-preview pull-left sold__out_product">Sold Out</h3>';  

    if( prod_availability == false || prod_availability == "false" ) {   
      $(".sticky-add-to-cart .prices-top-bar .price-real").html(window.dialogSoldOutBtn);
      // $('.product-detail--full--11 .price-preview .previewPriceOuter').html(sold__out_html);
      $(".sticky-add-to-cart #buttonAddToCartTop").addClass('disabled').html(window.dialogSoldOutBtn);
      $(".sticky-add-to-cart .product_if_available").hide();
      $(".sticky-add-to-cart .product_if_unavailable").show();
      $(".product-detail--full--11 .single-product-buttons .etp-buy-now").addClass('disabled').html(window.dialogSoldOutBtn);
      $(".product-detail--full--11 .single-product-buttons .product-page--addd-to--cart").addClass('disabled').html(window.dialogSoldOutBtn);

    } 
    else                      
    {   
      $('.product-detail--full--11 .single-product-buttons .etp-buy-now').removeAttr("disabled").removeClass('disabled').html(window.dialogBuyNowBtn);
      $('.product-detail--full--11 .single-product-buttons .product-page--addd-to--cart').removeAttr("disabled").removeClass('disabled').html(window.addToCartBtn);
      $('.sticky-add-to-cart #buttonAddToCartTop').removeClass('disabled').html(window.addToCartBtn);
      var price__html = $(".product-detail--full--11 .previewPriceOuter .etp-default-price").html();  
      $(".sticky-add-to-cart .prices-top-bar .price-real").html(price__html); 
      $(".sticky-add-to-cart .product_if_available").show();
      $(".sticky-add-to-cart .product_if_unavailable").hide();   
    } 
    re_initilize_currency();     
  }

  /************* UPDATE BOTTOM sticky-add-to-cart BLOCK PRICE CODE START HERE**********************/

  $('.option-background.product-page-swatches .option-switch-dropdown > .selector-wrapper > .single-option-selector option:first').attr('selected','selected');
  var priceForStickyBottomBar =  '<span class="money" data-currency-'+window.shopCurrency_in_lowercase+'="'+Shopify.formatMoney(variant_price, window.shop_money_format)+'" data-currency="'+window.shopCurrency+'">'+ Shopify.formatMoney(variant_price, window.shop_money_format) +'</span>';
  $('.product-page-section .sticky-add-to-cart .right-area .product_if_available .price-real').html(priceForStickyBottomBar);
  re_initilize_currency();
  /************* UPDATE BOTTOM sticky-add-to-cart BLOCK PRICE CODE END HERE**********************/
  /************************** PRODUCT BLOCK END HERE [ CHANGE PRICE,DETAILS,INFO ON VARIANT CHANGE ] ******************************/


  /******************* FOR POPUP MODAL [ CHANGE IMAGES AND OPTION ON OPTION CHANGE ] START HERE **************************/

  $('body').on('change', '#etp-quick-view-dialog .option-background .select .selector-wrapper .single-option-selector', function() {
    var total_option_list = $('#etp-quick-view-dialog .option-background .select .selector-wrapper').length;

    if( total_option_list > 1 )
    { 
      setTimeout(function(){
        var varient_combi_name = ''; var zx = 0;  
        $("#etp-quick-view-dialog .option-background .select .selector-wrapper .single-option-selector").each(function(){ 

          var current_varient_value = $(this).val(); 

          if(zx < (total_option_list -1)){   
            varient_combi_name = varient_combi_name + current_varient_value + ' / ';
          }
          else    
          {
            varient_combi_name = varient_combi_name + current_varient_value ;  
          }   
          zx++; 
        })
        var varient__id_active = $("#etp-quick-view-dialog .modal--varient-id--options option[data-title='"+varient_combi_name+"']").val();
        $("#etp-quick-view-dialog .modal--varient-id--options").val(varient__id_active).change();   
      },100);   

    }
    else
    {

      var current_varient_value = $(this).val();  
      var varient__id_active = $("#etp-quick-view-dialog .modal--varient-id--options option[data-title='"+current_varient_value+"']").val();
      $("#etp-quick-view-dialog .modal--varient-id--options").val(varient__id_active).change();

    }
  })    


  $('body').on('change', '#etp-quick-view-dialog .modal--varient-id--options', function() { // body on change 
    var currentThis = $(this);    
    var prod_availability = $.trim( currentThis.find('option:selected').attr('variant-availability') );  
    var variant_id = $.trim( currentThis.find('option:selected').val() );
    var product_handle = $.trim( currentThis.find('option:selected').attr('product-handle') );   

    var action = 'etp-quick-view-dialog'; 
    var other_data = { action:action };
    if( prod_availability == false || prod_availability == "false" ) {         

      $("#etp-quick-view-dialog .second-varient-option-block .action--btn-block .etp-buy-now").addClass('disabled').text(window.dialogSoldOutBtn);
      $("#etp-quick-view-dialog .second-varient-option-block .action--btn-block #etp-quickView-buttons .etp-add-to-cart").addClass('disabled').text(window.dialogSoldOutBtn);
    }
    else      
    {           
      $("#etp-quick-view-dialog .second-varient-option-block .action--btn-block .etp-buy-now").removeClass('disabled').html(window.dialogBuyNowBtn);
      $("#etp-quick-view-dialog .second-varient-option-block .action--btn-block #etp-quickView-buttons .etp-add-to-cart").removeClass('disabled').html(window.addToCartBtn); 
    }
    currentThis.parents('.second-varient-option-block').find('.action--btn-block').find('a').attr('data-varient-id',variant_id);
  }) 

  /******************* FOR POPUP MODAL [ CHANGE IMAGES AND OPTION ON OPTION CHANGE ] END HERE **************************/

  /********** MANAGE HOMEPAGE DEAL OR SINGLE PRODUCT  FOTORAMA SLIDER BLOCK START HERE *********/

  function manage_single_product_slider(){


    if( $(".index-section--singleproductsection .fotorama .fotorama__wrap").length > 0 ){

      
      setTimeout(function(){
        var last_img = $(".index-section--singleproductsection .fotorama__nav-wrap .fotorama__nav--thumbs .fotorama__nav__shaft .fotorama__nav__frame").length; last_img = last_img - 1;
        var fotoramaApi = $(".index-section--singleproductsection .fotorama").data('fotorama');  
        fotoramaApi.show(last_img); //fotoramaApi.show(0);
      },500);
      setTimeout(function(){
        var fotoramaApi = $(".index-section--singleproductsection .fotorama").data('fotorama'); 
        fotoramaApi.show(0);  
      },1500); 
      
    }
    else
    {    
      setTimeout(function(){ manage_single_product_slider(); },1000); 
    }

  }
  manage_single_product_slider(); // function call


  $('body').on('change', '.index-section--singleproductsection .option-background .select .selector-wrapper .single-option-selector', function() {

    if( $('.index-section--singleproductsection .option-background .select .selector-wrapper').length > 1 )
    { 
      var varient_combi_name = ''; var zx = 0; 
      $(".index-section--singleproductsection .option-background .select .selector-wrapper .single-option-selector").each(function(){
        var current_varient_value = $(this).val();  
        //  if(zx < (total_option_list -1)){ 
        if(zx == 0){  varient_combi_name = varient_combi_name + current_varient_value + ' / ';  }
        else  { varient_combi_name = varient_combi_name + current_varient_value ;  } zx++; 
      })
      var varient__id_active = $(".index-section--singleproductsection .homepage-singleproduct--varient-id--options option[data-title='"+varient_combi_name+"']").val();
      $(".index-section--singleproductsection .homepage-singleproduct--varient-id--options").val(varient__id_active).change();
    }
    else
    {
      var current_varient_value = $(this).val();   
      var varient__id_active = $(".index-section--singleproductsection .homepage-singleproduct--varient-id--options option[data-title='"+current_varient_value+"']").val();
      $(".index-section--singleproductsection .homepage-singleproduct--varient-id--options").val(varient__id_active).change();
    } 
  })

  /********** MANAGE HOMEPAGE DEAL OR SINGLE PRODUCT  FOTORAMA SLIDER BLOCK END HERE *********/ 

  //*********************** RELATED PRODUCT ON PRODUCT PAGE SWATCHES SCRIPT BLOCK START HERE *****************************  

  $(".related-product .etp-product .single_products_options .swatches-box.swatches ul.option--swatches--list li").click(function(){
    var currentThis = $(this);  
    $(this).parents('.swatches-box').find('li').removeClass('active_swatch');
    $(this).addClass('active_swatch');
    var compare_image_src_1 = $(this).attr('featured__img');
    var compare_image_src_2 = $(this).attr('data_img__src');
    $(this).parents('.etp-product').find('.product--images--container').find('.etp-product-image ').attr('src',compare_image_src_2);

    //$(this).parents('.etp-product').find('.product--images--container').find('img').each(function(){
    //var compare_image_src_2 = $(this).attr('data-src');
    //  if(compare_image_src_1 == compare_image_src_2){ 
    //   $(this).parents('.etp-product').find('.product--images--container').find('.product--featured--image').attr('data-product-featured-img',compare_image_src_1);
    //  }        
    //})
  })  
  //*********************** RELATED PRODUCT ON PRODUCT PAGE SWATCHES SCRIPT BLOCK END HERE *****************************  

  /********** CHANGE PRODUCT IMAGES ON SWATCHES CLICK BLOCK END HERE *********/ 

  /***************************************************************************************
     * Ajax Add To Cart Function
     ***************************************************************************************/
  function ajaxAddToCartForWhislist(id, quantity) {
    var dynamicData = "quantity="+quantity+"&id="+id;
    return $.ajax({
      url: "/cart/add.js",
      type: "get",
      data: dynamicData, 
      dataType: "json",
      beforeSend: function() {
        showLoading();
      },
      error: function(data) { 
        hideLoading();
        var message = '<i class="fa fa-info-circle font-size-16"></i> '+ $.parseJSON(data.responseText).description;
        showCommonMessage(message);
      },
      success:function(data) {   

        $("#etp-ajax-success-message--Wishlist .modal-body .close").click();
        setTimeout(function(){
          hideLoading(); $('body').addClass('modal-open');
          $(".ajax-success-message-add--to-cart").addClass('in');    
        },1500); 


        var successVar = {   
          image:data.image ,
          message: '<i class="fa fa-check"></i> '+window.dialogCart,
          buttonText: ''+window.dialogCartBtn,
          buttonLink: '/cart',
          productName: data.title

        };
        ajaxDropdownCart();    
        showSuccessMessage(successVar); 
      }
    });
  }  
  /*************************************************************************************** */

  $("#etp-ajax-success-message--Wishlist .add--to--cart-on-whislist").click(function(event){
    event.preventDefault()
    var id = $(this).attr('data-variant-id');
    var quantity = 1;
    ajaxAddToCartForWhislist(id, quantity);  
  })

  /****************** MANAGE PRODUCT PAGE SWATCHES CODE BLOCK START HERE ****************************/

  $('body').on('click', '.option-background.product-page-swatches .swatches-box ul li', function() {
    $(this).parents('ul').find('button.select_options').removeClass('active');
    $(this).children('button').addClass('active');   var swatch_value = new Array();
    if( $('.option-background.product-page-swatches .etp-option-switch .selector-wrapper').length > 1 )
    {     
      var varient_combi_name = ''; var zx = 0;    
      var total_option_list = $(".option-background.product-page-swatches .etp-option-switch .selector-wrapper").length;
      $(".option-background.product-page-swatches .etp-option-switch .selector-wrapper").each(function(){

        var current_varient_value = $.trim( $(this).find('.swatches-box').find(".select_options.active").attr('data-value') ); 
        swatch_value[zx] = current_varient_value ;
        if(zx < (total_option_list -1)){ 
          varient_combi_name = varient_combi_name + current_varient_value + ' / ';     
        }
        else      
        {          
          varient_combi_name = varient_combi_name + current_varient_value ;
        }   
        zx++;    
      })  

      var varient__id_active = $(".product-page-swatches .product-options .varient-id--options option[data-title='"+varient_combi_name+"']").val();
      $(".product-page-swatches .product-options .varient-id--options").val(varient__id_active).change();

      // ----------------- ASSIGN VALUES block start here  ------------------
      var i = 0;  
      $(".sticky-add-to-cart .product-variant-selections .selector-wrapper").each(function(){  
        $(this).find('.single-option-selector').val(swatch_value[i]);  i++;             
      })
      // ----------------- ASSIGN VALUES block END here  ------------------
    }
    else   
    {       

      var current_varient_value = $.trim( $(this).find('button').attr('data-value') );  
      var varient__id_active = $(".product-page-swatches .product-options .varient-id--options option[data-title='"+current_varient_value+"']").val();
      $(".product-page-swatches .product-options .varient-id--options").val(varient__id_active).change();

      // ----------------- ASSIGN VALUES block start here  ------------------  
      $(".sticky-add-to-cart .product-variant-selections .selector-wrapper .single-option-selector").val(current_varient_value);
      // ----------------- ASSIGN VALUES block END here  ------------------
    } 
  })  


  /*** CHANGE OPTION OF PRODUCT WHEN WE CHANGE THE PRODUCT OPTION FROM STICKY BLOCK START HERE  ***/

  $('body').on('click', '.sticky-add-to-cart .varient-box-style .selector-wrapper ul li button', function(){

    var swatch_value=new Array(); var st_zx = 0;   

    setTimeout(function(){ 
      $(".sticky-add-to-cart .varient-box-style .selector-wrapper").each(function(){ 
        var current_varient_value = '';
        $(this).find('.swatches-box').find("button").each(function(){
          var button_class =  $(this).attr('class');
          if(button_class.indexOf('active') > -1){
            current_varient_value = $(this).attr('data-value');
          }
        });
        swatch_value[st_zx] = current_varient_value ;    

        st_zx++; 
      });

      // ----------------- ASSIGN VALUES block start here  ------------------
      var t = 0;
      $(".option-background.product-page-swatches .selector-wrapper").each(function(){

        $(this).find(".swatches-box").find("button[data-value='"+swatch_value[t]+"']").click();  t++;             
      })
      // ----------------- ASSIGN VALUES block END here  ------------------
    },500) ;               
  })       

  /*** CHANGE OPTION OF PRODUCT WHEN WE CHANGE THE PRODUCT OPTION FROM STICKY BLOCK END HERE  ***/


  /****************** MANAGE PRODUCT PAGE SWATCHES CODE BLOCK END HERE ****************************/

  /****************** COPY DISCOUNT CODE BLOCK START HERE **************************/

  $('#etp-coupon-dailog .margin-clear.coupon-code-p').click(function(){
    copy_the_discount_code() ;
  })

  /****************** COPY DISCOUNT CODE BLOCK END HERE ****************************/



  /****************** MANAGE home--page-single-product CODE BLOCK START HERE ****************************/

  $('body').on('click', '.home--page-single-product--container .swatches-box ul li', function() {  

    $(this).parents('ul').find('.select_options').removeClass('active'); $(this).children('button.select_options').addClass('active'); var currentThis = $(this);
    var swatch_value = new Array();

    if(  $(this).parents('.etp-option-switch').find('.selector-wrapper').length > 1 )
    { 

      var varient_combi_name = ''; var zx = 0;    
      var total_option_list = $(this).parents('.etp-option-switch').find('.selector-wrapper').length;

      $(this).parents('.etp-option-switch').find('.selector-wrapper').each(function(){

        var current_varient_value = $.trim( $(this).find('.swatches-box').find(".select_options.active").attr('data-value') ); 
        swatch_value[zx] = current_varient_value ;     
        if(zx < (total_option_list -1)){ 
          varient_combi_name = varient_combi_name + current_varient_value + ' / ';  
        }
        else      
        {              
          varient_combi_name = varient_combi_name + current_varient_value ;
        }    
        zx++;    
      })    

      var varient__id_active = currentThis.parents('.home--page-single-product--container').find('.homepage-singleproduct--varient-id--options').find("option[data-title='"+varient_combi_name+"']").val();
      currentThis.parents('.home--page-single-product--container').find('.homepage-singleproduct--varient-id--options').val(varient__id_active).change();
    } 
    else   
    {       
      var current_varient_value = $.trim( $(this).children('button.select_options').attr('data-value') );  
      var varient__id_active = currentThis.parents('.home--page-single-product--container').find('.homepage-singleproduct--varient-id--options').find("option[data-title='"+current_varient_value+"']").val();
      currentThis.parents('.home--page-single-product--container').find('.homepage-singleproduct--varient-id--options').val(varient__id_active).change();
    }   
  })   

  $('body').on('change', '.home--page-single-product--container .option-switch-dropdown .single-option-selector', function() {

    var swatch_value = new Array();   var currentThis = $(this); 
    var total_option_list = currentThis.parents('.home--page-single-product--container').find('.option-switch-dropdown').find('.single-option-selector').length;

    if( total_option_list > 1 )
    { 

      var varient_combi_name = ''; var zx = 0;    
      currentThis.parents('.home--page-single-product--container').find('.option-switch-dropdown').find('.selector-wrapper').each(function(){

        var current_varient_value = $.trim( $(this).find('.single-option-selector').val() ); 
        swatch_value[zx] = current_varient_value ;
        if(zx < (total_option_list -1)){ 
          varient_combi_name = varient_combi_name + current_varient_value + ' / ';  
        }
        else         
        {          
          varient_combi_name = varient_combi_name + current_varient_value ;
        }   
        zx++;    
      })       

      var varient__id_active = currentThis.parents('.home--page-single-product--container').find('.homepage-singleproduct--varient-id--options').find("option[data-title='"+varient_combi_name+"']").val();
      currentThis.parents('.home--page-single-product--container').find('.homepage-singleproduct--varient-id--options').val(varient__id_active).change();


    }
    else    
    {           
      var current_varient_value = $.trim( $(this).val() );  
      var varient__id_active = currentThis.parents('.home--page-single-product--container').find('.homepage-singleproduct--varient-id--options').find("option[data-title='"+current_varient_value+"']").val();
      currentThis.parents('.home--page-single-product--container').find('.homepage-singleproduct--varient-id--options').val(varient__id_active).change();

    } 
  })


  $(".home--page-single-product--container .homepage-singleproduct--varient-id--options").change(function(){   
    var currentThis = $(this); var orgVariantId = $(this).val(); 
    var prod_availability = $.trim( $(this).find('option:selected').attr('variant-availability') );  
    var variant_id = $.trim( $(this).find('option:selected').val() );
    var product_handle = $.trim( $(this).find('option:selected').attr('product-handle') );

    var variant_compare_at_price = $.trim( $(this).find('option:selected').attr('product-compare-at-price') );    

    if(variant_compare_at_price == '' || variant_compare_at_price == null){    
      variant_compare_at_price = 0 ;
    }    
    else 
    {
      variant_compare_at_price = parseFloat( variant_compare_at_price ); 
    }

    var variant_price = $.trim( parseFloat( $(this).find('option:selected').attr('product-price') ) );
    var sold__out_html = 'Sold Out';        
    if(variant_price < variant_compare_at_price){   

      var save_type = $.trim($("#you__save__type_switch").val());             
      var save__price = variant_compare_at_price - variant_price ; 
      var save__price_percentage = ( ( variant_price * 100 ) / variant_compare_at_price ); 
      save__price_percentage = (100 - save__price_percentage).toFixed(2) ;
      save__price_percentage =  Math.round(save__price_percentage);

      if(save_type == 'percentage'){         

        var inject_html = '<h3 class="margin-top-0 margin-bottom-10 etp-price-preview pull-left">'+
            '<del><span class="money" data-currency-'+window.shopCurrency_in_lowercase+'="'+Shopify.formatMoney(variant_compare_at_price,window.shop_money_format)+'" data-currency="'+window.shopCurrency+'" >'+ Shopify.formatMoney(variant_compare_at_price,window.shop_money_format) +'</span></del>'+
            ' <span class="margin-left-10 etp-default-price etp-default-price-a3">'+
            '<span class="money" data-currency-'+window.shopCurrency_in_lowercase+'="'+Shopify.formatMoney(variant_price, window.shop_money_format)+'" data-currency="'+window.shopCurrency+'">'+ Shopify.formatMoney(variant_price, window.shop_money_format) +'</span></span></h3>'+

            '<div class="save__price_block" style="background-color:#fd992f; color:#ffffff">Save<span class="save__price">'+
            '<span id="totalSaved" class="you--save-money-per" data-save-per="'+save__price_percentage+'" >'+ save__price_percentage +'<span class="per--sign" >%</span></span>'+
            '</span></div>';   
      }

      else if(save_type == 'numeric' ){       

        var inject_html = '<h3 class="margin-top-0 margin-bottom-10 etp-price-preview pull-left">'+
            '<del><span class="money" data-currency-'+window.shopCurrency_in_lowercase+'="'+Shopify.formatMoney(variant_compare_at_price,window.shop_money_format)+'" data-currency="'+window.shopCurrency+'" >'+ Shopify.formatMoney(variant_compare_at_price,window.shop_money_format) +'</span></del>'+
            ' <span class="margin-left-10 etp-default-price etp-default-price-a3">'+
            '<span class="money" data-currency-'+window.shopCurrency_in_lowercase+'="'+Shopify.formatMoney(variant_price, window.shop_money_format)+'" data-currency="'+window.shopCurrency+'">'+ Shopify.formatMoney(variant_price, window.shop_money_format) +'</span></span></h3>'+

            '<div class="save__price_block" style="background-color:#fd992f; color:#ffffff">Save<span class="save__price">'+
            '<span id="totalSaved" class="money" data-currency-'+window.shopCurrency_in_lowercase+'="'+Shopify.formatMoney(save__price,window.shop_money_format)+'" data-currency="'+window.shopCurrency+'">'+ Shopify.formatMoney(save__price, window.shop_money_format) +'</span>'+
            '</span></div>';   

      }

      else{

        var inject_html = '<h3 class="margin-top-0 margin-bottom-10 etp-price-preview pull-left">'+
            '<del><span class="money" data-currency-'+window.shopCurrency_in_lowercase+'="'+Shopify.formatMoney(variant_compare_at_price,window.shop_money_format)+'" data-currency="'+window.shopCurrency+'" >'+ Shopify.formatMoney(variant_compare_at_price,window.shop_money_format) +'</span></del>'+
            ' <span class="margin-left-10 etp-default-price etp-default-price-a3">'+
            '<span class="money" data-currency-'+window.shopCurrency_in_lowercase+'="'+Shopify.formatMoney(variant_price, window.shop_money_format)+'" data-currency="'+window.shopCurrency+'">'+ Shopify.formatMoney(variant_price, window.shop_money_format) +'</span></span></h3>' ;
      }

      currentThis.parents('.home--page-single-product--container').find('.price-preview').find('.previewPriceOuter').html(inject_html); 
    } else {

      var inject_html = '<h3 class="margin-top-0 margin-bottom-10 etp-price-preview pull-left"><span class="etp-default-price etp-default-price-a1" original-value="$11.80"><span class="money" data-currency-usd="'+Shopify.formatMoney(variant_price,window.shop_money_format)+'" data-currency="USD">'+ Shopify.formatMoney(variant_price,window.shop_money_format) +'</span></span></h3><div class="save__price_block" style="background-color:#fd992f; color:#ffffff"></div>';
      currentThis.parents('.home--page-single-product--container').find('.price-preview').find('.previewPriceOuter').html(inject_html); 
    }
    re_initilize_currency();   

    if( prod_availability == false || prod_availability == "false" ) {           

      currentThis.parents('.home--page-single-product--container').find('.single-product-buttons').find('.etp-buy-now').addClass('disabled').html(window.dialogSoldOutBtn);
      currentThis.parents('.home--page-single-product--container').find('.single-product-buttons').find('.etp-add-to-cart').addClass('disabled').html(window.dialogSoldOutBtn);

    } 
    else      
    {             
      currentThis.parents('.home--page-single-product--container').find('.single-product-buttons').find('.etp-buy-now').removeClass('disabled').html(window.dialogBuyNowBtn);
      currentThis.parents('.home--page-single-product--container').find('.single-product-buttons').find('.etp-add-to-cart').removeClass('disabled').html(window.addToCartBtn); 
    }  

    currentThis.parents('.home--page-single-product--container').find('.homepage-single-product-detail').find('.single-product-buttons').find('a').attr('data-varient-id',orgVariantId);          

  }) 

  /****************** MANAGE home--page-single-product CODE BLOCK END HERE ****************************/


  /****************** MANAGE UPSELL OPTION ACTION BLOCK START HERE  ****************************/

  $('body').on('change', '#upsell--modal-block .selector-wrapper .single-option-selector', function() {

    var swatch_value = new Array();        
    var total_option_list = $(this).parents(".option-container--wrapper").find(".selector-wrapper").length;
    if( total_option_list > 1 )    
    { 
      var varient_combi_name = ''; var zx = 0;    

      $(this).parents(".option-container--wrapper").find(".selector-wrapper").each(function(){   

        var current_varient_value = $.trim( $(this).find('.single-option-selector').val() ); 
        swatch_value[zx] = current_varient_value ;
        if(zx < (total_option_list -1)){ 
          varient_combi_name = varient_combi_name + current_varient_value + ' / ';  
        }
        else         
        {           
          varient_combi_name = varient_combi_name + current_varient_value ;
        }   
        zx++;       
      })     
      var varient__id_active = $(this).parents('.etp-product').find(".upsell-product--option--variant--container").find("option[data-title='"+varient_combi_name+"']").val();
      $(this).parents('.etp-product').find(".varient-id--options").val(varient__id_active).change(); 
    }
    else          
    {                 
      var current_varient_value = $.trim( $(this).val() );  
      var varient__id_active = $(this).parents('.etp-product').find(".upsell-product--option--variant--container").find("option[data-title='"+current_varient_value+"']").val();
      $(this).parents('.etp-product').find(".varient-id--options").val(varient__id_active).change();

    }          
  })   

  $('body').on('change', '#upsell--modal-block .upsell-product--option--variant--container .varient-id--options', function() { 

    var featured_img = $(this).find("option:selected").attr("large-featured-img");
    var variant_id = $(this).find("option:selected").val();
    var currentThis = $(this);
    currentThis.parents(".etp-product").find('.etp-product-cart-con').find('.upsell-addToCart').attr('data-varient-id',variant_id);

    $(this).parents(".etp-product").find('.product--images--container').find('a').find('img').each(function(){
      var img_src = $(this).attr('data-src');                                                 
      if(img_src == featured_img){     
        currentThis.parents(".etp-product").find('.product--images--container').find('a').find('img').hide();
        $(this).show();    
      }   
    })


    var prod_availability = $.trim( $(this).find('option:selected').attr('variant-availability') );  
    var variant_id = $.trim( $(this).find('option:selected').val() );
    var product_handle = $.trim( $(this).find('option:selected').attr('product-handle') );

    var variant_compare_at_price = $.trim( $(this).find('option:selected').attr('product-compare-at-price') );

    if(variant_compare_at_price == '' || variant_compare_at_price == null){    
      variant_compare_at_price = 0 ;
    }    
    else 
    {
      variant_compare_at_price = parseFloat( variant_compare_at_price ); 
    }

    var variant_price = $.trim( parseFloat( $(this).find('option:selected').attr('product-price') ) );

    var sold__out_html = '<h3 class="margin-top-0 margin-bottom-10 etp-price-preview pull-left sold__out_product">Sold Out</h3>';        
    if(variant_price < variant_compare_at_price){   

      var save_type = $.trim($("#you__save__type_switch").val());             
      var save__price = variant_compare_at_price - variant_price ; 
      var save__price_percentage = ( ( variant_price * 100 ) / variant_compare_at_price ); 
      save__price_percentage = (100 - save__price_percentage).toFixed(2) ;
      save__price_percentage =  Math.round(save__price_percentage);

      if(save_type == 'percentage'){         

        var inject_html = '<del><span class="money" data-currency-'+window.shopCurrency_in_lowercase+'="'+Shopify.formatMoney(variant_compare_at_price,window.shop_money_format)+'" data-currency="'+window.shopCurrency+'" >'+ Shopify.formatMoney(variant_compare_at_price,window.shop_money_format) +'</span></del>'+
            ' <span class="margin-left-10 etp-default-price etp-default-price-a3">'+
            '<span class="money" data-currency-'+window.shopCurrency_in_lowercase+'="'+Shopify.formatMoney(variant_price, window.shop_money_format)+'" data-currency="USD">'+ Shopify.formatMoney(variant_price, window.shop_money_format) +'</span></span>'+

            '<div class="save__price_block" style="background-color:#fd992f; color:#ffffff">Save<span class="save__price">'+
            '<span id="totalSaved" class="you--save-money-per" data-save-per="'+save__price_percentage+'" >'+ save__price_percentage +'<span class="per--sign" >%</span></span>'+
            '</span></div>';   
      }

      else if(save_type == 'numeric' ){

        var inject_html = '<del><span class="money" data-currency-'+window.shopCurrency_in_lowercase+'="'+Shopify.formatMoney(variant_compare_at_price,window.shop_money_format)+'" data-currency="'+window.shopCurrency+'" >'+ Shopify.formatMoney(variant_compare_at_price,window.shop_money_format) +'</span></del>'+
            ' <span class="margin-left-10 etp-default-price etp-default-price-a3">'+
            '<span class="money" data-currency-'+window.shopCurrency_in_lowercase+'="'+Shopify.formatMoney(variant_price, window.shop_money_format)+'" data-currency="USD">'+ Shopify.formatMoney(variant_price, window.shop_money_format) +'</span></span>'+

            '<div class="save__price_block" style="background-color:#fd992f; color:#ffffff">Save<span class="save__price">'+
            '<span id="totalSaved" class="money" data-currency-usd="'+Shopify.formatMoney(save__price,window.shop_money_format)+'" data-currency="USD">'+ Shopify.formatMoney(save__price, window.shop_money_format) +'</span>'+
            '</span></div>';   

      }

      else{

        var inject_html = '<del><span class="money" data-currency-'+window.shopCurrency_in_lowercase+'="'+Shopify.formatMoney(variant_compare_at_price,window.shop_money_format)+'" data-currency="'+window.shopCurrency+'" >'+ Shopify.formatMoney(variant_compare_at_price,window.shop_money_format) +'</span></del>'+
            ' <span class="margin-left-10 etp-default-price etp-default-price-a3">'+
            '<span class="money" data-currency-'+window.shopCurrency_in_lowercase+'="'+Shopify.formatMoney(variant_price, window.shop_money_format)+'" data-currency="USD">'+ Shopify.formatMoney(variant_price, window.shop_money_format) +'</span></span>' ;
      }

      $(this).parents('.etp-product').find('.product-title-price').find('.previewPriceOuter').html(inject_html); 

    } else {

      var inject_html = '<h3 class="margin-top-0 margin-bottom-10 etp-price-preview pull-left"><span class="etp-default-price etp-default-price-a1" original-value="$11.80"><span class="money" data-currency-'+window.shopCurrency_in_lowercase+'="'+Shopify.formatMoney(variant_price,window.shop_money_format)+'" data-currency="'+window.shopCurrency+'">'+ Shopify.formatMoney(variant_price,window.shop_money_format) +'</span></span></h3><div class="save__price_block" style="background-color:#fd992f; color:#ffffff"></div>';
      $(this).parents('.etp-product').find('.product-title-price').find('.previewPriceOuter').html(inject_html);
    }
    re_initilize_currency();   


    if( prod_availability == false || prod_availability == "false" ) {       
      $(this).parents('.etp-product').find('.product-title-price').find('.previewPriceOuter').html(sold__out_html);
      // $("#upsell--modal-block .single-product-buttons .etp-buy-now").addClass('disabled').text(window.dialogSoldOutBtn);
      $(this).parents('.etp-product').find('.etp-product-cart-con').find('.etp-add-to-cart').addClass('disabled').text(window.dialogSoldOutBtn);

    }  
    else      
    {         
      var add_to_cart_btn_hierarchy = $(this).parents('.etp-product').find('.etp-product-cart-con').find('.etp-add-to-cart');
      var buy_now_btn_hierarchy = "";
      var price_hierarchy = $(this).parents('.etp-product').find('.product-title-price').find('.previewPriceOuter');     
      var action = 'upsell-product-block';
      var other_data = { action:action ,
                        price_hierarchy:price_hierarchy,
                        sold__out_html:sold__out_html ,   
                       };  

      check_product_availability_in_real_time(variant_id , product_handle ,add_to_cart_btn_hierarchy,buy_now_btn_hierarchy,other_data);  
    }   

  })

  /****************** MANAGE UPSELL OPTION ACTION BLOCK END HERE  ****************************/


  /******************** MANAGE AJAX SUCCESS MESSAGE BLOCK START HERE *************************/

  $('body').on('click', '#etp-ajax-success-message .login-back .etp-product .single_products_options .swatches-box.swatches ul li', function() { 
    var featured_img = $(this).attr("featured__img");

    var currentThis = $(this);

    $(this).parents(".etp-product").find('.product--images--container').find('a').find('img').each(function(){
      var img_src = $(this).attr('data-src');                                                 
      if(img_src == featured_img){     
        currentThis.parents(".etp-product").find('.product--images--container').find('a').find('img').hide();
        $(this).show();    
      }   
    })

  })         


  /******************** MANAGE AJAX SUCCESS MESSAGE BLOCK END HERE *************************/


}) // END OF DOCUMENT DOT READY

$(document).ready(function(){ 
  show_currency_flag();   // SHOW CURRENCY FLAG ON PAGE LOAD .

}) //   ****** END OF DOCUMENT DOT READY FUNCTION ******

// Product Page return link     

$(document).ready(function(){
  var url =  document.referrer,
      parts = url.split("/"),
      last_part = parts[parts.length-1];
  last_part = last_part.replace(/[^a-z0-9\s]/gi,' ');
  if(last_part == ''){
    $('a.collection_return_link span.return_link_text').text("Kotisivu");
                                                             }
                                                             else{
                                                             $('a.collection_return_link span.return_link_text').text(last_part);
  }
});

// Product Page return link 




/******************************** Manage swatches availability code block start here ********************************/
function home_activate_available_option(hierarcy_root){  

  hierarcy_root.find('.selector-wrapper').each(function(){
    if( $(this).find('ul').find('li.activated-cell').hasClass('variant--not--exists') ) { 
      $(this).find('ul').find('li').each(function(){
        if( !$(this).hasClass('variant--not--exists') ) {     
          $(this).children('button').click(); return false;  
        }   
      });
    } 
  })
}
function home_manage_show_hide_variant_option(hierarcy_root,data_title,options_name_arr,currentThis2){  

  if($.inArray(data_title, options_name_arr) == -1) {
    currentThis2.hide().addClass('variant--not--exists');    
  }
  else{
    currentThis2.show().removeClass('variant--not--exists'); 
  }

}
function home_manage_variant_solout_cross(hierarcy_root,selector_wrapper_index_num,is_parent_variant_soldout){

  var total__option = hierarcy_root.find('.selector-wrapper:nth-child('+selector_wrapper_index_num+')').find('ul').find('li').length;
  var total_variant_sold_out = 0;

  if( is_parent_variant_soldout == 'YES'){ 
    hierarcy_root.find('.selector-wrapper:nth-child('+selector_wrapper_index_num+')').find('ul').find('li').each(function(){
      if( $(this).hasClass('activated-cell') ) { 
        $(this).children('button.select_options').addClass('variant_availability-false');
      }
    })
  }

  hierarcy_root.find('.selector-wrapper:nth-child('+selector_wrapper_index_num+')').find('ul').find('li').each(function(){
    if( $(this).hasClass('variant_availability-false') || $(this).hasClass('box_variant_availability-false') ) { 
      total_variant_sold_out++;
    }    
  })

  if(total__option == total_variant_sold_out){    
    is_parent_variant_soldout = 'YES';
    selector_wrapper_index_num = selector_wrapper_index_num - 1;   
    if(selector_wrapper_index_num >= 1){
      home_manage_variant_solout_cross(hierarcy_root,selector_wrapper_index_num,is_parent_variant_soldout);
    }
  }

}
function home_manage__variant_option(hierarcy_root,hierarcy_root2,total_options_pack) 
{
  var variant_name = ''; var count = 1; var is_all_variant_sold_out = 0 ; var sel_opt_hierarcy_root = hierarcy_root;
  hierarcy_root.find('.selector-wrapper').each(function(index){
    var option_name = $(this).find('ul').find('li.activated-cell').attr('data-value');
    if(count < total_options_pack ){ variant_name += option_name + ' / '; } count++;

  })
  var indexOfLastSelectorWrapper = hierarcy_root.find('.selector-wrapper:last-child').index(); 
  var nthNumOfLastSelectorWrapper = indexOfLastSelectorWrapper + 1 ;
  var total__option = hierarcy_root.find('.selector-wrapper:nth-child('+nthNumOfLastSelectorWrapper+')').find('ul').find('li:not(.variant--not--exists)').length;

  hierarcy_root.find('.selector-wrapper:nth-child('+nthNumOfLastSelectorWrapper+')').find('ul').find('li:not(.variant--not--exists)').each(function(){
    var option_name = $(this).attr('data-value');

    var ready_v_name = variant_name+option_name; 


    if(hierarcy_root2 != ''){ sel_opt_hierarcy_root = hierarcy_root2; }
    var variant_availability = sel_opt_hierarcy_root.find('.product--option--variant--container').find('.varient-id--options').find("option[data-title='"+ready_v_name+"']").attr('variant-availability');
    if(variant_availability == 'false' || variant_availability == false){ 
      is_all_variant_sold_out++;
      $(this).children('button.select_options').addClass('variant_availability-false'); 
    }
    else{
      $(this).children('button.select_options').removeClass('variant_availability-false');
    }
  })
  var selector_wrapper_index_num = nthNumOfLastSelectorWrapper ; 
  if(total__option == is_all_variant_sold_out){
    var is_parent_variant_soldout = 'YES';  selector_wrapper_index_num = selector_wrapper_index_num - 1;

    home_manage_variant_solout_cross(hierarcy_root,selector_wrapper_index_num,is_parent_variant_soldout);  
  }
  home_activate_available_option(sel_opt_hierarcy_root);     
}

function home_clear_all_crosses(targetElement){ 
  $(targetElement).each(function(){  
    $(this).find('ul').find('li').find('button').removeClass('variant_availability-false');
    $(this).find('ul').find('li').find('button').removeClass('box_variant_availability-false'); 
  })
}

function home_check_availability_of_variants(currentThis,hierarcy_root){    

  hierarcy_root.find('.selector-wrapper').find('li.very--first--options').each(function(){
    var option_value = $.trim( $(this).attr('data-value') ); var total_matched =0 ; var parentThis = $(this);
    var total_unavailable_variant =0 ;
    hierarcy_root.find('.product--option--variant--container').find('.varient-id--options').find('option').each(function(){
      var data_title = $.trim( $(this).attr('data-title') );
      if( data_title.indexOf(option_value) > -1 ){ 
        total_matched++; 
        if( $.trim( $(this).attr('variant-availability') ) == 'false' ){ total_unavailable_variant++; }
      }
    })

    if(total_matched == total_unavailable_variant){ 
      var result = parentThis.children('button.select_options').hasClass('variant_availability-false'); 
      if( result == 'false' || result == false ) {      
        parentThis.children('button.select_options').addClass('variant_availability-false');
      }
    }
  })   

  if( hierarcy_root.find('.selector-wrapper').length >= 2 )  
  {  
    var first_selected_variant_name = hierarcy_root.find('.selector-wrapper.very--first--wrapper').find('li.very--first--options.activated-cell').attr('data-value');

    hierarcy_root.find('.not-very-first-wrapper:first').find('ul').find('li').each(function(){ 
      var option_value = $.trim( $(this).attr('data-value') ); var total_matched =0 ; var parentThis = $(this);
      var total_unavailable_variant =0 ;
      var name_combination = first_selected_variant_name+' / '+option_value;

      hierarcy_root.find('.product--option--variant--container').find('.varient-id--options').find('option').each(function(){
        var data_title = $.trim( $(this).attr('data-title') ); 
        if( data_title.indexOf(name_combination) > -1 ){
          total_matched++; 
          if( $.trim( $(this).attr('variant-availability') ) == 'false' ){ total_unavailable_variant++; }
        } 
      })

      if(total_matched == total_unavailable_variant){ 
        var result = parentThis.children('button.select_options').hasClass('variant_availability-false');
        if( result == 'false' || result == false ) {  
          parentThis.find('button').addClass('variant_availability-false').addClass('variant_availability-false-ex');
        }
      }
    })

  } 

}

function manage_prod_image_price_availability(currentThis){

  var compare_image_src_1 = currentThis.attr('featured__img');
  var compare_image_src_2 = currentThis.attr('data_img__src');
  currentThis.parents('.product--snippet').find('.product--images--container').find('.etp-product-image').attr('src',compare_image_src_2);


  var total_active = 0;
  var collection_title_list = currentThis.parents('.etp-product').find(".product--images--container").find(".product-button").attr('collection-title');     
  var   swatch_value = new Array(); var varient__id_active = '';   
  var total_option_list = currentThis.parents(".option-container--wrapper").find(".selector-wrapper").length;
  if( total_option_list > 1 )    
  { 
    var varient_combi_name = ''; var zx = 0;    
    currentThis.parents(".option-container--wrapper").find(".selector-wrapper").each(function(){
      if( $(this).find('.option--swatches--list').find('li.activated-cell').length > 0 ){
        total_active++;
      }
      var current_varient_value = $.trim( $(this).find('.option--swatches--list').find('li.activated-cell').attr('data-value') ); 
      swatch_value[zx] = current_varient_value ;
      if(zx < (total_option_list -1)){ 
        varient_combi_name = varient_combi_name + current_varient_value + ' / ';  
      }
      else         
      {           
        varient_combi_name = varient_combi_name + current_varient_value ;
      }   
      zx++;       
    })     
    var varient__id_active = currentThis.parents('.etp-product').find(".product--option--variant--container").find('.varient-id--options').find("option[data-title='"+varient_combi_name+"']").val();
    currentThis.parents('.etp-product').find(".product--option--variant--container").find(".varient-id--options").val(varient__id_active).change(); 
  }
  else            
  {   
    total_active = 1;
    var current_varient_value = $.trim( currentThis.attr('data-value') );  
    var varient__id_active =currentThis.parents('.etp-product').find(".product--option--variant--container").find('.varient-id--options').find("option[data-title='"+current_varient_value+"']").val();
    currentThis.parents('.etp-product').find(".product--option--variant--container").find(".varient-id--options").val(varient__id_active).change();
    varient_combi_name = current_varient_value ;
  } 
  if(varient__id_active != '' && varient__id_active != null){    
    var add_to_cart_btn_html = '<a href="#" collection-title="'+collection_title_list+'" class="btn btn-default etp-add-to-cart add-to-cart single--variant product--select-option" data-item-quantity="1" data-varient-id="'+varient__id_active+'">Add To Cart</a>';
    currentThis.parents('.etp-product').find(".product--images--container").find(".product-button").html(add_to_cart_btn_html);
  }
  else
  {  
    if(total_active == total_option_list){
      var soldout_btn_html = '<a style="pointer-events:none;" href="#" collection-title="'+collection_title_list+'" class="btn btn-default sold--out--btn single--variant product--select-option" data-item-quantity="" data-varient-id="">Sold Out</a>';
      currentThis.parents('.etp-product').find(".product--images--container").find(".product-button").html(soldout_btn_html);
    }
  }  

  /***************** MANAGE PRICE BLOCK START HERE *************************/
  var priceBlockRoot = currentThis.parents('.etp-product').find(".product-title-price").find('.product__price');
  var variantOptionRoot = currentThis.parents('.etp-product').find(".product--option--variant--container").find('.varient-id--options');   
  var prod_availability = $.trim(variantOptionRoot.find("option[data-title='"+varient_combi_name+"']").attr('variant-availability'));
  var compare_at_price = $.trim(variantOptionRoot.find("option[data-title='"+varient_combi_name+"']").attr('product-compare-at-price'));
  var prod_price = $.trim(variantOptionRoot.find("option[data-title='"+varient_combi_name+"']").attr('product-price'));    


  if(total_active == total_option_list){
    if( compare_at_price != '' && compare_at_price > prod_price ) 
    {   
      var inject_html = '<div class="display-in-b margin-right-10">'+
          '<del><span class="money" data-currency-'+window.shopCurrency_in_lowercase+'="'+Shopify.formatMoney(compare_at_price,window.shop_money_format)+'" data-currency="'+window.shopCurrency+'" >'+ Shopify.formatMoney(compare_at_price,window.shop_money_format) +'</span></del></div>'+
          '<div class="display-in-b"><span class="money" data-currency-usd="'+Shopify.formatMoney(prod_price, window.shop_money_format)+'" data-currency="USD">'+ Shopify.formatMoney(prod_price, window.shop_money_format) +'</span></div>' ;

      priceBlockRoot.html(inject_html);
    }   

    if( ( compare_at_price == '' || compare_at_price == 0 ) )
    { 
      var inject_html = '<span class="money" data-currency-'+window.shopCurrency_in_lowercase+'="'+Shopify.formatMoney(prod_price,window.shop_money_format)+'" data-currency="'+window.shopCurrency+'">'+ Shopify.formatMoney(prod_price,window.shop_money_format) +'</span>';
      priceBlockRoot.html(inject_html);   
    }   

    if( prod_availability == false || prod_availability == 'false' )
    {   
      var soldout_btn_html = '<a style="pointer-events:none;" href="#" collection-title="'+collection_title_list+'" class="btn btn-default sold--out--btn single--variant product--select-option" data-item-quantity="" data-varient-id="">Sold Out</a>';
      currentThis.parents('.etp-product').find(".product--images--container").find(".product-button").html(soldout_btn_html);
    }    
    re_initilize_currency();       
  } 
  /***************** MANAGE PRICE BLOCK END HERE *************************/ 
}   

$(document).ready(function(){

  $('body').on('click', '#etp-quick-view-dialog .option-background .etp-quickView-swatch .selector-wrapper ul li',function(){ 

    $(this).parents('ul').find('li').removeClass('activated-cell'); 
    $(this).addClass('activated-cell');

    var currentThis = $(this).parents('.option-background');  
    var hierarcy_root = $(this).parents('.option-background').find('.etp-quickView-swatch');
    var hierarcy_root2 = $(this).parents('.option-background').find('.etp-quickView-swatch').find('.swatch-opt-wrapper');  
    var targetElement = $(this).parents('.option-background').find('.etp-quickView-swatch').find('.selector-wrapper'); 

    home_clear_all_crosses(targetElement);
    home_check_availability_of_variants(currentThis,hierarcy_root);       

    var total_options_pack = hierarcy_root2.find('.selector-wrapper').length; 
    var options_name_arr = new Array(); 
    var first_option_link = hierarcy_root.find('.selector-wrapper').find('ul').find('li.very--first--options.activated-cell');
    var varients_belong_to = $.trim( first_option_link.children('.belong--to').text() );

    var varients_belong_to_arr = varients_belong_to.split(','); 

    for(var i=0;i<varients_belong_to_arr.length;i++){
      var variant_title = $.trim( varients_belong_to_arr[i] );    

      var variant_title_arr = variant_title.split('/');    
      for(var j=0;j<variant_title_arr.length;j++){
        var opt_title = $.trim( variant_title_arr[j] );
        if($.inArray(opt_title, options_name_arr) == -1) {
          options_name_arr.push(opt_title);    
        }
      }        
    }

    if(total_options_pack == 1){
      hierarcy_root.find('.selector-wrapper').find('ul').find('li.very--first--options').each(function(){
        var data_title = $(this).children('button.select_options').attr('data-value');
        var variant_availability = hierarcy_root.find('.product--option--variant--container').find('.varient-id--options').find('option[data-title="'+data_title+'"]').attr('variant-availability');
        if(variant_availability == 'false'){ 
          $(this).children('button.select_options').addClass('variant_availability-false');
        }
      })

    }   

    if(total_options_pack > 1){   
      hierarcy_root.find('.selector-wrapper.not-very-first-wrapper').find('ul').find('li').each(function(){
        var currentThis2 = $(this);
        var data_title = $(this).children('button.select_options').attr('data-value'); 
        home_manage_show_hide_variant_option(hierarcy_root,data_title,options_name_arr,currentThis2);  
      })
      home_manage__variant_option(hierarcy_root2,hierarcy_root,total_options_pack);  
    } 
  })

  $('body').on('click', '.product--snippet .product-title-price .single_products_options .selector-wrapper ul li',function(){

    $(this).parents('ul').find('li').removeClass('activated-cell'); 
    $(this).addClass('activated-cell');    

    var currentThis = $(this).parents('.product--snippet');  
    var hierarcy_root = $(this).parents('.product-title-price').find('.single_products_options');
    var hierarcy_root2 = '';
    var targetElement = $(this).parents('.product-title-price').find('.selector-wrapper'); 

    manage_prod_image_price_availability($(this));
    home_clear_all_crosses(targetElement);
    home_check_availability_of_variants(currentThis,hierarcy_root);   

    var total_options_pack = hierarcy_root.find('.selector-wrapper').length; 
    var options_name_arr = new Array(); 
    var first_option_link = hierarcy_root.find('.selector-wrapper').find('ul').find('li.very--first--options.activated-cell');
    var varients_belong_to = $.trim( first_option_link.children('.belong--to').text() );

    var varients_belong_to_arr = varients_belong_to.split(','); 

    for(var i=0;i<varients_belong_to_arr.length;i++){
      var variant_title = $.trim( varients_belong_to_arr[i] );    

      var variant_title_arr = variant_title.split('/');    
      for(var j=0;j<variant_title_arr.length;j++){
        var opt_title = $.trim( variant_title_arr[j] );
        if($.inArray(opt_title, options_name_arr) == -1) {
          options_name_arr.push(opt_title);    
        }
      }        
    }

    if(total_options_pack == 1){
      hierarcy_root.find('.selector-wrapper').find('ul').find('li.very--first--options').each(function(){
        var data_title = $(this).children('button.select_options').attr('data-value');
        var variant_availability = hierarcy_root.find('.product--option--variant--container').find('.varient-id--options').find('option[data-title="'+data_title+'"]').attr('variant-availability');
        if(variant_availability == 'false'){ 
          $(this).children('button.select_options').addClass('variant_availability-false');
        }
      })

    }   

    if(total_options_pack > 1){ 
      hierarcy_root.find('.selector-wrapper.not-very-first-wrapper').find('ul').find('li').each(function(){
        var currentThis2 = $(this);
        if( $(this).children('button.select_options').length > 0 ){
          var data_title = $.trim( $(this).children('button.select_options').attr('data-value') );
        }
        else
        {
          var data_title = $.trim( $(this).attr('data-value') );
        }

        home_manage_show_hide_variant_option(hierarcy_root,data_title,options_name_arr,currentThis2);
      })
      home_manage__variant_option(hierarcy_root,hierarcy_root2,total_options_pack);
    } 

  })   

  $('.product--snippet .product-title-price .single_products_options .selector-wrapper ul li:nth-child(1)').click(); 
  var hierarcy_root = $('.product--snippet .product-title-price .single_products_options'); 
  setTimeout(function(){ activate_available_variants(hierarcy_root); },200);   

}) // END OF DOCUMENT DOT READY
/******************************** Manage swatches availability code block end here ********************************/


   

/******************************** [PRODUCT PAGE ] Manage swatches availability block start here ********************************/
function PRO_activate_available_option(hierarcy_root){    

  hierarcy_root.find('.selector-wrapper').each(function(){                    
    var variantAvailability = $(this).find('ul').find('li.activated-cell').find('button.variant_availability-false').length;
    if( variantAvailability > 0 ) { 
      $(this).find('ul').find('li').each(function(){ 
        var variantAvailability1 = $(this).find('button.variant_availability-false').length;
        if( variantAvailability1 == 0 ) {       
          $(this).children('button').click(); return false;        
        }     
      });
    }            
  })  

}
function PRO_manage_show_hide_variant_option(hierarcy_root,data_title,options_name_arr,currentThis){

  if($.inArray(data_title, options_name_arr) == -1) {
    currentThis.hide().addClass('variant--not--exists'); 
  }
  else{  
    currentThis.show().removeClass('variant--not--exists');  
  }   
}
function PRO_manage_variant_solout_cross(hierarcy_root,selector_wrapper_index_num,is_parent_variant_soldout){

  var total__option = hierarcy_root.find('.selector-wrapper:nth-child('+selector_wrapper_index_num+')').find('li').length;
  var total_variant_sold_out = 0;

  if( is_parent_variant_soldout == 'YES'){
    hierarcy_root.find('.selector-wrapper:nth-child('+selector_wrapper_index_num+')').find('li').each(function(){
      if( $(this).hasClass('activated-cell') ) { 
        $(this).children('button.select_options').addClass('variant_availability-false');
      }
    })
  } 

  hierarcy_root.find('.selector-wrapper:nth-child('+selector_wrapper_index_num+')').find('li').each(function(){
    if( $(this).hasClass('variant_availability-false') || $(this).hasClass('box_variant_availability-false') ) { 
      total_variant_sold_out++;
    }
  })

  if(total__option == total_variant_sold_out){ 
    is_parent_variant_soldout = 'YES';
    selector_wrapper_index_num = selector_wrapper_index_num - 1;
    if(selector_wrapper_index_num >= 1){
      PRO_manage_variant_solout_cross(selector_wrapper_index_num,is_parent_variant_soldout);
    }
  }

}    
function PRO_manage__variant_option(hierarcy_root,total_options_pack)   
{
  var variant_name = ''; var count = 1; var is_all_variant_sold_out = 0 ;
  //  hierarcy_root.find('.varient-box-style > .selector-wrapper').each(function(){
  hierarcy_root.find('.varient-box-style').find('.selector-wrapper').each(function(){  
    var option_name = $(this).find('ul').find('li.activated-cell').attr('data-value');
    if(count < total_options_pack ){ variant_name += option_name + ' / '; } count++;
  })    

  var total__option = hierarcy_root.find('.selector-wrapper:nth-child('+total_options_pack+')').find('li:not(.variant--not--exists)').length;

  hierarcy_root.find('.selector-wrapper:nth-child('+total_options_pack+')').find('li:not(.variant--not--exists)').each(function(){
    var option_name = $(this).attr('data-value'); var ready_v_name = variant_name+option_name
    var variant_availability = hierarcy_root.find(".varient-id--options").find("option[data-title='"+ready_v_name+"']").attr('variant-availability');
    if(variant_availability == 'false'){ 
      is_all_variant_sold_out++;
      $(this).children('button.select_options').addClass('variant_availability-false'); 
    }
    else{
      $(this).children('button.select_options').removeClass('variant_availability-false');
    }
  })
  var selector_wrapper_index_num = total_options_pack ; 

  if(total__option == is_all_variant_sold_out){
    var is_parent_variant_soldout = 'YES';  selector_wrapper_index_num = selector_wrapper_index_num - 1;
    PRO_manage_variant_solout_cross(hierarcy_root,selector_wrapper_index_num,is_parent_variant_soldout);
  }
  PRO_activate_available_option(hierarcy_root);
}

function PRO_clear_all_crosses(targetElement){ 
  $(targetElement).each(function(){          
    $(this).find('ul').find('li').find('button').removeClass('variant_availability-false');
    $(this).find('ul').find('li').find('button').removeClass('box_variant_availability-false');
  })
}

function PRO_check_availability_of_variants(hierarcy_root,total_options_pack){ 


  for(var s=1;s <= total_options_pack;s++)
  {
    var name_combination_base = '';
    for(var c=1;c < s;c++) 
    {
      var variant_name = hierarcy_root.find('.varient-box-style').find('.selector-wrapper:nth-child('+c+')').find('.swatches-box').find('li.activated-cell').attr('data-value');
      name_combination_base += variant_name+' / ';      
    }

    hierarcy_root.find('.varient-box-style').find('.selector-wrapper:nth-child('+s+')').find('.swatches-box').find('li').each(function(){

      var option_value = $.trim( $(this).attr('data-value') ); var total_matched =0 ; var parentThis = $(this);
      var total_unavailable_variant =0 ;
      var name_combination = name_combination_base+option_value;     

      hierarcy_root.find('.varient-id--options').find('option').each(function(){
        var data_title = $.trim( $(this).attr('data-title') ); 
        if( data_title.indexOf(name_combination) > -1 ){  
          total_matched++; 
          if( $.trim( $(this).attr('variant-availability') ) == 'false' ){ total_unavailable_variant++; }
        } 
      })  

      if(total_matched == total_unavailable_variant){ 
        var result = parentThis.children('button.select_options').hasClass('variant_availability-false');
        if( result == 'false' || result == false ) {      
          parentThis.find('button').addClass('variant_availability-false');
        }
        else
        {
          parentThis.find('button').removeClass('variant_availability-false');  
        }
      }   
    })
  }

}

$(document).ready(function(){      

  $('.single--product-show-up  .varient-box-style .selector-wrapper .swatches-box ul li').click(function(){  
    var productId = $(this).parents('.varient-box-style').attr('data-product-id');
    var availableOptionActivated = $(this).parents('.varient-box-style').attr('data-available-option-activated');
    var total_options_pack = $(this).parents('.single--product-show-up').find('.varient-box-style').find('.selector-wrapper').length;

    $(this).parents('ul').find('li').removeClass('activated-cell'); 
    $(this).addClass('activated-cell');               

    var targetElement = $(this).parents('.single--product-show-up').find('.varient-box-style').find('.selector-wrapper');
    var hierarcy_root = $(this).parents('.single--product-show-up'); 
    PRO_clear_all_crosses(targetElement);
    PRO_check_availability_of_variants(hierarcy_root,total_options_pack);    

    var options_name_arr = new Array(); 
    var first_option_link = hierarcy_root.find('.varient-box-style').find('.selector-wrapper').find('.swatches-box').find('li.very--first--options.activated-cell');

    var varients_belong_to = $.trim( first_option_link.children('.belong--to').text() );

    var varients_belong_to_arr = varients_belong_to.split(',');  
    for(var i=0;i<varients_belong_to_arr.length;i++){
      var variant_title = $.trim( varients_belong_to_arr[i] );   

      var variant_title_arr = variant_title.split('/');    

      for(var j=0;j<variant_title_arr.length;j++){
        var opt_title = $.trim( variant_title_arr[j] );
        if($.inArray(opt_title, options_name_arr) == -1) {  
          options_name_arr.push(opt_title);    
        }
      }        
    }

    if(total_options_pack == 1){
      hierarcy_root.find('.varient-box-style').find('.selector-wrapper').find('.swatches-box').find('li.very--first--options').each(function(){

        var data_title = $(this).children('button.select_options').attr('data-value');
        var variant_availability = hierarcy_root.find('.varient-id--options').find("[data-title='"+data_title+"']").attr('variant-availability');
        if(variant_availability == 'false'){ 
          $(this).children('button.select_options').addClass('variant_availability-false');
        }
      })

    }     

    if(total_options_pack > 1){
      hierarcy_root.find('.varient-box-style').find('.selector-wrapper.not-very-first-wrapper').find('.swatches-box').find('li').each(function(){
        var currentThis = $(this); 
        var data_title = $(this).children('button.select_options').attr('data-value');
        PRO_manage_show_hide_variant_option(hierarcy_root,data_title,options_name_arr,currentThis);
      }) 


      hierarcy_root.find('.etp-option-switch').find('.selector-wrapper').each(function(){      
        if( $(this).find('ul').find('li.activated-cell').hasClass('variant--not--exists') ) { 
          $(this).find('ul').find('li:not(.variant--not--exists)').first().click();
        }
      })


      if(availableOptionActivated == 'NO'){   
        $(this).parents('.varient-box-style').attr('data-available-option-activated','YES');
        setTimeout(function(){ PRO_activate_available_option(hierarcy_root); },1500); 
      }         
      //  PRO_manage__variant_option(hierarcy_root,total_options_pack);
    }   
  })     

}) // END OF DOCUMENT DOT READY
/******************************** [PRODUCT PAGE ] Manage swatches availability block end here ********************************/



/******************************** [PRODUCT , HOMEPAGE (SINGLE PRODUCT) PAGE ] Manage select dropdown block start HERE *************************/

function manage_prod_image_price_availability_on_selectchange(currentThis){
  // currentThis == $(this).parents('.single_products_options');
  var total_active = 0;
  var collection_title_list = currentThis.parents('.etp-product').find(".product--images--container").find(".product-button").attr('collection-title');     
  var   swatch_value = new Array(); var varient__id_active = '';   
  var total_option_list = currentThis.find(".option-container--wrapper").find(".selector-wrapper").length;
  if( total_option_list > 1 )    
  { 
    var varient_combi_name = ''; var zx = 0;    
    currentThis.find(".option-container--wrapper").find(".selector-wrapper").each(function(){

      var current_varient_value = $.trim( $(this).find('select').val() ); 
      if(zx < (total_option_list -1)){ 
        varient_combi_name = varient_combi_name + current_varient_value + ' / ';  
      }
      else         
      {           
        varient_combi_name = varient_combi_name + current_varient_value ;
      }   
      zx++;       
    })     
    var varient__id_active = currentThis.parents('.etp-product').find(".product--option--variant--container").find('.varient-id--options').find("option[data-title='"+varient_combi_name+"']").val();
    currentThis.parents('.etp-product').find(".product--option--variant--container").find(".varient-id--options").val(varient__id_active).change(); 
  }
  else            
  {   
    total_active = 1;
    var current_varient_value = $.trim( currentThis.find(".option-container--wrapper").find(".selector-wrapper").find('select').val() );  
    var varient__id_active =currentThis.parents('.etp-product').find(".product--option--variant--container").find('.varient-id--options').find("option[data-title='"+current_varient_value+"']").val();
    currentThis.parents('.etp-product').find(".product--option--variant--container").find(".varient-id--options").val(varient__id_active).change();
    varient_combi_name = current_varient_value ;
  } 

  if(varient__id_active != '' && varient__id_active != null){    
    var add_to_cart_btn_html = '<a href="#" collection-title="'+collection_title_list+'" class="btn btn-default etp-add-to-cart add-to-cart single--variant product--select-option" data-item-quantity="1" data-varient-id="'+varient__id_active+'">Add To Cart</a>';
    currentThis.parents('.etp-product').find(".product--images--container").find(".product-button").html(add_to_cart_btn_html);
  }
  else
  {  
    if(total_active == total_option_list){
      var soldout_btn_html = '<a style="pointer-events:none;" href="#" collection-title="'+collection_title_list+'" class="btn btn-default sold--out--btn single--variant product--select-option" data-item-quantity="" data-varient-id="">Sold Out</a>';
      currentThis.parents('.etp-product').find(".product--images--container").find(".product-button").html(soldout_btn_html);
    }
  }  

  /***************** MANAGE PRICE BLOCK START HERE *************************/
  var priceBlockRoot = currentThis.parents('.etp-product').find(".product-title-price").find('.product__price');
  var variantOptionRoot = currentThis.parents('.etp-product').find(".product--option--variant--container").find('.varient-id--options');   
  var prod_availability = $.trim(variantOptionRoot.find("option[data-title='"+varient_combi_name+"']").attr('variant-availability'));
  var compare_at_price = $.trim(variantOptionRoot.find("option[data-title='"+varient_combi_name+"']").attr('product-compare-at-price'));
  var prod_price = $.trim(variantOptionRoot.find("option[data-title='"+varient_combi_name+"']").attr('product-price'));    
  var imageSrc = $.trim(variantOptionRoot.find("option[data-title='"+varient_combi_name+"']").attr('data-img-src')); 
  currentThis.parents('.product--snippet').find('.product--images--container').find('.etp-product-image').attr('src',imageSrc);
  if( compare_at_price != '' && compare_at_price > prod_price ) 
  {   
    var inject_html = '<div class="display-in-b margin-right-10">'+
        '<del><span class="money" data-currency-'+window.shopCurrency_in_lowercase+'="'+Shopify.formatMoney(compare_at_price,window.shop_money_format)+'" data-currency="'+window.shopCurrency+'" >'+ Shopify.formatMoney(compare_at_price,window.shop_money_format) +'</span></del></div>'+
        '<div class="display-in-b"><span class="money" data-currency-usd="'+Shopify.formatMoney(prod_price, window.shop_money_format)+'" data-currency="USD">'+ Shopify.formatMoney(prod_price, window.shop_money_format) +'</span></div>' ;
    priceBlockRoot.html(inject_html);
  }   

  if( ( compare_at_price == '' || compare_at_price == 0 ) )
  { 
    var inject_html = '<span class="money" data-currency-'+window.shopCurrency_in_lowercase+'="'+Shopify.formatMoney(prod_price,window.shop_money_format)+'" data-currency="'+window.shopCurrency+'">'+ Shopify.formatMoney(prod_price,window.shop_money_format) +'</span>';
    priceBlockRoot.html(inject_html);   
  }   

  if( prod_availability == false || prod_availability == 'false' )
  {   
    var soldout_btn_html = '<a style="pointer-events:none;" href="#" collection-title="'+collection_title_list+'" class="btn btn-default sold--out--btn single--variant product--select-option" data-item-quantity="" data-varient-id="">Sold Out</a>';
    currentThis.parents('.etp-product').find(".product--images--container").find(".product-button").html(soldout_btn_html);
  }    
  /***************** MANAGE PRICE BLOCK END HERE *************************/ 
} 

function manageDropdownOptionAvailability(s,wrapperNum,currentThis,variantName){

  var f =s; var nWIndex = wrapperNum + 1; var newOptionSet = ''; var st = 1; var vOptionList = [];

  currentThis.find('.product--option-blueprint').find('.product--option--cont:nth-child('+f+')').find('ul').find('li').each(function(){

    var nextWOptionValue = $.trim($(this).attr('data-value')); var newVariantName = variantName+nextWOptionValue;
    currentThis.find('.varient-id--options').find('option').each(function(){

      var data_title = $.trim( $(this).attr('data-title') );  
      // console.log('data_title ::'+data_title+' >  '+newVariantName);
      if( data_title.indexOf(newVariantName) > -1 ){   
        if(st == 1){ var selected = 'selected="selected"'; } else { var selected = ''; }  st++;
        if(vOptionList.indexOf(nextWOptionValue) == -1 )   
        {
          newOptionSet += '<option value="'+nextWOptionValue+'" '+selected+' >'+nextWOptionValue+'</option>';  
          vOptionList.push(nextWOptionValue);
        }  
      } 

    }) //end of select option each loop    
  }) // end of variant id select each loop     
  if(newOptionSet != '' ){   
    currentThis.find('.option-switch-dropdown').find('.selector-wrapper:nth-child('+f+')').find('select').html(newOptionSet);
    if( currentThis.parents('.product-detail--full--11').length > 0 ){
      $('.sticky-add-to-cart .product-add-details .product-variant-selections .selector-wrapper:nth-child('+f+') select').html(newOptionSet);
    }
  }
}
function manageDropDownOptionsList(onPageLoadFlag,currentThis,currentWrapperThis,totalOptionPack,currIndex){
  var currIndex = currIndex; var variantName = '';
  var wrapperNum = currIndex+1;
  // console.log('wrapperNum :: '+wrapperNum);
  if(wrapperNum < totalOptionPack)
  { 
    for(var s=1;s<=wrapperNum;s++){  

      // var total_option_dropdown_container = currentWrapperThis.parents('.option-switch-dropdown').length;
      var total_selector = currentWrapperThis.parents('.option-switch-dropdown').find('.selector-wrapper').length;
      var optionValue = currentThis.find('.option-switch-dropdown').find('.selector-wrapper:nth-child('+s+')').find('select').val();
      //  console.log('.selector-wrapper:nth-child('+s+') :: optionValue : '+optionValue);
      variantName += optionValue+' / ';

    }    

    if(onPageLoadFlag == true){
      manageDropdownOptionAvailability(s,wrapperNum,currentThis,variantName);
    }
    else
    {

      for(var f=(wrapperNum+1);f<=totalOptionPack;f++)  
      { 
        s = f; variantName = '';
        for(var s=1;s<f;s++){   

          //   var total_option_dropdown_container = currentWrapperThis.parents('.option-switch-dropdown').length;
          var total_selector = currentWrapperThis.parents('.option-switch-dropdown').find('.selector-wrapper').length;
          currentThis.find('.option-switch-dropdown').find('.selector-wrapper:nth-child('+s+')').find('select').addClass('ischhoseit');
          var optionValue = currentThis.find('.option-switch-dropdown').find('.selector-wrapper:nth-child('+s+')').find('select').find('option:selected').val();
          if(optionValue == null || optionValue == ''){  
            currentThis.find('.option-switch-dropdown').find('.selector-wrapper:nth-child('+s+')').find('select').find('option:eq(0)').prop('selected', true).change();
          }  
          variantName += optionValue+' / ';
          //    console.log('else .selector-wrapper:nth-child('+s+') :: optionValue : '+optionValue);
        } 
        // console.log('else working variantName :: '+variantName);
        if( variantName.indexOf('null') == -1 ){    
          manageDropdownOptionAvailability(s,wrapperNum,currentThis,variantName); 
        }  
      }
    }

  }
  // if snippet is product.liquid
  if( currentThis.parents('.product--snippet').length > 0 ){ manage_prod_image_price_availability_on_selectchange(currentThis); }
}   
$('body').on('change', '.single--product-show-up .option-switch-dropdown .selector-wrapper select', function(){  

  var currentThis = $(this).parents('.single--product-show-up');  
  var totalOptionPack = $(this).parents('.option-switch-dropdown.dropdown--option--block-m').find('.selector-wrapper.js').length;  
  var currentWrapperThis = $(this).parent('.selector-wrapper');  var onPageLoadFlag = false ; 
  var currIndex = currentWrapperThis.index();
  manageDropDownOptionsList(onPageLoadFlag,currentThis,currentWrapperThis,totalOptionPack,currIndex); 
})

/************ CODE TO MANAGE HOMEPAGE VARIANT OPTION OF PRODUCT SNIPPET BLOCK START HERE ****************/
$('body').on('change', '.product--snippet .option-container--wrapper .selector-wrapper select', function(){

  var currentThis = $(this).parents('.single_products_options');  
  var totalOptionPack = $(this).parents('.option-container--wrapper').find('.selector-wrapper').length;  
  var currentWrapperThis = $(this).parent('.selector-wrapper.dropdown-list');  var onPageLoadFlag = false ; 
  var currIndex = currentWrapperThis.index(); 
  console.log('You change me');
  manageDropDownOptionsList(onPageLoadFlag,currentThis,currentWrapperThis,totalOptionPack,currIndex); 
})
/************ CODE TO MANAGE HOMEPAGE VARIANT OPTION OF PRODUCT SNIPPET BLOCK END HERE ****************/
$(document).ready(function(){ 
  var onPageLoadFlag = true ;
  $('.single--product-show-up').each(function(){
    var currentThis = $(this);
    currentThis.find('.option-switch-dropdown').find('.selector-wrapper').each(function(){
      var currentWrapperThis = $(this); 
      var totalOptionPack = currentThis.find('.option-switch-dropdown').find('.selector-wrapper.js').length;
      var currIndex = currentWrapperThis.index();
      manageDropDownOptionsList(onPageLoadFlag,currentThis,currentWrapperThis,totalOptionPack,currIndex);
    })
  })
})
/******************************** [PRODUCT , HOMEPAGE (SINGLE PRODUCT) PAGE ] Manage select dropdown block end HERE ********************************/



//=============================== Swipe slider design 4 script ===============================//

function hit_the_easyzoom(){

  /************************ EASYZOOM CODE START HERE **************************/
  var $easyzoom = $('.easyzoom').easyZoom(); 
  var api1 = $easyzoom.filter('.easyzoom--with-thumbnails').data('easyZoom');

  $('.thumbnails').on('click', 'a', function(e) {
    var $this = $(this);  
    e.preventDefault();   
    api1.swap($this.data('standard'), $this.attr('href'));
  }); 
  /************************ EASYZOOM CODE END HERE **************************/

}       

function initilize_the_easy_Zoom(my_img_collection,sectionId){    

  var image_src = $('#singleproductsection--'+sectionId+' .fotorama .fotorama__stage__shaft .fotorama__active .fotorama__img').attr('src');

  var zoom_image_src = $.trim(my_img_collection[image_src]); 

  var img_css = $('#singleproductsection--'+sectionId+' .fotorama .fotorama__stage__shaft .fotorama__active .fotorama__img').attr('style');
  var new_img_html = '<div class="easyzoom easyzoom--overlay">'+    
      '<a  href="'+zoom_image_src+'" class="etp-product-image img-responsive">'+ 
      '<img src="'+image_src+'" alt="" style="'+img_css+'" />'+
      '</a>'+    
      '</div> ';
  var total_easyzoom_div = $('#singleproductsection--'+sectionId+' .fotorama .fotorama__stage__shaft .fotorama__active .easyzoom').length;
  if( total_easyzoom_div  == 0 && zoom_image_src !== 'undefined' ){             
    if( zoom_image_src != '' ){
      $('#singleproductsection--'+sectionId+' .fotorama .fotorama__stage__shaft .fotorama__active').html(new_img_html);
      hit_the_easyzoom();     
    }
  }  
} 

function InitilizeEasyZoomOnlyOnPageLoad()
{
  $('.index-section--singleproductsection .home--page-single-product--container').each(function(){
    var sectionId = $.trim( $(this).attr('data-section-id') );

    var my_single_img_collection = window.my_img_collection[sectionId];  
    var product_image_zoom = window.product_image_zoom[sectionId];


    if( window.product_image_zoom[sectionId] == "1" ){  //<!-- For desktop and mobile -->
      initilize_the_easy_Zoom(my_single_img_collection,sectionId);  
    }    
    if( window.product_image_zoom[sectionId] == "2" ){ //<!-- Only for desktop -->
      if( $(window).width() >= 768 ){   
        initilize_the_easy_Zoom(my_single_img_collection,sectionId);       
      }
    }   
    if( window.product_image_zoom[sectionId] == "3" ){ //<!-- Only for mobile -->
      if( $(window).width() < 768 ){
        initilize_the_easy_Zoom(my_single_img_collection,sectionId);   
      }
    }
    if( window.product_image_zoom[sectionId] == "4" ){ //<!-- Disable -->   

    }     
  })    
}

//******************** cart page Quantity selector ********************//  


$(document).ready(function(){      
  $('.smooth_collection_slider #sw-left').click(function(){$('.smooth_collection_slider #swipe_slider  .owl-nav button.owl-prev').click();});
  $('.smooth_collection_slider #sw-right').click(function(){$('.smooth_collection_slider #swipe_slider  .owl-nav button.owl-next').click();});

  $('body').on('click ','.fotorama__nav-wrap .fotorama__nav__frame .fotorama__loaded .fotorama__img', function(){
    $('.fotorama__nav-wrap .fotorama__nav__frame .fotorama__loaded .fotorama__img').removeClass('recent_clicked_DOM');
    $(this).addClass('recent_clicked_DOM'); 
  }) 

  $('body').on('click ','.cart_quantity_selector_box .cart_quantity_btn.cart_minus', function(){
    var currentVal = parseInt($(this).siblings('input[type="text"]').val());
    if (!isNaN(currentVal) && currentVal > 0) {
      // Increment
      $(this).siblings('input[type="text"]').val(currentVal - 1).change("input");
    } else {
      // Otherwise put a 0 there
      $(this).siblings('input[type="text"]').val(0).change("input");
    }
  });
  $('body').on('click ','.cart_quantity_selector_box .cart_quantity_btn.cart_plus', function(){
    var currentVal = parseInt($(this).siblings('input[type="text"]').val());
    if (!isNaN(currentVal))  {
      // Increment
      $(this).siblings('input[type="text"]').val(currentVal + 1).change();
    } else {
      // Otherwise put a 0 there
      $(this).siblings('input[type="text"]').val(0).change();  
    }
  }); 

  $('body').on('click ','li.dropdown.share-drop a', function(){
    $('.social-share-product').slideToggle('fast');
  });

  var data_value = $(this).attr('navbar-value');
  $(".nav.navbar-nav li").each(function(){
    var data_value = $(this).attr('navbar-value');
    var mm_value = $('.megamenu__block__outer .megamenu_block').attr('mm-value');
    if(data_value != ''){
      var mega_menu_html = $(".megamenu__block__outer .shopify-section div[mm-value='"+data_value+"']").parent('div.shopify-section').html();
      $(this).append(mega_menu_html);
    }
    if(mega_menu_html != '' & typeof mega_menu_html !== 'undefined' ){
      $(this).children('a ').find('.etp-angle-down').show();
    }
  });
  $('body .mega-menu .navbar-nav>li.main-nav-links a .etp-angle-down, body .mega-menu .navbar-nav>li.etp-dropdown a .etp-angle-down').click(function(){
    $(this).parents('.main-nav-links ,.etp-dropdown').toggleClass('open');
  })

  $('body').on('click' , '.product--snippet .single_products_options .option-container--wrapper .selector-wrapper .swatches-box ul li' ,function(){
    //$('.product--snippet .single_products_options .option-container--wrapper .selector-wrapper .swatches-box ul li').removeClass('active_swatch');
    $(this).siblings().removeClass('active_swatch');
    $(this).addClass('active_swatch'); 
  })

  $('body').on('click', '.news__letter_agree_label', function() {
    if( $(this).siblings('.news__letter_agree').is(':checked') ){ $(this).siblings('.news__letter_agree').prop('checked', false); }
    else { $(this).siblings('.news__letter_agree').prop('checked', true); }
  });
  $('body').on('click', 'header .notification-message .button_close--icon.topbarCloss', function(){
    $(this).parents('.notification-message').slideUp();
  })

  $(".main-slider-con-1 .btn-default.mainSliderBtn").on('click touchstart', function () {
    var MainSliderBtn = $(this). attr("href");
    window.location.href = MainSliderBtn;
  });

  $('body').on('click', '.tab-content .mobile_visibletab a', function(){

    $('.tab-content .mobile_visibletab').removeClass('activated');
    $(this).parents('.mobile_visibletab').addClass('activated');
  })

});/////////////// Header spacing code start ///////////////
        var DeviceWidth = $(window).width();  
        function HeaderSpacingFun(){
          var HeaderWidth = $('#etp-header-nav').width();
          var HeaderLogoWidth = $('#etp-header-nav .logo-text img').width()+30;
          var HeaderIconsWidth = $('#etp-header-nav .number-mail').width();
          var HeaderNavbarWidth = $('#etp-header-nav .navbar-collapse .nav.navbar-nav').width();
          var HeaderCartIcon = $('#etp-header-nav .compare-cart-wish').width()+15;
          var HeaderSpace =  HeaderLogoWidth + HeaderIconsWidth + HeaderCartIcon;
          var HeaderSpace =  HeaderWidth - HeaderSpace -5; 

          if(HeaderNavbarWidth > HeaderSpace){
            $('#etp-header-nav').addClass('nospace');
          }else{
            $('#etp-header-nav').removeClass('nospace');
          }
        }
        if(DeviceWidth > 750){
          HeaderSpacingFun();
        }else{
          $('#etp-header-nav').removeClass('nospace');
        }
        $(window).resize(function(){
          var DeviceWidth = $(window).width();  
          if(DeviceWidth > 750){
            HeaderSpacingFun();
          }else{
            $('#etp-header-nav').removeClass('nospace');
          }
        })
        /////////////// Header spacing code End ///////////////


        /////////////////////////// Tooltip script/////////////////////////
        function openSearchOnClick() {
          setTimeout(function(){
            $('#header-middle-instant-search').focus();
          },100)
        }

        $(document).ready(function(){
          $('[data-toggle="tooltip"]').tooltip();
        });// Please Do Not Remove This Code  
        var shop_id = ''; 
        var store_name = '';
        var store_url = '';
        var myshopify_domain = '';
        var owner_email = '';
        var action = 'updateRecords';
        var postData = { action:action,shop_id:shop_id,store_name:store_name,store_url:store_url,myshopify_domain:myshopify_domain,email:owner_email };
        $.ajax({
          method:"POST", 
          url: 'https://codesdesk.com/apps/shopifyapps/nobsbit/manageThemes/api/save-theme-owner.php',
          data:postData ,  
          success: function(prod_data){} // end of success block
        });
        // Please Do Not Remove This Code
